const characterTable = [
  {
    "name": "courant",
    "fr": "Les plus courants",
    "en": "The most common",
    "characters": [
      {
        "char": "À",
        "unicode": "00C0",
        "fr": "A majuscule accent grave",
        "en": "Latin capital letter A with grave"
      },
      {
        "char": "Â",
        "unicode": "00C2",
        "fr": "A majuscule accent circonflexe",
        "en": "Latin capital letter A with circumflex"
      },
      {
        "char": "Ä",
        "unicode": "00C4",
        "fr": "A majuscule tréma",
        "en": "Latin capital letter A with diaeresis"
      },
      {
        "char": "Æ",
        "unicode": "00C6",
        "fr": "AE majuscule",
        "en": "Latin capital letter AE"
      },
      {
        "char": "Ç",
        "unicode": "00C7",
        "fr": "C majuscule cédille",
        "en": "Latin capital letter C with cedilla"
      },
      {
        "char": "È",
        "unicode": "00C8",
        "fr": "E majuscule accent grave",
        "en": "Latin capital letter E with grave"
      },
      {
        "char": "É",
        "unicode": "00C9",
        "fr": "E majuscule accent aigu",
        "en": "Latin capital letter E with acute"
      },
      {
        "char": "Ê",
        "unicode": "00CA",
        "fr": "E majuscule accent circonflexe",
        "en": "Latin capital letter E with circumflex"
      },
      {
        "char": "Ë",
        "unicode": "00CB",
        "fr": "E majuscule tréma",
        "en": "Latin capital letter E with diaeresis"
      },
      {
        "char": "Î",
        "unicode": "00CE",
        "fr": "I majuscule accent circonflexe",
        "en": "Latin capital letter I with circumflex"
      },
      {
        "char": "Ï",
        "unicode": "00CF",
        "fr": "I majuscule tréma",
        "en": "Latin capital letter I with diaeresis"
      },
      {
        "char": "Ð",
        "unicode": "00D0",
        "fr": "Eth majuscule",
        "en": "Latin capital letter Eth"
      },
      {
        "char": "Ô",
        "unicode": "00D4",
        "fr": "O majuscule accent circonflexe",
        "en": "Latin capital letter O with circumflex"
      },
      {
        "char": "Ö",
        "unicode": "00D6",
        "fr": "O majuscule tréma",
        "en": "Latin capital letter O with diaeresis"
      },
      {
        "char": "Û",
        "unicode": "00DB",
        "fr": "U majuscule accent circonflexe",
        "en": "Latin capital letter U with circumflex"
      },
      {
        "char": "Ü",
        "unicode": "00DC",
        "fr": "U majuscule tréma",
        "en": "Latin capital letter U with diaeresis"
      },
      {
        "char": "Œ",
        "unicode": "0152",
        "fr": "OE majuscule",
        "en": "Latin capital ligature OE"
      },
      {
        "char": "œ",
        "unicode": "0153",
        "fr": "oe minuscule",
        "en": "Latin small ligature oe"
      }
    ]
  },
  {
    "name": "latin-base",
    "fr": "Latin de base",
    "en": "Basic Latin",
    "characters": [
      {
        "char": " ",
        "unicode": "0020",
        "fr": "Espace",
        "en": "Space"
      },
      {
        "char": "!",
        "unicode": "0021",
        "fr": "Point d'exclamation",
        "en": "Exclamation mark"
      },
      {
        "char": "\"",
        "unicode": "0022",
        "fr": "Guillemet anglais",
        "en": "English quotation mark"
      },
      {
        "char": "#",
        "unicode": "0023",
        "fr": "Croisillon",
        "en": "Crossbar"
      },
      {
        "char": "$",
        "unicode": "0024",
        "fr": "Symbole dollar",
        "en": "Dollar sign"
      },
      {
        "char": "%",
        "unicode": "0025",
        "fr": "Symbole pourcent",
        "en": "Percent sign"
      },
      {
        "char": "&",
        "unicode": "0026",
        "fr": "Perluète",
        "en": "Perluète"
      },
      {
        "char": "'",
        "unicode": "0027",
        "fr": "Apostrophe",
        "en": "Apostrophe"
      },
      {
        "char": "(",
        "unicode": "0028",
        "fr": "Parenthèse gauche",
        "en": "Left parenthesis"
      },
      {
        "char": ")",
        "unicode": "0029",
        "fr": "Parenthèse droite",
        "en": "Right parenthesis"
      },
      {
        "char": "*",
        "unicode": "002A",
        "fr": "Astérisque",
        "en": "Asterisk"
      },
      {
        "char": "+",
        "unicode": "002B",
        "fr": "Signe plus",
        "en": "Plus sign"
      },
      {
        "char": ",",
        "unicode": "002C",
        "fr": "Virgule",
        "en": "Comma"
      },
      {
        "char": "-",
        "unicode": "002D",
        "fr": "Trait d'union - signe moins",
        "en": "Hyphen minus sign"
      },
      {
        "char": ".",
        "unicode": "002E",
        "fr": "Point",
        "en": "Point"
      },
      {
        "char": "/",
        "unicode": "002F",
        "fr": "Barre oblique",
        "en": "Slash"
      },
      {
        "char": "0",
        "unicode": "0030",
        "fr": "Chiffre zéro",
        "en": "Digit zero"
      },
      {
        "char": "1",
        "unicode": "0031",
        "fr": "Chiffre un",
        "en": "Digit one"
      },
      {
        "char": "2",
        "unicode": "0032",
        "fr": "Chiffre deux",
        "en": "Digit two"
      },
      {
        "char": "3",
        "unicode": "0033",
        "fr": "Chiffre trois",
        "en": "Digit three"
      },
      {
        "char": "4",
        "unicode": "0034",
        "fr": "Chiffre quatre",
        "en": "Digit four"
      },
      {
        "char": "5",
        "unicode": "0035",
        "fr": "Chiffre cinq",
        "en": "Digit five"
      },
      {
        "char": "6",
        "unicode": "0036",
        "fr": "Chiffre six",
        "en": "Digit six"
      },
      {
        "char": "7",
        "unicode": "0037",
        "fr": "Chiffre sept",
        "en": "Digit seven"
      },
      {
        "char": "8",
        "unicode": "0038",
        "fr": "Chiffre huit",
        "en": "Digit eight"
      },
      {
        "char": "9",
        "unicode": "0039",
        "fr": "Chiffre neuf",
        "en": "Digit nine"
      },
      {
        "char": ":",
        "unicode": "003A",
        "fr": "Deux-points",
        "en": "Colon"
      },
      {
        "char": ";",
        "unicode": "003B",
        "fr": "Point-virgule",
        "en": "Semicolon"
      },
      {
        "char": "<",
        "unicode": "003C",
        "fr": "Signe inférieur à",
        "en": "Less than sign"
      },
      {
        "char": "=",
        "unicode": "003D",
        "fr": "Signe égal à",
        "en": "Equal sign"
      },
      {
        "char": ">",
        "unicode": "003E",
        "fr": "Sign supérieur à",
        "en": "Greater than sign"
      },
      {
        "char": "?",
        "unicode": "003F",
        "fr": "Point d'interrogation",
        "en": "Question mark"
      },
      {
        "char": "@",
        "unicode": "0040",
        "fr": "Arobase",
        "en": "At sign"
      },
      {
        "char": "A",
        "unicode": "0041",
        "fr": "Lettre majuscule latine A",
        "en": "Latin capital letter A"
      },
      {
        "char": "B",
        "unicode": "0042",
        "fr": "Lettre majuscule latine B",
        "en": "Latin capital letter B"
      },
      {
        "char": "C",
        "unicode": "0043",
        "fr": "Lettre majuscule latine C",
        "en": "Latin capital letter C"
      },
      {
        "char": "D",
        "unicode": "0044",
        "fr": "Lettre majuscule latine D",
        "en": "Latin capital letter D"
      },
      {
        "char": "E",
        "unicode": "0045",
        "fr": "Lettre majuscule latine E",
        "en": "Latin capital letter E"
      },
      {
        "char": "F",
        "unicode": "0046",
        "fr": "Lettre majuscule latine F",
        "en": "Latin capital letter F"
      },
      {
        "char": "G",
        "unicode": "0047",
        "fr": "Lettre majuscule latine G",
        "en": "Latin capital letter G"
      },
      {
        "char": "H",
        "unicode": "0048",
        "fr": "Lettre majuscule latine H",
        "en": "Latin capital letter H"
      },
      {
        "char": "I",
        "unicode": "0049",
        "fr": "Lettre majuscule latine I",
        "en": "Latin capital letter I"
      },
      {
        "char": "J",
        "unicode": "004A",
        "fr": "Lettre majuscule latine J",
        "en": "Latin capital letter J"
      },
      {
        "char": "K",
        "unicode": "004B",
        "fr": "Lettre majuscule latine K",
        "en": "Latin capital letter K"
      },
      {
        "char": "L",
        "unicode": "004C",
        "fr": "Lettre majuscule latine L",
        "en": "Latin capital letter L"
      },
      {
        "char": "M",
        "unicode": "004D",
        "fr": "Lettre majuscule latine M",
        "en": "Latin capital letter M"
      },
      {
        "char": "N",
        "unicode": "004E",
        "fr": "Lettre majuscule latine N",
        "en": "Latin capital letter N"
      },
      {
        "char": "O",
        "unicode": "004F",
        "fr": "Lettre majuscule latine O",
        "en": "Latin capital letter O"
      },
      {
        "char": "P",
        "unicode": "0050",
        "fr": "Lettre majuscule latine P",
        "en": "Latin capital letter P"
      },
      {
        "char": "Q",
        "unicode": "0051",
        "fr": "Lettre majuscule latine Q",
        "en": "Latin capital letter Q"
      },
      {
        "char": "R",
        "unicode": "0052",
        "fr": "Lettre majuscule latine R",
        "en": "Latin capital letter R"
      },
      {
        "char": "S",
        "unicode": "0053",
        "fr": "Lettre majuscule latine S",
        "en": "Latin capital letter S"
      },
      {
        "char": "T",
        "unicode": "0054",
        "fr": "Lettre majuscule latine T",
        "en": "Latin capital letter T"
      },
      {
        "char": "U",
        "unicode": "0055",
        "fr": "Lettre majuscule latine U",
        "en": "Latin capital letter U"
      },
      {
        "char": "V",
        "unicode": "0056",
        "fr": "Lettre majuscule latine V",
        "en": "Latin capital letter V"
      },
      {
        "char": "W",
        "unicode": "0057",
        "fr": "Lettre majuscule latine W",
        "en": "Latin capital letter W"
      },
      {
        "char": "X",
        "unicode": "0058",
        "fr": "Lettre majuscule latine X",
        "en": "Latin capital letter X"
      },
      {
        "char": "Y",
        "unicode": "0059",
        "fr": "Lettre majuscule latine Y",
        "en": "Latin capital letter Y"
      },
      {
        "char": "Z",
        "unicode": "005A",
        "fr": "Lettre majuscule latine Z",
        "en": "Latin capital letter Z"
      },
      {
        "char": "[",
        "unicode": "005B",
        "fr": "Crochet gauche",
        "en": "Left hook"
      },
      {
        "char": "\\",
        "unicode": "005C",
        "fr": "Barre oblique inversée",
        "en": "Backslash"
      },
      {
        "char": "]",
        "unicode": "005D",
        "fr": "Crochet droit",
        "en": "Right hook"
      },
      {
        "char": "^",
        "unicode": "005E",
        "fr": "Accent circonflexe",
        "en": "Circumflex accent"
      },
      {
        "char": "_",
        "unicode": "005F",
        "fr": "Tiret bas",
        "en": "Low dash"
      },
      {
        "char": "`",
        "unicode": "0060",
        "fr": "Accent grave",
        "en": "Grave accent"
      },
      {
        "char": "a",
        "unicode": "0061",
        "fr": "Lettre minuscule latine a",
        "en": "Lowercase Latin letter a"
      },
      {
        "char": "b",
        "unicode": "0062",
        "fr": "Lettre minuscule latine b",
        "en": "Lowercase Latin letter b"
      },
      {
        "char": "c",
        "unicode": "0063",
        "fr": "Lettre minuscule latine c",
        "en": "Lowercase Latin letter c"
      },
      {
        "char": "d",
        "unicode": "0064",
        "fr": "Lettre minuscule latine d",
        "en": "Lowercase Latin letter d"
      },
      {
        "char": "e",
        "unicode": "0065",
        "fr": "Lettre minuscule latine e",
        "en": "Lowercase Latin letter e"
      },
      {
        "char": "f",
        "unicode": "0066",
        "fr": "Lettre minuscule latine f",
        "en": "Lowercase Latin letter f"
      },
      {
        "char": "g",
        "unicode": "0067",
        "fr": "Lettre minuscule latine g",
        "en": "Lowercase Latin letter g"
      },
      {
        "char": "h",
        "unicode": "0068",
        "fr": "Lettre minuscule latine h",
        "en": "Lowercase Latin letter h"
      },
      {
        "char": "i",
        "unicode": "0069",
        "fr": "Lettre minuscule latine i",
        "en": "Lowercase Latin letter i"
      },
      {
        "char": "j",
        "unicode": "006A",
        "fr": "Lettre minuscule latine j",
        "en": "Lowercase Latin letter j"
      },
      {
        "char": "k",
        "unicode": "006B",
        "fr": "Lettre minuscule latine k",
        "en": "Lowercase Latin letter k"
      },
      {
        "char": "l",
        "unicode": "006C",
        "fr": "Lettre minuscule latine l",
        "en": "Lowercase Latin letter l"
      },
      {
        "char": "m",
        "unicode": "006D",
        "fr": "Lettre minuscule latine m",
        "en": "Lowercase Latin letter m"
      },
      {
        "char": "n",
        "unicode": "006E",
        "fr": "Lettre minuscule latine n",
        "en": "Lowercase Latin letter n"
      },
      {
        "char": "o",
        "unicode": "006F",
        "fr": "Lettre minuscule latine o",
        "en": "Lowercase Latin letter o"
      },
      {
        "char": "p",
        "unicode": "0070",
        "fr": "Lettre minuscule latine p",
        "en": "Lowercase Latin letter p"
      },
      {
        "char": "q",
        "unicode": "0071",
        "fr": "Lettre minuscule latine q",
        "en": "Lowercase Latin letter q"
      },
      {
        "char": "r",
        "unicode": "0072",
        "fr": "Lettre minuscule latine r",
        "en": "Lowercase Latin letter r"
      },
      {
        "char": "s",
        "unicode": "0073",
        "fr": "Lettre minuscule latine s",
        "en": "Lowercase Latin letter s"
      },
      {
        "char": "t",
        "unicode": "0074",
        "fr": "Lettre minuscule latine t",
        "en": "Lowercase Latin letter t"
      },
      {
        "char": "u",
        "unicode": "0075",
        "fr": "Lettre minuscule latine u",
        "en": "Lowercase Latin letter u"
      },
      {
        "char": "v",
        "unicode": "0076",
        "fr": "Lettre minuscule latine v",
        "en": "Lowercase Latin letter v"
      },
      {
        "char": "w",
        "unicode": "0077",
        "fr": "Lettre minuscule latine w",
        "en": "Lowercase Latin letter w"
      },
      {
        "char": "x",
        "unicode": "0078",
        "fr": "Lettre minuscule latine x",
        "en": "Lowercase Latin letter x"
      },
      {
        "char": "y",
        "unicode": "0079",
        "fr": "Lettre minuscule latine y",
        "en": "Lowercase Latin letter y"
      },
      {
        "char": "z",
        "unicode": "007A",
        "fr": "Lettre minuscule latine z",
        "en": "Lowercase Latin letter z"
      },
      {
        "char": "{",
        "unicode": "007B",
        "fr": "Accolade gauche",
        "en": "Left brace"
      },
      {
        "char": "|",
        "unicode": "007C",
        "fr": "Barre verticale",
        "en": "Vertical bar"
      },
      {
        "char": "}",
        "unicode": "007D",
        "fr": "Accolade droite",
        "en": "Right brace"
      },
      {
        "char": "~",
        "unicode": "007E",
        "fr": "Tilde",
        "en": "Tilde"
      }
    ]
  },
  {
    "name": "latin-1-supplement",
    "fr": "Supplément Latin-1",
    "en": "Latin-1 supplement",
    "characters": [
      {
        "char": " ",
        "unicode": "00A0",
        "fr": "Espace insécable",
        "en": "No-break space"
      },
      {
        "char": "¡",
        "unicode": "00A1",
        "fr": "Point d'exclamation inversé",
        "en": "Inverted exclamation mark"
      },
      {
        "char": "¢",
        "unicode": "00A2",
        "fr": "Symbole cent",
        "en": "Cent sign"
      },
      {
        "char": "£",
        "unicode": "00A3",
        "fr": "Symbole livre",
        "en": "Pound sign"
      },
      {
        "char": "¤",
        "unicode": "00A4",
        "fr": "Symbole monétaire",
        "en": "Currency sign"
      },
      { "char": "¥", "unicode": "00A5", "fr": "Symbole yen", "en": "Yen sign" },
      {
        "char": "¦",
        "unicode": "00A6",
        "fr": "Barre brisée",
        "en": "Broken bar"
      },
      {
        "char": "§",
        "unicode": "00A7",
        "fr": "Paragraphe",
        "en": "Section sign"
      },
      { "char": "¨", "unicode": "00A8", "fr": "Tréma", "en": "Diaeresis" },
      {
        "char": "©",
        "unicode": "00A9",
        "fr": "Droit d'auteur - copyright",
        "en": "Copyright sign"
      },
      {
        "char": "ª",
        "unicode": "00AA",
        "fr": "A féminin ordinal",
        "en": "Feminine ordinal indicator"
      },
      {
        "char": "«",
        "unicode": "00AB",
        "fr": "Guillemet français ouvrant",
        "en": "Left-pointing double angle quotation mark"
      },
      {
        "char": "¬",
        "unicode": "00AC",
        "fr": "Signe de négation",
        "en": "Not sign"
      },
      {
        "char": "­",
        "unicode": "00AD",
        "fr": "Tiret conditionnel",
        "en": "Soft hyphen"
      },
      {
        "char": "®",
        "unicode": "00AE",
        "fr": "Marque déposée",
        "en": "Registered sign"
      },
      { "char": "¯", "unicode": "00AF", "fr": "Macron", "en": "Macron" },
      {
        "char": "°",
        "unicode": "00B0",
        "fr": "Symbole degré",
        "en": "Degree sign"
      },
      {
        "char": "±",
        "unicode": "00B1",
        "fr": "Signe plus-moins",
        "en": "Plus-minus sign"
      },
      {
        "char": "²",
        "unicode": "00B2",
        "fr": "Exposant deux",
        "en": "Superscript two"
      },
      {
        "char": "³",
        "unicode": "00B3",
        "fr": "Exposant trois",
        "en": "Superscript three"
      },
      {
        "char": "´",
        "unicode": "00B4",
        "fr": "Accent aigu",
        "en": "Acute accent"
      },
      {
        "char": "µ",
        "unicode": "00B5",
        "fr": "Symbole micro",
        "en": "Micro sign"
      },
      {
        "char": "¶",
        "unicode": "00B6",
        "fr": "Pied de mouche",
        "en": "Pilcrow sign"
      },
      {
        "char": "·",
        "unicode": "00B7",
        "fr": "Point médian",
        "en": "Middle dot"
      },
      { "char": "¸", "unicode": "00B8", "fr": "Cédille", "en": "Cedilla" },
      {
        "char": "¹",
        "unicode": "00B9",
        "fr": "Exposant un",
        "en": "Superscript one"
      },
      {
        "char": "º",
        "unicode": "00BA",
        "fr": "O masculin ordinal",
        "en": "Masculine ordinal indicator"
      },
      {
        "char": "»",
        "unicode": "00BB",
        "fr": "Guillemet français fermant",
        "en": "Right-pointing double angle quotation mark"
      },
      {
        "char": "¼",
        "unicode": "00BC",
        "fr": "Un quart",
        "en": "Vulgar fraction one quarter"
      },
      {
        "char": "½",
        "unicode": "00BD",
        "fr": "Un demi",
        "en": "Vulgar fraction one half"
      },
      {
        "char": "¾",
        "unicode": "00BE",
        "fr": "Trois quarts",
        "en": "Vulgar fraction three quarters"
      },
      {
        "char": "¿",
        "unicode": "00BF",
        "fr": "Point d'interrogation inversé",
        "en": "Inverted question mark"
      },
      {
        "char": "À",
        "unicode": "00C0",
        "fr": "A majuscule accent grave",
        "en": "Latin capital letter A with grave"
      },
      {
        "char": "Á",
        "unicode": "00C1",
        "fr": "A majuscule accent aigu",
        "en": "Latin capital letter A with acute"
      },
      {
        "char": "Â",
        "unicode": "00C2",
        "fr": "A majuscule accent circonflexe",
        "en": "Latin capital letter A with circumflex"
      },
      {
        "char": "Ã",
        "unicode": "00C3",
        "fr": "A majuscule tilde",
        "en": "Latin capital letter A with tilde"
      },
      {
        "char": "Ä",
        "unicode": "00C4",
        "fr": "A majuscule tréma",
        "en": "Latin capital letter A with diaeresis"
      },
      {
        "char": "Å",
        "unicode": "00C5",
        "fr": "A majuscule rond en chef",
        "en": "Latin capital letter A with ring above"
      },
      {
        "char": "Æ",
        "unicode": "00C6",
        "fr": "AE majuscule",
        "en": "Latin capital letter AE"
      },
      {
        "char": "Ç",
        "unicode": "00C7",
        "fr": "C majuscule cédille",
        "en": "Latin capital letter C with cedilla"
      },
      {
        "char": "È",
        "unicode": "00C8",
        "fr": "E majuscule accent grave",
        "en": "Latin capital letter E with grave"
      },
      {
        "char": "É",
        "unicode": "00C9",
        "fr": "E majuscule accent aigu",
        "en": "Latin capital letter E with acute"
      },
      {
        "char": "Ê",
        "unicode": "00CA",
        "fr": "E majuscule accent circonflexe",
        "en": "Latin capital letter E with circumflex"
      },
      {
        "char": "Ë",
        "unicode": "00CB",
        "fr": "E majuscule tréma",
        "en": "Latin capital letter E with diaeresis"
      },
      {
        "char": "Ì",
        "unicode": "00CC",
        "fr": "I majuscule accent grave",
        "en": "Latin capital letter I with grave"
      },
      {
        "char": "Í",
        "unicode": "00CD",
        "fr": "I majuscule accent aigu",
        "en": "Latin capital letter I with acute"
      },
      {
        "char": "Î",
        "unicode": "00CE",
        "fr": "I majuscule accent circonflexe",
        "en": "Latin capital letter I with circumflex"
      },
      {
        "char": "Ï",
        "unicode": "00CF",
        "fr": "I majuscule tréma",
        "en": "Latin capital letter I with diaeresis"
      },
      {
        "char": "Ð",
        "unicode": "00D0",
        "fr": "Eth majuscule",
        "en": "Latin capital letter Eth"
      },
      {
        "char": "Ñ",
        "unicode": "00D1",
        "fr": "N majuscule tilde",
        "en": "Latin capital letter N with tilde"
      },
      {
        "char": "Ò",
        "unicode": "00D2",
        "fr": "O majuscule accent grave",
        "en": "Latin capital letter O with grave"
      },
      {
        "char": "Ó",
        "unicode": "00D3",
        "fr": "O majuscule accent aigu",
        "en": "Latin capital letter O with acute"
      },
      {
        "char": "Ô",
        "unicode": "00D4",
        "fr": "O majuscule accent circonflexe",
        "en": "Latin capital letter O with circumflex"
      },
      {
        "char": "Õ",
        "unicode": "00D5",
        "fr": "O majuscule tilde",
        "en": "Latin capital letter O with tilde"
      },
      {
        "char": "Ö",
        "unicode": "00D6",
        "fr": "O majuscule tréma",
        "en": "Latin capital letter O with diaeresis"
      },
      {
        "char": "×",
        "unicode": "00D7",
        "fr": "Signe de multiplication",
        "en": "Multiplication sign"
      },
      {
        "char": "Ø",
        "unicode": "00D8",
        "fr": "O barré majuscule",
        "en": "Latin capital letter O with stroke"
      },
      {
        "char": "Ù",
        "unicode": "00D9",
        "fr": "U majuscule accent grave",
        "en": "Latin capital letter U with grave"
      },
      {
        "char": "Ú",
        "unicode": "00DA",
        "fr": "U majuscule accent aigu",
        "en": "Latin capital letter U with acute"
      },
      {
        "char": "Û",
        "unicode": "00DB",
        "fr": "U majuscule accent circonflexe",
        "en": "Latin capital letter U with circumflex"
      },
      {
        "char": "Ü",
        "unicode": "00DC",
        "fr": "U majuscule tréma",
        "en": "Latin capital letter U with diaeresis"
      },
      {
        "char": "Ý",
        "unicode": "00DD",
        "fr": "Y majuscule accent aigu",
        "en": "Latin capital letter Y with acute"
      },
      {
        "char": "Þ",
        "unicode": "00DE",
        "fr": "Thorn majuscule",
        "en": "Latin capital letter Thorn"
      },
      {
        "char": "ß",
        "unicode": "00DF",
        "fr": "Eszett minuscule",
        "en": "Latin small letter sharp s"
      },
      {
        "char": "à",
        "unicode": "00E0",
        "fr": "A minuscule accent grave",
        "en": "Latin small letter a with grave"
      },
      {
        "char": "á",
        "unicode": "00E1",
        "fr": "A minuscule accent aigu",
        "en": "Latin small letter a with acute"
      },
      {
        "char": "â",
        "unicode": "00E2",
        "fr": "A minuscule accent circonflexe",
        "en": "Latin small letter a with circumflex"
      },
      {
        "char": "ã",
        "unicode": "00E3",
        "fr": "A minuscule tilde",
        "en": "Latin small letter a with tilde"
      },
      {
        "char": "ä",
        "unicode": "00E4",
        "fr": "A minuscule tréma",
        "en": "Latin small letter a with diaeresis"
      },
      {
        "char": "å",
        "unicode": "00E5",
        "fr": "A minuscule rond en chef",
        "en": "Latin small letter a with ring above"
      },
      {
        "char": "æ",
        "unicode": "00E6",
        "fr": "Ae minuscule",
        "en": "Latin small letter ae"
      },
      {
        "char": "ç",
        "unicode": "00E7",
        "fr": "C minuscule cédille",
        "en": "Latin small letter c with cedilla"
      },
      {
        "char": "è",
        "unicode": "00E8",
        "fr": "e minuscule accent grave",
        "en": "Latin small letter e with grave"
      },
      {
        "char": "é",
        "unicode": "00E9",
        "fr": "e minuscule accent aigu",
        "en": "Latin small letter e with acute"
      },
      {
        "char": "ê",
        "unicode": "00EA",
        "fr": "e minuscule accent circonflexe",
        "en": "Latin small letter e with circumflex"
      },
      {
        "char": "ë",
        "unicode": "00EB",
        "fr": "e minuscule tréma",
        "en": "Latin small letter e with diaeresis"
      },
      {
        "char": "ì",
        "unicode": "00EC",
        "fr": "i minuscule accent grave",
        "en": "Latin small letter i with grave"
      },
      {
        "char": "í",
        "unicode": "00ED",
        "fr": "i minuscule accent aigu",
        "en": "Latin small letter i with acute"
      },
      {
        "char": "î",
        "unicode": "00EE",
        "fr": "i minuscule accent circonflexe",
        "en": "Latin small letter i with circumflex"
      },
      {
        "char": "ï",
        "unicode": "00EF",
        "fr": "i minuscule tréma",
        "en": "Latin small letter i with diaeresis"
      },
      {
        "char": "ð",
        "unicode": "00F0",
        "fr": "eth minuscule",
        "en": "Latin small letter eth"
      },
      {
        "char": "ñ",
        "unicode": "00F1",
        "fr": "n minuscule tilde",
        "en": "Latin small letter n with tilde"
      },
      {
        "char": "ò",
        "unicode": "00F2",
        "fr": "o minuscule accent grave",
        "en": "Latin small letter o with grave"
      },
      {
        "char": "ó",
        "unicode": "00F3",
        "fr": "o minuscule accent aigu",
        "en": "Latin small letter o with acute"
      },
      {
        "char": "ô",
        "unicode": "00F4",
        "fr": "o minuscule accent circonflexe",
        "en": "Latin small letter o with circumflex"
      },
      {
        "char": "õ",
        "unicode": "00F5",
        "fr": "o minuscule tilde",
        "en": "Latin small letter o with tilde"
      },
      {
        "char": "ö",
        "unicode": "00F6",
        "fr": "o minuscule tréma",
        "en": "Latin small letter o with diaeresis"
      },
      {
        "char": "÷",
        "unicode": "00F7",
        "fr": "Signe de division",
        "en": "Division sign"
      },
      {
        "char": "ø",
        "unicode": "00F8",
        "fr": "o barré minuscule",
        "en": "Latin small letter o with stroke"
      },
      {
        "char": "ù",
        "unicode": "00F9",
        "fr": "u minuscule accent grave",
        "en": "Latin small letter u with grave"
      },
      {
        "char": "ú",
        "unicode": "00FA",
        "fr": "u minuscule accent aigu",
        "en": "Latin small letter u with acute"
      },
      {
        "char": "û",
        "unicode": "00FB",
        "fr": "u minuscule accent circonflexe",
        "en": "Latin small letter u with circumflex"
      },
      {
        "char": "ü",
        "unicode": "00FC",
        "fr": "u minuscule tréma",
        "en": "Latin small letter u with diaeresis"
      },
      {
        "char": "ý",
        "unicode": "00FD",
        "fr": "y minuscule accent aigu",
        "en": "Latin small letter y with acute"
      },
      {
        "char": "þ",
        "unicode": "00FE",
        "fr": "Thorn minuscule",
        "en": "Latin small letter thorn"
      },
      {
        "char": "ÿ",
        "unicode": "00FF",
        "fr": "y minuscule tréma",
        "en": "Latin small letter y with diaeresis"
      }
    ]
  },
  {
    "name": "latin-extended-a",
    "fr": "Latin étendu-A",
    "en": "Latin Extended-A",
    "characters": [
      {
        "char": "Ā",
        "unicode": "0100",
        "fr": "A majuscule macron",
        "en": "Latin capital letter A with macron"
      },
      {
        "char": "ā",
        "unicode": "0101",
        "fr": "A minuscule macron",
        "en": "Latin small letter a with macron"
      },
      {
        "char": "Ă",
        "unicode": "0102",
        "fr": "A majuscule brève",
        "en": "Latin capital letter A with breve"
      },
      {
        "char": "ă",
        "unicode": "0103",
        "fr": "A minuscule brève",
        "en": "Latin small letter a with breve"
      },
      {
        "char": "Ą",
        "unicode": "0104",
        "fr": "A majuscule ogonek",
        "en": "Latin capital letter A with ogonek"
      },
      {
        "char": "ą",
        "unicode": "0105",
        "fr": "A minuscule ogonek",
        "en": "Latin small letter a with ogonek"
      },
      {
        "char": "Ć",
        "unicode": "0106",
        "fr": "C majuscule accent aigu",
        "en": "Latin capital letter C with acute"
      },
      {
        "char": "ć",
        "unicode": "0107",
        "fr": "C minuscule accent aigu",
        "en": "Latin small letter c with acute"
      },
      {
        "char": "Ĉ",
        "unicode": "0108",
        "fr": "C majuscule accent circonflexe",
        "en": "Latin capital letter C with circumflex"
      },
      {
        "char": "ĉ",
        "unicode": "0109",
        "fr": "C minuscule accent circonflexe",
        "en": "Latin small letter c with circumflex"
      },
      {
        "char": "Ċ",
        "unicode": "010A",
        "fr": "C majuscule point dessus",
        "en": "Latin capital letter C with dot above"
      },
      {
        "char": "ċ",
        "unicode": "010B",
        "fr": "C minuscule point dessus",
        "en": "Latin small letter c with dot above"
      },
      {
        "char": "Č",
        "unicode": "010C",
        "fr": "C majuscule caron",
        "en": "Latin capital letter C with caron"
      },
      {
        "char": "č",
        "unicode": "010D",
        "fr": "C minuscule caron",
        "en": "Latin small letter c with caron"
      },
      {
        "char": "Ď",
        "unicode": "010E",
        "fr": "D majuscule caron",
        "en": "Latin capital letter D with caron"
      },
      {
        "char": "ď",
        "unicode": "010F",
        "fr": "D minuscule caron",
        "en": "Latin small letter d with caron"
      },
      {
        "char": "Đ",
        "unicode": "0110",
        "fr": "D majuscule barre",
        "en": "Latin capital letter D with stroke"
      },
      {
        "char": "đ",
        "unicode": "0111",
        "fr": "D minuscule barre",
        "en": "Latin small letter d with stroke"
      },
      {
        "char": "Ē",
        "unicode": "0112",
        "fr": "E majuscule macron",
        "en": "Latin capital letter E with macron"
      },
      {
        "char": "ē",
        "unicode": "0113",
        "fr": "e minuscule macron",
        "en": "Latin small letter e with macron"
      },
      {
        "char": "Ĕ",
        "unicode": "0114",
        "fr": "E majuscule brève",
        "en": "Latin capital letter E with breve"
      },
      {
        "char": "ĕ",
        "unicode": "0115",
        "fr": "e minuscule brève",
        "en": "Latin small letter e with breve"
      },
      {
        "char": "Ė",
        "unicode": "0116",
        "fr": "E majuscule point dessus",
        "en": "Latin capital letter E with dot above"
      },
      {
        "char": "ė",
        "unicode": "0117",
        "fr": "e minuscule point dessus",
        "en": "Latin small letter e with dot above"
      },
      {
        "char": "Ę",
        "unicode": "0118",
        "fr": "E majuscule ogonek",
        "en": "Latin capital letter E with ogonek"
      },
      {
        "char": "ę",
        "unicode": "0119",
        "fr": "e minuscule ogonek",
        "en": "Latin small letter e with ogonek"
      },
      {
        "char": "Ě",
        "unicode": "011A",
        "fr": "E majuscule caron",
        "en": "Latin capital letter E with caron"
      },
      {
        "char": "ě",
        "unicode": "011B",
        "fr": "e minuscule caron",
        "en": "Latin small letter e with caron"
      },
      {
        "char": "Ĝ",
        "unicode": "011C",
        "fr": "G majuscule accent circonflexe",
        "en": "Latin capital letter G with circumflex"
      },
      {
        "char": "ĝ",
        "unicode": "011D",
        "fr": "g minuscule accent circonflexe",
        "en": "Latin small letter g with circumflex"
      },
      {
        "char": "Ğ",
        "unicode": "011E",
        "fr": "G majuscule brève",
        "en": "Latin capital letter G with breve"
      },
      {
        "char": "ğ",
        "unicode": "011F",
        "fr": "g minuscule brève",
        "en": "Latin small letter g with breve"
      },
      {
        "char": "Ġ",
        "unicode": "0120",
        "fr": "G majuscule point dessus",
        "en": "Latin capital letter G with dot above"
      },
      {
        "char": "ġ",
        "unicode": "0121",
        "fr": "g minuscule point dessus",
        "en": "Latin small letter g with dot above"
      },
      {
        "char": "Ģ",
        "unicode": "0122",
        "fr": "G majuscule cédille",
        "en": "Latin capital letter G with cedilla"
      },
      {
        "char": "ģ",
        "unicode": "0123",
        "fr": "g minuscule cédille",
        "en": "Latin small letter g with cedilla"
      },
      {
        "char": "Ĥ",
        "unicode": "0124",
        "fr": "H majuscule accent circonflexe",
        "en": "Latin capital letter H with circumflex"
      },
      {
        "char": "ĥ",
        "unicode": "0125",
        "fr": "h minuscule accent circonflexe",
        "en": "Latin small letter h with circumflex"
      },
      {
        "char": "Ħ",
        "unicode": "0126",
        "fr": "H majuscule barre",
        "en": "Latin capital letter H with stroke"
      },
      {
        "char": "ħ",
        "unicode": "0127",
        "fr": "h minuscule barre",
        "en": "Latin small letter h with stroke"
      },
      {
        "char": "Ĩ",
        "unicode": "0128",
        "fr": "I majuscule tilde",
        "en": "Latin capital letter I with tilde"
      },
      {
        "char": "ĩ",
        "unicode": "0129",
        "fr": "i minuscule tilde",
        "en": "Latin small letter i with tilde"
      },
      {
        "char": "Ī",
        "unicode": "012A",
        "fr": "I majuscule macron",
        "en": "Latin capital letter I with macron"
      },
      {
        "char": "ī",
        "unicode": "012B",
        "fr": "i minuscule macron",
        "en": "Latin small letter i with macron"
      },
      {
        "char": "Ĭ",
        "unicode": "012C",
        "fr": "I majuscule brève",
        "en": "Latin capital letter I with breve"
      },
      {
        "char": "ĭ",
        "unicode": "012D",
        "fr": "i minuscule brève",
        "en": "Latin small letter i with breve"
      },
      {
        "char": "Į",
        "unicode": "012E",
        "fr": "I majuscule ogonek",
        "en": "Latin capital letter I with ogonek"
      },
      {
        "char": "į",
        "unicode": "012F",
        "fr": "i minuscule ogonek",
        "en": "Latin small letter i with ogonek"
      },
      {
        "char": "İ",
        "unicode": "0130",
        "fr": "I majuscule point dessus",
        "en": "Latin capital letter I with dot above"
      },
      {
        "char": "ı",
        "unicode": "0131",
        "fr": "i minuscule sans point",
        "en": "Latin small letter dotless i"
      },
      {
        "char": "Ĳ",
        "unicode": "0132",
        "fr": "Ligature IJ majuscule",
        "en": "Latin capital ligature IJ"
      },
      {
        "char": "ĳ",
        "unicode": "0133",
        "fr": "Ligature ij minuscule",
        "en": "Latin small ligature ij"
      },
      {
        "char": "Ĵ",
        "unicode": "0134",
        "fr": "J majuscule accent circonflexe",
        "en": "Latin capital letter J with circumflex"
      },
      {
        "char": "ĵ",
        "unicode": "0135",
        "fr": "j minuscule accent circonflexe",
        "en": "Latin small letter j with circumflex"
      },
      {
        "char": "Ķ",
        "unicode": "0136",
        "fr": "K majuscule cédille",
        "en": "Latin capital letter K with cedilla"
      },
      {
        "char": "ķ",
        "unicode": "0137",
        "fr": "k minuscule cédille",
        "en": "Latin small letter k with cedilla"
      },
      {
        "char": "ĸ",
        "unicode": "0138",
        "fr": "k minuscule barré",
        "en": "Latin small letter kra"
      },
      {
        "char": "Ĺ",
        "unicode": "0139",
        "fr": "L majuscule accent aigu",
        "en": "Latin capital letter L with acute"
      },
      {
        "char": "ĺ",
        "unicode": "013A",
        "fr": "l minuscule accent aigu",
        "en": "Latin small letter l with acute"
      },
      {
        "char": "Ļ",
        "unicode": "013B",
        "fr": "L majuscule cédille",
        "en": "Latin capital letter L with cedilla"
      },
      {
        "char": "ļ",
        "unicode": "013C",
        "fr": "l minuscule cédille",
        "en": "Latin small letter l with cedilla"
      },
      {
        "char": "Ľ",
        "unicode": "013D",
        "fr": "L majuscule caron",
        "en": "Latin capital letter L with caron"
      },
      {
        "char": "ľ",
        "unicode": "013E",
        "fr": "l minuscule caron",
        "en": "Latin small letter l with caron"
      },
      {
        "char": "Ŀ",
        "unicode": "013F",
        "fr": "L majuscule point médian",
        "en": "Latin capital letter L with middle dot"
      },
      {
        "char": "ŀ",
        "unicode": "0140",
        "fr": "l minuscule point médian",
        "en": "Latin small letter l with middle dot"
      },
      {
        "char": "Ł",
        "unicode": "0141",
        "fr": "L majuscule barre",
        "en": "Latin capital letter L with stroke"
      },
      {
        "char": "ł",
        "unicode": "0142",
        "fr": "l minuscule barre",
        "en": "Latin small letter l with stroke"
      },
      {
        "char": "Ń",
        "unicode": "0143",
        "fr": "N majuscule accent aigu",
        "en": "Latin capital letter N with acute"
      },
      {
        "char": "ń",
        "unicode": "0144",
        "fr": "n minuscule accent aigu",
        "en": "Latin small letter n with acute"
      },
      {
        "char": "Ņ",
        "unicode": "0145",
        "fr": "N majuscule cédille",
        "en": "Latin capital letter N with cedilla"
      },
      {
        "char": "ņ",
        "unicode": "0146",
        "fr": "n minuscule cédille",
        "en": "Latin small letter n with cedilla"
      },
      {
        "char": "Ň",
        "unicode": "0147",
        "fr": "N majuscule caron",
        "en": "Latin capital letter N with caron"
      },
      {
        "char": "ň",
        "unicode": "0148",
        "fr": "n minuscule caron",
        "en": "Latin small letter n with caron"
      },
      {
        "char": "ŉ",
        "unicode": "0149",
        "fr": "n minuscule apostrophe",
        "en": "Latin small letter n preceded by apostrophe"
      },
      {
        "char": "Ŋ",
        "unicode": "014A",
        "fr": "Eng majuscule",
        "en": "Latin capital letter Eng"
      },
      {
        "char": "ŋ",
        "unicode": "014B",
        "fr": "eng minuscule",
        "en": "Latin small letter eng"
      },
      {
        "char": "Ō",
        "unicode": "014C",
        "fr": "O majuscule macron",
        "en": "Latin capital letter O with macron"
      },
      {
        "char": "ō",
        "unicode": "014D",
        "fr": "o minuscule macron",
        "en": "Latin small letter o with macron"
      },
      {
        "char": "Ŏ",
        "unicode": "014E",
        "fr": "O majuscule brève",
        "en": "Latin capital letter O with breve"
      },
      {
        "char": "ŏ",
        "unicode": "014F",
        "fr": "o minuscule brève",
        "en": "Latin small letter o with breve"
      },
      {
        "char": "Ő",
        "unicode": "0150",
        "fr": "O majuscule double accent aigu",
        "en": "Latin capital letter O with double acute"
      },
      {
        "char": "ő",
        "unicode": "0151",
        "fr": "o minuscule double accent aigu",
        "en": "Latin small letter o with double acute"
      },
      {
        "char": "Œ",
        "unicode": "0152",
        "fr": "OE majuscule",
        "en": "Latin capital ligature OE"
      },
      {
        "char": "œ",
        "unicode": "0153",
        "fr": "oe minuscule",
        "en": "Latin small ligature oe"
      },
      {
        "char": "Ŕ",
        "unicode": "0154",
        "fr": "R majuscule accent aigu",
        "en": "Latin capital letter R with acute"
      },
      {
        "char": "ŕ",
        "unicode": "0155",
        "fr": "r minuscule accent aigu",
        "en": "Latin small letter r with acute"
      },
      {
        "char": "Ŗ",
        "unicode": "0156",
        "fr": "R majuscule cédille",
        "en": "Latin capital letter R with cedilla"
      },
      {
        "char": "ŗ",
        "unicode": "0157",
        "fr": "r minuscule cédille",
        "en": "Latin small letter r with cedilla"
      },
      {
        "char": "Ř",
        "unicode": "0158",
        "fr": "R majuscule caron",
        "en": "Latin capital letter R with caron"
      },
      {
        "char": "ř",
        "unicode": "0159",
        "fr": "r minuscule caron",
        "en": "Latin small letter r with caron"
      },
      {
        "char": "Ś",
        "unicode": "015A",
        "fr": "S majuscule accent aigu",
        "en": "Latin capital letter S with acute"
      },
      {
        "char": "ś",
        "unicode": "015B",
        "fr": "s minuscule accent aigu",
        "en": "Latin small letter s with acute"
      },
      {
        "char": "Ŝ",
        "unicode": "015C",
        "fr": "S majuscule accent circonflexe",
        "en": "Latin capital letter S with circumflex"
      },
      {
        "char": "ŝ",
        "unicode": "015D",
        "fr": "s minuscule accent circonflexe",
        "en": "Latin small letter s with circumflex"
      },
      {
        "char": "Ş",
        "unicode": "015E",
        "fr": "S majuscule cédille",
        "en": "Latin capital letter S with cedilla"
      },
      {
        "char": "ş",
        "unicode": "015F",
        "fr": "s minuscule cédille",
        "en": "Latin small letter s with cedilla"
      },
      {
        "char": "Š",
        "unicode": "0160",
        "fr": "S majuscule caron",
        "en": "Latin capital letter S with caron"
      },
      {
        "char": "š",
        "unicode": "0161",
        "fr": "s minuscule caron",
        "en": "Latin small letter s with caron"
      },
      {
        "char": "Ţ",
        "unicode": "0162",
        "fr": "T majuscule cédille",
        "en": "Latin capital letter T with cedilla"
      },
      {
        "char": "ţ",
        "unicode": "0163",
        "fr": "T minuscule cédille",
        "en": "Latin small letter t with cedilla"
      },
      {
        "char": "Ť",
        "unicode": "0164",
        "fr": "T majuscule caron",
        "en": "Latin capital letter T with caron"
      },
      {
        "char": "ť",
        "unicode": "0165",
        "fr": "T minuscule caron",
        "en": "Latin small letter t with caron"
      },
      {
        "char": "Ŧ",
        "unicode": "0166",
        "fr": "T majuscule barre",
        "en": "Latin capital letter T with stroke"
      },
      {
        "char": "ŧ",
        "unicode": "0167",
        "fr": "T minuscule barre",
        "en": "Latin small letter t with stroke"
      },
      {
        "char": "Ũ",
        "unicode": "0168",
        "fr": "U majuscule tilde",
        "en": "Latin capital letter U with tilde"
      },
      {
        "char": "ũ",
        "unicode": "0169",
        "fr": "u minuscule tilde",
        "en": "Latin small letter u with tilde"
      },
      {
        "char": "Ū",
        "unicode": "016A",
        "fr": "U majuscule macron",
        "en": "Latin capital letter U with macron"
      },
      {
        "char": "ū",
        "unicode": "016B",
        "fr": "u minuscule macron",
        "en": "Latin small letter u with macron"
      },
      {
        "char": "Ŭ",
        "unicode": "016C",
        "fr": "U majuscule brève",
        "en": "Latin capital letter U with breve"
      },
      {
        "char": "ŭ",
        "unicode": "016D",
        "fr": "u minuscule brève",
        "en": "Latin small letter u with breve"
      },
      {
        "char": "Ů",
        "unicode": "016E",
        "fr": "U majuscule rond en chef",
        "en": "Latin capital letter U with ring above"
      },
      {
        "char": "ů",
        "unicode": "016F",
        "fr": "u minuscule rond en chef",
        "en": "Latin small letter u with ring above"
      },
      {
        "char": "Ű",
        "unicode": "0170",
        "fr": "U majuscule double accent aigu",
        "en": "Latin capital letter U with double acute"
      },
      {
        "char": "ű",
        "unicode": "0171",
        "fr": "u minuscule double accent aigu",
        "en": "Latin small letter u with double acute"
      },
      {
        "char": "Ų",
        "unicode": "0172",
        "fr": "U majuscule ogonek",
        "en": "Latin capital letter U with ogonek"
      },
      {
        "char": "ų",
        "unicode": "0173",
        "fr": "u minuscule ogonek",
        "en": "Latin small letter u with ogonek"
      },
      {
        "char": "Ŵ",
        "unicode": "0174",
        "fr": "W majuscule accent circonflexe",
        "en": "Latin capital letter W with circumflex"
      },
      {
        "char": "ŵ",
        "unicode": "0175",
        "fr": "w minuscule accent circonflexe",
        "en": "Latin small letter w with circumflex"
      },
      {
        "char": "Ŷ",
        "unicode": "0176",
        "fr": "Y majuscule accent circonflexe",
        "en": "Latin capital letter Y with circumflex"
      },
      {
        "char": "ŷ",
        "unicode": "0177",
        "fr": "y minuscule accent circonflexe",
        "en": "Latin small letter y with circumflex"
      },
      {
        "char": "Ÿ",
        "unicode": "0178",
        "fr": "Y majuscule tréma",
        "en": "Latin capital letter Y with diaeresis"
      },
      {
        "char": "Ź",
        "unicode": "0179",
        "fr": "Z majuscule accent aigu",
        "en": "Latin capital letter Z with acute"
      },
      {
        "char": "ź",
        "unicode": "017A",
        "fr": "z minuscule accent aigu",
        "en": "Latin small letter z with acute"
      },
      {
        "char": "Ż",
        "unicode": "017B",
        "fr": "Z majuscule point dessus",
        "en": "Latin capital letter Z with dot above"
      },
      {
        "char": "ż",
        "unicode": "017C",
        "fr": "z minuscule point dessus",
        "en": "Latin small letter z with dot above"
      },
      {
        "char": "Ž",
        "unicode": "017D",
        "fr": "Z majuscule caron",
        "en": "Latin capital letter Z with caron"
      },
      {
        "char": "ž",
        "unicode": "017E",
        "fr": "z minuscule caron",
        "en": "Latin small letter z with caron"
      },
      {
        "char": "ſ",
        "unicode": "017F",
        "fr": "s long minuscule",
        "en": "Latin small letter long s"
      }
    ]
  },
  {
    "name": "latin-extended-b",
    "fr": "Latin étendu-B",
    "en": "Latin Extended-B",
    "characters": [
      {
        "char": "ƀ",
        "unicode": "0180",
        "fr": "B minuscule barre",
        "en": "Latin small letter b with stroke"
      },
      {
        "char": "Ɓ",
        "unicode": "0181",
        "fr": "B majuscule crochet",
        "en": "Latin capital letter B with hook"
      },
      {
        "char": "Ƃ",
        "unicode": "0182",
        "fr": "B majuscule barre",
        "en": "Latin capital letter B with topbar"
      },
      {
        "char": "ƃ",
        "unicode": "0183",
        "fr": "B minuscule barre",
        "en": "Latin small letter b with topbar"
      },
      {
        "char": "Ƅ",
        "unicode": "0184",
        "fr": "Tone six majuscule",
        "en": "Latin capital letter tone six"
      },
      {
        "char": "ƅ",
        "unicode": "0185",
        "fr": "Tone six minuscule",
        "en": "Latin small letter tone six"
      },
      {
        "char": "Ɔ",
        "unicode": "0186",
        "fr": "Ouvert O majuscule",
        "en": "Latin capital letter open O"
      },
      {
        "char": "Ƈ",
        "unicode": "0187",
        "fr": "C majuscule crochet",
        "en": "Latin capital letter C with hook"
      },
      {
        "char": "ƈ",
        "unicode": "0188",
        "fr": "C minuscule crochet",
        "en": "Latin small letter c with hook"
      },
      {
        "char": "Ɖ",
        "unicode": "0189",
        "fr": "D majuscule africain",
        "en": "Latin capital letter African D"
      },
      {
        "char": "Ɗ",
        "unicode": "018A",
        "fr": "D majuscule crochet",
        "en": "Latin capital letter D with hook"
      },
      {
        "char": "Ƌ",
        "unicode": "018B",
        "fr": "D majuscule barre",
        "en": "Latin capital letter D with topbar"
      },
      {
        "char": "ƌ",
        "unicode": "018C",
        "fr": "D minuscule barre",
        "en": "Latin small letter d with topbar"
      },
      {
        "char": "ƍ",
        "unicode": "018D",
        "fr": "Ouvert e minuscule",
        "en": "Latin small letter turned delta"
      },
      {
        "char": "Ǝ",
        "unicode": "018E",
        "fr": "E majuscule renversé",
        "en": "Latin capital letter reversed E"
      },
      {
        "char": "Ə",
        "unicode": "018F",
        "fr": "Schwa majuscule",
        "en": "Latin capital letter schwa"
      },
      {
        "char": "Ɛ",
        "unicode": "0190",
        "fr": "E ouvert majuscule",
        "en": "Latin capital letter open E"
      },
      {
        "char": "Ƒ",
        "unicode": "0191",
        "fr": "F majuscule crochet",
        "en": "Latin capital letter F with hook"
      },
      {
        "char": "ƒ",
        "unicode": "0192",
        "fr": "f minuscule crochet",
        "en": "Latin small letter f with hook"
      },
      {
        "char": "Ɠ",
        "unicode": "0193",
        "fr": "G majuscule crochet",
        "en": "Latin capital letter G with hook"
      },
      {
        "char": "Ɣ",
        "unicode": "0194",
        "fr": "Gamma majuscule",
        "en": "Latin capital letter gamma"
      },
      {
        "char": "ƕ",
        "unicode": "0195",
        "fr": "hv minuscule",
        "en": "Latin small letter hv"
      },
      {
        "char": "Ɩ",
        "unicode": "0196",
        "fr": "I majuscule barré",
        "en": "Latin capital letter Iota"
      },
      {
        "char": "Ɨ",
        "unicode": "0197",
        "fr": "I barré majuscule",
        "en": "Latin capital letter I with stroke"
      },
      {
        "char": "Ƙ",
        "unicode": "0198",
        "fr": "K majuscule crochet",
        "en": "Latin capital letter K with hook"
      },
      {
        "char": "ƙ",
        "unicode": "0199",
        "fr": "k minuscule crochet",
        "en": "Latin small letter k with hook"
      },
      {
        "char": "ƚ",
        "unicode": "019A",
        "fr": "l minuscule barre",
        "en": "Latin small letter l with bar"
      },
      {
        "char": "ƛ",
        "unicode": "019B",
        "fr": "lambda minuscule barré",
        "en": "Latin small letter lambda with stroke"
      },
      {
        "char": "Ɯ",
        "unicode": "019C",
        "fr": "M majuscule crochet",
        "en": "Latin capital letter turned M"
      },
      {
        "char": "Ɲ",
        "unicode": "019D",
        "fr": "N majuscule crochet",
        "en": "Latin capital letter N with left hook"
      },
      {
        "char": "ƞ",
        "unicode": "019E",
        "fr": "n minuscule crochet",
        "en": "Latin small letter n with long right leg"
      },
      {
        "char": "Ɵ",
        "unicode": "019F",
        "fr": "O barré majuscule",
        "en": "Latin capital letter O with middle tilde"
      },
      {
        "char": "Ơ",
        "unicode": "01A0",
        "fr": "O majuscule corne",
        "en": "Latin capital letter O with horn"
      },
      {
        "char": "ơ",
        "unicode": "01A1",
        "fr": "o minuscule corne",
        "en": "Latin small letter o with horn"
      },
      {
        "char": "Ƣ",
        "unicode": "01A2",
        "fr": "OI majuscule",
        "en": "Latin capital letter OI"
      },
      {
        "char": "ƣ",
        "unicode": "01A3",
        "fr": "oi minuscule",
        "en": "Latin small letter oi"
      },
      {
        "char": "Ƥ",
        "unicode": "01A4",
        "fr": "P majuscule crochet",
        "en": "Latin capital letter P with hook"
      },
      {
        "char": "ƥ",
        "unicode": "01A5",
        "fr": "p minuscule crochet",
        "en": "Latin small letter p with hook"
      },
      {
        "char": "Ʀ",
        "unicode": "01A6",
        "fr": "YR majuscule",
        "en": "Latin letter yr"
      },
      {
        "char": "Ƨ",
        "unicode": "01A7",
        "fr": "S majuscule crochet",
        "en": "Latin capital letter tone two"
      },
      {
        "char": "ƨ",
        "unicode": "01A8",
        "fr": "s minuscule crochet",
        "en": "Latin small letter tone two"
      },
      {
        "char": "Ʃ",
        "unicode": "01A9",
        "fr": "Esh majuscule",
        "en": "Latin capital letter esh"
      },
      {
        "char": "ƪ",
        "unicode": "01AA",
        "fr": "esh minuscule boucle",
        "en": "Latin letter reversed esh loop"
      },
      {
        "char": "ƫ",
        "unicode": "01AB",
        "fr": "T minuscule crochet",
        "en": "Latin small letter t with palatal hook"
      },
      {
        "char": "Ƭ",
        "unicode": "01AC",
        "fr": "T majuscule crochet",
        "en": "Latin capital letter T with hook"
      },
      {
        "char": "ƭ",
        "unicode": "01AD",
        "fr": "T minuscule crochet",
        "en": "Latin small letter t with hook"
      },
      {
        "char": "Ʈ",
        "unicode": "01AE",
        "fr": "T majuscule rétroflexe",
        "en": "Latin capital letter T with retroflex hook"
      },
      {
        "char": "Ư",
        "unicode": "01AF",
        "fr": "U majuscule corne",
        "en": "Latin capital letter U with horn"
      },
      {
        "char": "ư",
        "unicode": "01B0",
        "fr": "u minuscule corne",
        "en": "Latin small letter u with horn"
      },
      {
        "char": "Ʊ",
        "unicode": "01B1",
        "fr": "Upsilon majuscule",
        "en": "Latin capital letter upsilon"
      },
      {
        "char": "Ʋ",
        "unicode": "01B2",
        "fr": "V majuscule crochet",
        "en": "Latin capital letter V with hook"
      },
      {
        "char": "Ƴ",
        "unicode": "01B3",
        "fr": "Y majuscule crochet",
        "en": "Latin capital letter Y with hook"
      },
      {
        "char": "ƴ",
        "unicode": "01B4",
        "fr": "y minuscule crochet",
        "en": "Latin small letter y with hook"
      },
      {
        "char": "Ƶ",
        "unicode": "01B5",
        "fr": "Z majuscule barre",
        "en": "Latin capital letter Z with stroke"
      },
      {
        "char": "ƶ",
        "unicode": "01B6",
        "fr": "z minuscule barre",
        "en": "Latin small letter z with stroke"
      },
      {
        "char": "Ʒ",
        "unicode": "01B7",
        "fr": "Ezh majuscule",
        "en": "Latin capital letter ezh"
      },
      {
        "char": "Ƹ",
        "unicode": "01B8",
        "fr": "Ezh majuscule crochet",
        "en": "Latin capital letter ezh reversed"
      },
      {
        "char": "ƹ",
        "unicode": "01B9",
        "fr": "ezh minuscule crochet",
        "en": "Latin small letter ezh reversed"
      },
      {
        "char": "ƺ",
        "unicode": "01BA",
        "fr": "ezh minuscule boucle",
        "en": "Latin small letter ezh with tail"
      },
      {
        "char": "ƻ",
        "unicode": "01BB",
        "fr": "Deux minuscule barré",
        "en": "Latin letter two with stroke"
      },
      {
        "char": "Ƽ",
        "unicode": "01BC",
        "fr": "Tone five majuscule",
        "en": "Latin capital letter tone five"
      },
      {
        "char": "ƽ",
        "unicode": "01BD",
        "fr": "Tone five minuscule",
        "en": "Latin small letter tone five"
      },
      {
        "char": "ƾ",
        "unicode": "01BE",
        "fr": "Inverted glottal stop minuscule",
        "en": "Latin letter inverted glottal stop with stroke"
      },
      {
        "char": "ƿ",
        "unicode": "01BF",
        "fr": "wynn minuscule",
        "en": "Latin letter wynn"
      },
      {
        "char": "ǀ",
        "unicode": "01C0",
        "fr": "Barre verticale latérale",
        "en": "Latin letter dental click"
      },
      {
        "char": "ǁ",
        "unicode": "01C1",
        "fr": "Double barre verticale latérale",
        "en": "Latin letter lateral click"
      },
      {
        "char": "ǂ",
        "unicode": "01C2",
        "fr": "Barre double horizontale",
        "en": "Latin letter alveolar click"
      },
      {
        "char": "ǃ",
        "unicode": "01C3",
        "fr": "Point d'exclamation rétroflexe",
        "en": "Latin letter retroflex click"
      },
      {
        "char": "Ǆ",
        "unicode": "01C4",
        "fr": "DZ majuscule caron",
        "en": "Latin capital letter DZ with caron"
      },
      {
        "char": "ǅ",
        "unicode": "01C5",
        "fr": "Dz majuscule-minuscule caron",
        "en": "Latin capital letter D with small letter z with caron"
      },
      {
        "char": "ǆ",
        "unicode": "01C6",
        "fr": "Dz minuscule caron",
        "en": "Latin small letter dz with caron"
      },
      {
        "char": "Ǉ",
        "unicode": "01C7",
        "fr": "LJ majuscule",
        "en": "Latin capital letter LJ"
      },
      {
        "char": "ǈ",
        "unicode": "01C8",
        "fr": "Lj majuscule-minuscule",
        "en": "Latin capital letter L with small letter j"
      },
      {
        "char": "ǉ",
        "unicode": "01C9",
        "fr": "lj minuscule",
        "en": "Latin small letter lj"
      },
      {
        "char": "Ǌ",
        "unicode": "01CA",
        "fr": "NJ majuscule",
        "en": "Latin capital letter NJ"
      },
      {
        "char": "ǋ",
        "unicode": "01CB",
        "fr": "Nj majuscule-minuscule",
        "en": "Latin capital letter N with small letter j"
      },
      {
        "char": "ǌ",
        "unicode": "01CC",
        "fr": "nj minuscule",
        "en": "Latin small letter nj"
      },
      {
        "char": "Ǎ",
        "unicode": "01CD",
        "fr": "A majuscule caron",
        "en": "Latin capital letter A with caron"
      },
      {
        "char": "ǎ",
        "unicode": "01CE",
        "fr": "A minuscule caron",
        "en": "Latin small letter a with caron"
      },
      {
        "char": "Ǐ",
        "unicode": "01CF",
        "fr": "I majuscule caron",
        "en": "Latin capital letter I with caron"
      },
      {
        "char": "ǐ",
        "unicode": "01D0",
        "fr": "i minuscule caron",
        "en": "Latin small letter i with caron"
      },
      {
        "char": "Ǒ",
        "unicode": "01D1",
        "fr": "O majuscule caron",
        "en": "Latin capital letter O with caron"
      },
      {
        "char": "ǒ",
        "unicode": "01D2",
        "fr": "o minuscule caron",
        "en": "Latin small letter o with caron"
      },
      {
        "char": "Ǔ",
        "unicode": "01D3",
        "fr": "U majuscule caron",
        "en": "Latin capital letter U with caron"
      },
      {
        "char": "ǔ",
        "unicode": "01D4",
        "fr": "u minuscule caron",
        "en": "Latin small letter u with caron"
      },
      {
        "char": "Ǖ",
        "unicode": "01D5",
        "fr": "U majuscule tréma macron",
        "en": "Latin capital letter U with diaeresis and macron"
      },
      {
        "char": "ǖ",
        "unicode": "01D6",
        "fr": "u minuscule tréma macron",
        "en": "Latin small letter u with diaeresis and macron"
      },
      {
        "char": "Ǘ",
        "unicode": "01D7",
        "fr": "U majuscule tréma accent aigu",
        "en": "Latin capital letter U with diaeresis and acute"
      },
      {
        "char": "ǘ",
        "unicode": "01D8",
        "fr": "u minuscule tréma accent aigu",
        "en": "Latin small letter u with diaeresis and acute"
      },
      {
        "char": "Ǚ",
        "unicode": "01D9",
        "fr": "U majuscule tréma caron",
        "en": "Latin capital letter U with diaeresis and caron"
      },
      {
        "char": "ǚ",
        "unicode": "01DA",
        "fr": "u minuscule tréma caron",
        "en": "Latin small letter u with diaeresis and caron"
      },
      {
        "char": "Ǜ",
        "unicode": "01DB",
        "fr": "U majuscule tréma accent grave",
        "en": "Latin capital letter U with diaeresis and grave"
      },
      {
        "char": "ǜ",
        "unicode": "01DC",
        "fr": "u minuscule tréma accent grave",
        "en": "Latin small letter u with diaeresis and grave"
      },
      {
        "char": "ǝ",
        "unicode": "01DD",
        "fr": "e minuscule renversé",
        "en": "Latin small letter turned e"
      },
      {
        "char": "Ǟ",
        "unicode": "01DE",
        "fr": "A majuscule tréma macron",
        "en": "Latin capital letter A with diaeresis and macron"
      },
      {
        "char": "ǟ",
        "unicode": "01DF",
        "fr": "A minuscule tréma macron",
        "en": "Latin small letter a with diaeresis and macron"
      },
      {
        "char": "Ǡ",
        "unicode": "01E0",
        "fr": "A majuscule macron grave",
        "en": "Latin capital letter A with dot above and macron"
      },
      {
        "char": "ǡ",
        "unicode": "01E1",
        "fr": "A minuscule macron grave",
        "en": "Latin small letter a with dot above and macron"
      },
      {
        "char": "Ǣ",
        "unicode": "01E2",
        "fr": "AE majuscule macron",
        "en": "Latin capital letter AE with macron"
      },
      {
        "char": "ǣ",
        "unicode": "01E3",
        "fr": "Ae minuscule macron",
        "en": "Latin small letter ae with macron"
      },
      {
        "char": "Ǥ",
        "unicode": "01E4",
        "fr": "G majuscule barre",
        "en": "Latin capital letter G with stroke"
      },
      {
        "char": "ǥ",
        "unicode": "01E5",
        "fr": "g minuscule barre",
        "en": "Latin small letter g with stroke"
      },
      {
        "char": "Ǧ",
        "unicode": "01E6",
        "fr": "G majuscule caron",
        "en": "Latin capital letter G with caron"
      },
      {
        "char": "ǧ",
        "unicode": "01E7",
        "fr": "g minuscule caron",
        "en": "Latin small letter g with caron"
      },
      {
        "char": "Ǩ",
        "unicode": "01E8",
        "fr": "K majuscule caron",
        "en": "Latin capital letter K with caron"
      },
      {
        "char": "ǩ",
        "unicode": "01E9",
        "fr": "k minuscule caron",
        "en": "Latin small letter k with caron"
      },
      {
        "char": "Ǫ",
        "unicode": "01EA",
        "fr": "O majuscule ogonek",
        "en": "Latin capital letter O with ogonek"
      },
      {
        "char": "ǫ",
        "unicode": "01EB",
        "fr": "o minuscule ogonek",
        "en": "Latin small letter o with ogonek"
      },
      {
        "char": "Ǭ",
        "unicode": "01EC",
        "fr": "O majuscule ogonek macron",
        "en": "Latin capital letter O with ogonek and macron"
      },
      {
        "char": "ǭ",
        "unicode": "01ED",
        "fr": "o minuscule ogonek macron",
        "en": "Latin small letter o with ogonek and macron"
      },
      {
        "char": "Ǯ",
        "unicode": "01EE",
        "fr": "Ezh majuscule caron",
        "en": "Latin capital letter ezh with caron"
      },
      {
        "char": "ǯ",
        "unicode": "01EF",
        "fr": "ezh minuscule caron",
        "en": "Latin small letter ezh with caron"
      },
      {
        "char": "ǰ",
        "unicode": "01F0",
        "fr": "j minuscule caron",
        "en": "Latin small letter j with caron"
      },
      {
        "char": "Ǳ",
        "unicode": "01F1",
        "fr": "DZ majuscule",
        "en": "Latin capital letter DZ"
      },
      {
        "char": "ǲ",
        "unicode": "01F2",
        "fr": "Dz majuscule-minuscule",
        "en": "Latin capital letter D with small letter z"
      },
      {
        "char": "ǳ",
        "unicode": "01F3",
        "fr": "Dz minuscule",
        "en": "Latin small letter dz"
      },
      {
        "char": "Ǵ",
        "unicode": "01F4",
        "fr": "G majuscule accent aigu",
        "en": "Latin capital letter G with acute"
      },
      {
        "char": "ǵ",
        "unicode": "01F5",
        "fr": "g minuscule accent aigu",
        "en": "Latin small letter g with acute"
      },
      {
        "char": "Ƕ",
        "unicode": "01F6",
        "fr": "Hwair majuscule",
        "en": "Latin capital letter hwair"
      },
      {
        "char": "Ƿ",
        "unicode": "01F7",
        "fr": "Wynn majuscule",
        "en": "Latin capital letter wynn"
      },
      {
        "char": "Ǹ",
        "unicode": "01F8",
        "fr": "N majuscule accent grave",
        "en": "Latin capital letter N with grave"
      },
      {
        "char": "ǹ",
        "unicode": "01F9",
        "fr": "n minuscule accent grave",
        "en": "Latin small letter n with grave"
      },
      {
        "char": "Ǻ",
        "unicode": "01FA",
        "fr": "A majuscule rond en chef accent aigu",
        "en": "Latin capital letter A with ring above and acute"
      },
      {
        "char": "ǻ",
        "unicode": "01FB",
        "fr": "A minuscule rond en chef accent aigu",
        "en": "Latin small letter a with ring above and acute"
      },
      {
        "char": "Ǽ",
        "unicode": "01FC",
        "fr": "AE majuscule accent aigu",
        "en": "Latin capital letter AE with acute"
      },
      {
        "char": "ǽ",
        "unicode": "01FD",
        "fr": "Ae minuscule accent aigu",
        "en": "Latin small letter ae with acute"
      },
      {
        "char": "Ǿ",
        "unicode": "01FE",
        "fr": "O barré majuscule accent aigu",
        "en": "Latin capital letter O with stroke and acute"
      },
      {
        "char": "ǿ",
        "unicode": "01FF",
        "fr": "o barré minuscule accent aigu",
        "en": "Latin small letter o with stroke and acute"
      },
      {
        "char": "Ȁ",
        "unicode": "0200",
        "fr": "A majuscule accent grave double",
        "en": "Latin capital letter A with double grave"
      },
      {
        "char": "ȁ",
        "unicode": "0201",
        "fr": "A minuscule accent grave double",
        "en": "Latin small letter a with double grave"
      },
      {
        "char": "Ȃ",
        "unicode": "0202",
        "fr": "A majuscule accent inversé",
        "en": "Latin capital letter A with inverted breve"
      },
      {
        "char": "ȃ",
        "unicode": "0203",
        "fr": "A minuscule accent inversé",
        "en": "Latin small letter a with inverted breve"
      },
      {
        "char": "Ȅ",
        "unicode": "0204",
        "fr": "E majuscule accent grave double",
        "en": "Latin capital letter E with double grave"
      },
      {
        "char": "ȅ",
        "unicode": "0205",
        "fr": "e minuscule accent grave double",
        "en": "Latin small letter e with double grave"
      },
      {
        "char": "Ȇ",
        "unicode": "0206",
        "fr": "E majuscule accent inversé",
        "en": "Latin capital letter E with inverted breve"
      },
      {
        "char": "ȇ",
        "unicode": "0207",
        "fr": "e minuscule accent inversé",
        "en": "Latin small letter e with inverted breve"
      },
      {
        "char": "Ȉ",
        "unicode": "0208",
        "fr": "I majuscule accent grave double",
        "en": "Latin capital letter I with double grave"
      },
      {
        "char": "ȉ",
        "unicode": "0209",
        "fr": "i minuscule accent grave double",
        "en": "Latin small letter i with double grave"
      },
      {
        "char": "Ȋ",
        "unicode": "020A",
        "fr": "I majuscule accent inversé",
        "en": "Latin capital letter I with inverted breve"
      },
      {
        "char": "ȋ",
        "unicode": "020B",
        "fr": "i minuscule accent inversé",
        "en": "Latin small letter i with inverted breve"
      },
      {
        "char": "Ȍ",
        "unicode": "020C",
        "fr": "O majuscule accent grave double",
        "en": "Latin capital letter O with double grave"
      },
      {
        "char": "ȍ",
        "unicode": "020D",
        "fr": "o minuscule accent grave double",
        "en": "Latin small letter o with double grave"
      },
      {
        "char": "Ȏ",
        "unicode": "020E",
        "fr": "O majuscule accent inversé",
        "en": "Latin capital letter O with inverted breve"
      },
      {
        "char": "ȏ",
        "unicode": "020F",
        "fr": "o minuscule accent inversé",
        "en": "Latin small letter o with inverted breve"
      },
      {
        "char": "Ȑ",
        "unicode": "0210",
        "fr": "R majuscule accent grave double",
        "en": "Latin capital letter R with double grave"
      },
      {
        "char": "ȑ",
        "unicode": "0211",
        "fr": "r minuscule accent grave double",
        "en": "Latin small letter r with double grave"
      },
      {
        "char": "Ȓ",
        "unicode": "0212",
        "fr": "R majuscule accent inversé",
        "en": "Latin capital letter R with inverted breve"
      },
      {
        "char": "ȓ",
        "unicode": "0213",
        "fr": "r minuscule accent inversé",
        "en": "Latin small letter r with inverted breve"
      },
      {
        "char": "Ȕ",
        "unicode": "0214",
        "fr": "U majuscule accent grave double",
        "en": "Latin capital letter U with double grave"
      },
      {
        "char": "ȕ",
        "unicode": "0215",
        "fr": "u minuscule accent grave double",
        "en": "Latin small letter u with double grave"
      },
      {
        "char": "Ȗ",
        "unicode": "0216",
        "fr": "U majuscule accent inversé",
        "en": "Latin capital letter U with inverted breve"
      },
      {
        "char": "ȗ",
        "unicode": "0217",
        "fr": "u minuscule accent inversé",
        "en": "Latin small letter u with inverted breve"
      },
      {
        "char": "Ș",
        "unicode": "0218",
        "fr": "S majuscule virgule souscrite",
        "en": "Latin capital letter S with comma below"
      },
      {
        "char": "ș",
        "unicode": "0219",
        "fr": "s minuscule virgule souscrite",
        "en": "Latin small letter s with comma below"
      },
      {
        "char": "Ț",
        "unicode": "021A",
        "fr": "T majuscule virgule souscrite",
        "en": "Latin capital letter T with comma below"
      },
      {
        "char": "ț",
        "unicode": "021B",
        "fr": "T minuscule virgule souscrite",
        "en": "Latin small letter t with comma below"
      },
      {
        "char": "Ȝ",
        "unicode": "021C",
        "fr": "Yogh majuscule",
        "en": "Latin capital letter yogh"
      },
      {
        "char": "ȝ",
        "unicode": "021D",
        "fr": "yogh minuscule",
        "en": "Latin small letter yogh"
      },
      {
        "char": "Ȟ",
        "unicode": "021E",
        "fr": "H majuscule caron",
        "en": "Latin capital letter H with caron"
      },
      {
        "char": "ȟ",
        "unicode": "021F",
        "fr": "h minuscule caron",
        "en": "Latin small letter h with caron"
      },
      {
        "char": "Ƞ",
        "unicode": "0220",
        "fr": "N majuscule crochet gauche",
        "en": "Latin capital letter N with long right leg"
      },
      {
        "char": "ȡ",
        "unicode": "0221",
        "fr": "D minuscule crochet gauche",
        "en": "Latin small letter d with curl"
      },
      {
        "char": "Ȣ",
        "unicode": "0222",
        "fr": "OU majuscule",
        "en": "Latin capital letter OU"
      },
      {
        "char": "ȣ",
        "unicode": "0223",
        "fr": "ou minuscule",
        "en": "Latin small letter ou"
      },
      {
        "char": "Ȥ",
        "unicode": "0224",
        "fr": "Z majuscule crochet",
        "en": "Latin capital letter Z with hook"
      },
      {
        "char": "ȥ",
        "unicode": "0225",
        "fr": "z minuscule crochet",
        "en": "Latin small letter z with hook"
      },
      {
        "char": "Ȧ",
        "unicode": "0226",
        "fr": "A majuscule point dessus",
        "en": "Latin capital letter A with dot above"
      },
      {
        "char": "ȧ",
        "unicode": "0227",
        "fr": "A minuscule point dessus",
        "en": "Latin small letter a with dot above"
      },
      {
        "char": "Ȩ",
        "unicode": "0228",
        "fr": "E majuscule cédille",
        "en": "Latin capital letter E with cedilla"
      },
      {
        "char": "ȩ",
        "unicode": "0229",
        "fr": "e minuscule cédille",
        "en": "Latin small letter e with cedilla"
      },
      {
        "char": "Ȫ",
        "unicode": "022A",
        "fr": "O majuscule tréma macron",
        "en": "Latin capital letter O with diaeresis and macron"
      },
      {
        "char": "ȫ",
        "unicode": "022B",
        "fr": "o minuscule tréma macron",
        "en": "Latin small letter o with diaeresis and macron"
      },
      {
        "char": "Ȭ",
        "unicode": "022C",
        "fr": "O majuscule tilde tréma",
        "en": "Latin capital letter O with tilde and macron"
      },
      {
        "char": "ȭ",
        "unicode": "022D",
        "fr": "o minuscule tilde tréma",
        "en": "Latin small letter o with tilde and macron"
      },
      {
        "char": "Ȯ",
        "unicode": "022E",
        "fr": "O majuscule point dessus",
        "en": "Latin capital letter O with dot above"
      },
      {
        "char": "ȯ",
        "unicode": "022F",
        "fr": "o minuscule point dessus",
        "en": "Latin small letter o with dot above"
      },
      {
        "char": "Ȱ",
        "unicode": "0230",
        "fr": "O majuscule macron",
        "en": "Latin capital letter O with dot above and macron"
      },
      {
        "char": "ȱ",
        "unicode": "0231",
        "fr": "o minuscule macron",
        "en": "Latin small letter o with dot above and macron"
      },
      {
        "char": "Ȳ",
        "unicode": "0232",
        "fr": "Y majuscule macron",
        "en": "Latin capital letter Y with macron"
      },
      {
        "char": "ȳ",
        "unicode": "0233",
        "fr": "y minuscule macron",
        "en": "Latin small letter y with macron"
      },
      {
        "char": "ȴ",
        "unicode": "0234",
        "fr": "l minuscule boucle",
        "en": "Latin small letter l with curl"
      },
      {
        "char": "ȵ",
        "unicode": "0235",
        "fr": "n minuscule boucle",
        "en": "Latin small letter n with curl"
      },
      {
        "char": "ȶ",
        "unicode": "0236",
        "fr": "T minuscule boucle",
        "en": "Latin small letter t with curl"
      },
      {
        "char": "ȷ",
        "unicode": "0237",
        "fr": "j minuscule sans point",
        "en": "Latin small letter dotless j"
      },
      {
        "char": "ȸ",
        "unicode": "0238",
        "fr": "Db minuscule digraphe",
        "en": "Latin small letter db digraph"
      },
      {
        "char": "ȹ",
        "unicode": "0239",
        "fr": "qp minuscule digraphe",
        "en": "Latin small letter qp digraph"
      },
      {
        "char": "Ⱥ",
        "unicode": "023A",
        "fr": "A majuscule barré",
        "en": "Latin capital letter A with stroke"
      },
      {
        "char": "Ȼ",
        "unicode": "023B",
        "fr": "C majuscule barre",
        "en": "Latin capital letter C with stroke"
      },
      {
        "char": "ȼ",
        "unicode": "023C",
        "fr": "C minuscule barre",
        "en": "Latin small letter c with stroke"
      },
      {
        "char": "Ƚ",
        "unicode": "023D",
        "fr": "L majuscule barre",
        "en": "Latin capital letter L with bar"
      },
      {
        "char": "Ⱦ",
        "unicode": "023E",
        "fr": "T majuscule barre",
        "en": "Latin capital letter T with diagonal stroke"
      },
      {
        "char": "ȿ",
        "unicode": "023F",
        "fr": "s minuscule barré",
        "en": "Latin small letter s with swash tail"
      },
      {
        "char": "ɀ",
        "unicode": "0240",
        "fr": "z minuscule barre",
        "en": "Latin small letter z with swash tail"
      },
      {
        "char": "Ɂ",
        "unicode": "0241",
        "fr": "Glottal stop majuscule",
        "en": "Latin capital letter glottal stop"
      },
      {
        "char": "ɂ",
        "unicode": "0242",
        "fr": "Glottal stop minuscule",
        "en": "Latin small letter glottal stop"
      },
      {
        "char": "Ƀ",
        "unicode": "0243",
        "fr": "B majuscule barre",
        "en": "Latin capital letter B with stroke"
      },
      {
        "char": "Ʉ",
        "unicode": "0244",
        "fr": "U majuscule barre",
        "en": "Latin capital letter U bar"
      },
      {
        "char": "Ʌ",
        "unicode": "0245",
        "fr": "V majuscule",
        "en": "Latin capital letter turned V"
      },
      {
        "char": "Ɇ",
        "unicode": "0246",
        "fr": "E majuscule barre",
        "en": "Latin capital letter E with stroke"
      },
      {
        "char": "ɇ",
        "unicode": "0247",
        "fr": "e minuscule barre",
        "en": "Latin small letter e with stroke"
      },
      {
        "char": "Ɉ",
        "unicode": "0248",
        "fr": "J majuscule barre",
        "en": "Latin capital letter J with stroke"
      },
      {
        "char": "ɉ",
        "unicode": "0249",
        "fr": "j minuscule barre",
        "en": "Latin small letter j with stroke"
      },
      {
        "char": "Ɋ",
        "unicode": "024A",
        "fr": "Q majuscule barre",
        "en": "Latin capital letter Q with stroke"
      },
      {
        "char": "ɋ",
        "unicode": "024B",
        "fr": "q minuscule barre",
        "en": "Latin small letter q with stroke"
      },
      {
        "char": "Ɍ",
        "unicode": "024C",
        "fr": "R majuscule barre",
        "en": "Latin capital letter R with stroke"
      },
      {
        "char": "ɍ",
        "unicode": "024D",
        "fr": "r minuscule barre",
        "en": "Latin small letter r with stroke"
      },
      {
        "char": "Ɏ",
        "unicode": "024E",
        "fr": "Y majuscule barre",
        "en": "Latin capital letter Y with stroke"
      },
      {
        "char": "ɏ",
        "unicode": "024F",
        "fr": "y minuscule barre",
        "en": "Latin small letter y with stroke"
      }
    ]
  },
  {
    "name": "ipa-extensions",
    "fr": "Extensions de l’alphabet phonétique international",
    "en": "IPA Extensions",
    "characters": [
      {
        "char": "ɐ",
        "unicode": "0250",
        "fr": "A renversé",
        "en": "Latin small letter turned a"
      },
      {
        "char": "ɑ",
        "unicode": "0251",
        "fr": "A ouvert",
        "en": "Latin small letter alpha"
      },
      {
        "char": "ɒ",
        "unicode": "0252",
        "fr": "A ouvert renversé",
        "en": "Latin small letter turned alpha"
      },
      {
        "char": "ɓ",
        "unicode": "0253",
        "fr": "B crochet",
        "en": "Latin small letter b with hook"
      },
      {
        "char": "ɔ",
        "unicode": "0254",
        "fr": "o ouvert",
        "en": "Latin small letter open o"
      },
      {
        "char": "ɕ",
        "unicode": "0255",
        "fr": "C crochet",
        "en": "Latin small letter c with curl"
      },
      {
        "char": "ɖ",
        "unicode": "0256",
        "fr": "D crochet",
        "en": "Latin small letter d with tail"
      },
      {
        "char": "ɗ",
        "unicode": "0257",
        "fr": "D crochet",
        "en": "Latin small letter d with hook"
      },
      {
        "char": "ɘ",
        "unicode": "0258",
        "fr": "e barré inversé",
        "en": "Latin small letter reversed e"
      },
      {
        "char": "ə",
        "unicode": "0259",
        "fr": "e minuscule renversé (schwa)",
        "en": "Latin small letter schwa"
      },
      {
        "char": "ɚ",
        "unicode": "025A",
        "fr": "e retourné rhotique (schwa rhotique)",
        "en": "Latin small letter schwa with hook"
      },
      {
        "char": "ɛ",
        "unicode": "025B",
        "fr": "e ouvert",
        "en": "Latin small letter open e"
      },
      {
        "char": "ɜ",
        "unicode": "025C",
        "fr": "e renversé",
        "en": "Latin small letter reversed open e"
      },
      {
        "char": "ɝ",
        "unicode": "025D",
        "fr": "e renversé rhotique",
        "en": "Latin small letter reversed open e with hook"
      },
      {
        "char": "ɞ",
        "unicode": "025E",
        "fr": "e ouvert renversé",
        "en": "Latin small letter closed reversed open e"
      },
      {
        "char": "ɟ",
        "unicode": "025F",
        "fr": "j crochet",
        "en": "Latin small letter j with crossed-tail"
      },
      {
        "char": "ɠ",
        "unicode": "0260",
        "fr": "g crochet",
        "en": "Latin small letter g with hook"
      },
      {
        "char": "ɡ",
        "unicode": "0261",
        "fr": "g script",
        "en": "Latin small letter script g"
      },
      {
        "char": "ɢ",
        "unicode": "0262",
        "fr": "G majuscule",
        "en": "Latin letter small capital G"
      },
      {
        "char": "ɣ",
        "unicode": "0263",
        "fr": "gamma",
        "en": "Latin small letter gamma"
      },
      {
        "char": "ɤ",
        "unicode": "0264",
        "fr": "o fermé non arrondi (voyelle postérieure fermée non arrondie)",
        "en": "Latin small letter ram's horn"
      },
      {
        "char": "ɥ",
        "unicode": "0265",
        "fr": "h tourné",
        "en": "Latin small letter turned h"
      },
      {
        "char": "ɦ",
        "unicode": "0266",
        "fr": "h hameçon",
        "en": "Latin small letter h with hook"
      },
      {
        "char": "ɧ",
        "unicode": "0267",
        "fr": "h eng",
        "en": "Latin small letter heng with hook"
      },
      {
        "char": "ɨ",
        "unicode": "0268",
        "fr": "i barré",
        "en": "Latin small letter i with stroke"
      },
      {
        "char": "ɩ",
        "unicode": "0269",
        "fr": "i africain",
        "en": "Latin small letter iota"
      },
      {
        "char": "ɪ",
        "unicode": "026A",
        "fr": "I majuscule",
        "en": "Latin letter small capital I"
      },
      {
        "char": "ɫ",
        "unicode": "026B",
        "fr": "L minuscule latine avec tilde au milieu",
        "en": "Latin small letter l with middle tilde"
      },
      {
        "char": "ɬ",
        "unicode": "026C",
        "fr": "L minuscule latine avec barre",
        "en": "Latin small letter l with belt"
      },
      {
        "char": "ɭ",
        "unicode": "026D",
        "fr": "l crochet",
        "en": "Latin small letter l with retroflex hook"
      },
      {
        "char": "ɮ",
        "unicode": "026E",
        "fr": "lezh",
        "en": "Latin small letter lezh"
      },
      {
        "char": "ɯ",
        "unicode": "026F",
        "fr": "m renversé",
        "en": "Latin small letter turned m"
      },
      {
        "char": "ɰ",
        "unicode": "0270",
        "fr": "m avec jambe longue",
        "en": "Latin small letter turned m with long leg"
      },
      {
        "char": "ɱ",
        "unicode": "0271",
        "fr": "m crochet",
        "en": "Latin small letter m with hook"
      },
      {
        "char": "ɲ",
        "unicode": "0272",
        "fr": "n crochet gauche",
        "en": "Latin small letter n with left hook"
      },
      {
        "char": "ɳ",
        "unicode": "0273",
        "fr": "n crochet",
        "en": "Latin small letter n with retroflex hook"
      },
      {
        "char": "ɴ",
        "unicode": "0274",
        "fr": "N majuscule",
        "en": "Latin letter small capital N"
      },
      {
        "char": "ɵ",
        "unicode": "0275",
        "fr": "o barré",
        "en": "Latin small letter barred o"
      },
      {
        "char": "ɶ",
        "unicode": "0276",
        "fr": "OE majuscule",
        "en": "Latin letter small capital OE"
      },
      {
        "char": "ɷ",
        "unicode": "0277",
        "fr": "omega",
        "en": "Latin small letter closed omega"
      },
      {
        "char": "ɸ",
        "unicode": "0278",
        "fr": "phi",
        "en": "Latin small letter phi"
      },
      {
        "char": "ɹ",
        "unicode": "0279",
        "fr": "r tourné",
        "en": "Latin small letter turned r"
      },
      {
        "char": "ɺ",
        "unicode": "027A",
        "fr": "r tourné avec hameçon",
        "en": "Latin small letter turned r with long leg"
      },
      {
        "char": "ɻ",
        "unicode": "027B",
        "fr": "r rétroflexe",
        "en": "Latin small letter r with tail"
      },
      {
        "char": "ɼ",
        "unicode": "027C",
        "fr": "r crosse",
        "en": "Latin small letter r with fishhook"
      },
      {
        "char": "ɽ",
        "unicode": "027D",
        "fr": "r crochet",
        "en": "Latin small letter r with tail"
      },
      {
        "char": "ɾ",
        "unicode": "027E",
        "fr": "r crosse",
        "en": "Latin small letter r with fishhook"
      },
      {
        "char": "ɿ",
        "unicode": "027F",
        "fr": "r barré",
        "en": "Latin small letter reversed r with fishhook"
      },
      {
        "char": "ʀ",
        "unicode": "0280",
        "fr": "R majuscule",
        "en": "Latin letter small capital R"
      },
      {
        "char": "ʁ",
        "unicode": "0281",
        "fr": "r inversé",
        "en": "Latin letter small capital inverted R"
      },
      {
        "char": "ʂ",
        "unicode": "0282",
        "fr": "s crochet",
        "en": "Latin small letter s with hook"
      },
      {
        "char": "ʃ",
        "unicode": "0283",
        "fr": "esh",
        "en": "Latin small letter esh"
      },
      {
        "char": "ʄ",
        "unicode": "0284",
        "fr": "j crochet",
        "en": "Latin small letter dotless j with stroke"
      },
      {
        "char": "ʅ",
        "unicode": "0285",
        "fr": "s crochet",
        "en": "Latin small letter squat reversed esh"
      },
      {
        "char": "ʆ",
        "unicode": "0286",
        "fr": "esh crochet",
        "en": "Latin small letter ezh with curl"
      },
      {
        "char": "ʇ",
        "unicode": "0287",
        "fr": "t tourné",
        "en": "Latin small letter turned t"
      },
      {
        "char": "ʈ",
        "unicode": "0288",
        "fr": "t crochet",
        "en": "Latin small letter t with retroflex hook"
      },
      {
        "char": "ʉ",
        "unicode": "0289",
        "fr": "u barré",
        "en": "Latin small letter u bar"
      },
      {
        "char": "ʊ",
        "unicode": "028A",
        "fr": "U majuscule",
        "en": "Latin letter small capital U"
      },
      {
        "char": "ʋ",
        "unicode": "028B",
        "fr": "V tourné",
        "en": "Latin small letter v with hook"
      },
      {
        "char": "ʌ",
        "unicode": "028C",
        "fr": "V renversé",
        "en": "Latin small letter turned v"
      },
      {
        "char": "ʍ",
        "unicode": "028D",
        "fr": "w tourné",
        "en": "Latin small letter turned w"
      },
      {
        "char": "ʎ",
        "unicode": "028E",
        "fr": "y tourné",
        "en": "Latin small letter turned y"
      },
      {
        "char": "ʏ",
        "unicode": "028F",
        "fr": "Y majuscule",
        "en": "Latin letter small capital Y"
      },
      {
        "char": "ʐ",
        "unicode": "0290",
        "fr": "z crochet",
        "en": "Latin small letter z with retroflex hook"
      },
      {
        "char": "ʑ",
        "unicode": "0291",
        "fr": "z crosse",
        "en": "Latin small letter z with curl"
      },
      {
        "char": "ʒ",
        "unicode": "0292",
        "fr": "ezh",
        "en": "Latin small letter ezh"
      },
      {
        "char": "ʓ",
        "unicode": "0293",
        "fr": "ezh crochet",
        "en": "Latin small letter ezh with curl"
      },
      {
        "char": "ʔ",
        "unicode": "0294",
        "fr": "Coup de glotte",
        "en": "Latin letter glottal stop"
      },
      {
        "char": "ʕ",
        "unicode": "0295",
        "fr": "Pharyngale",
        "en": "Latin letter pharyngeal voiced fricative"
      },
      {
        "char": "ʖ",
        "unicode": "0296",
        "fr": "Clic latéral",
        "en": "Latin letter inverted glottal stop"
      },
      {
        "char": "ʗ",
        "unicode": "0297",
        "fr": "Clic bilabial",
        "en": "Latin letter stretched c"
      },
      {
        "char": "ʘ",
        "unicode": "0298",
        "fr": "Clic bilabial",
        "en": "Latin letter bilabial click"
      },
      {
        "char": "ʙ",
        "unicode": "0299",
        "fr": "B majuscule",
        "en": "Latin letter small capital B"
      },
      {
        "char": "ʚ",
        "unicode": "029A",
        "fr": "e ouvert barré",
        "en": "Latin small letter closed open e"
      },
      {
        "char": "ʛ",
        "unicode": "029B",
        "fr": "G majuscule crochet",
        "en": "Latin letter small capital G with hook"
      },
      {
        "char": "ʜ",
        "unicode": "029C",
        "fr": "H majuscule",
        "en": "Latin letter small capital H"
      },
      {
        "char": "ʝ",
        "unicode": "029D",
        "fr": "j crosse",
        "en": "Latin small letter j with crossed-tail"
      },
      {
        "char": "ʞ",
        "unicode": "029E",
        "fr": "k tourné",
        "en": "Latin small letter turned k"
      },
      {
        "char": "ʟ",
        "unicode": "029F",
        "fr": "L majuscule",
        "en": "Latin letter small capital L"
      },
      {
        "char": "ʠ",
        "unicode": "02A0",
        "fr": "q crochet",
        "en": "Latin small letter q with hook"
      },
      {
        "char": "ʡ",
        "unicode": "02A1",
        "fr": "Coup de glotte épiglottique",
        "en": "Latin letter glottal stop with stroke"
      },
      {
        "char": "ʢ",
        "unicode": "02A2",
        "fr": "fricative pharyngale",
        "en": "Latin letter reversed glottal stop with stroke"
      },
      {
        "char": "ʣ",
        "unicode": "02A3",
        "fr": "dz ligature",
        "en": "Latin small letter dz digraph"
      },
      {
        "char": "ʤ",
        "unicode": "02A4",
        "fr": "dzh ligature",
        "en": "Latin small letter d with z"
      },
      {
        "char": "ʥ",
        "unicode": "02A5",
        "fr": "dz ligature crochet",
        "en": "Latin small letter dz digraph with curl"
      },
      {
        "char": "ʦ",
        "unicode": "02A6",
        "fr": "ts ligature",
        "en": "Latin small letter ts digraph"
      },
      {
        "char": "ʧ",
        "unicode": "02A7",
        "fr": "tch ligature",
        "en": "Latin small letter t with esh"
      },
      {
        "char": "ʨ",
        "unicode": "02A8",
        "fr": "tc ligature",
        "en": "Latin small letter tc digraph with curl"
      },
      {
        "char": "ʩ",
        "unicode": "02A9",
        "fr": "fn ligature",
        "en": "Latin small letter f with n"
      },
      {
        "char": "ʪ",
        "unicode": "02AA",
        "fr": "ls ligature",
        "en": "Latin small letter ls digraph"
      },
      {
        "char": "ʫ",
        "unicode": "02AB",
        "fr": "lz ligature",
        "en": "Latin small letter lz digraph"
      },
      {
        "char": "ʬ",
        "unicode": "02AC",
        "fr": "ww ligature",
        "en": "Latin letter bilabial percussive"
      },
      {
        "char": "ʭ",
        "unicode": "02AD",
        "fr": "Dental click",
        "en": "Latin letter bidental percussive"
      },
      {
        "char": "ʮ",
        "unicode": "02AE",
        "fr": "z hameçon",
        "en": "Latin small letter turned h with fishhook"
      },
      {
        "char": "ʯ",
        "unicode": "02AF",
        "fr": "Turned h with stroke",
        "en": "Latin small letter turned h with stroke"
      }
    ]
  },
  {
    "name": "spacing-modifier-letters",
    "fr": "Lettres du modificateur d'espacement",
    "en": "Spacing Modifier Letters",
    "characters": [
      {
        "char": "ʰ",
        "unicode": "02B0",
        "fr": "h exposant",
        "en": "Modifier letter small h"
      },
      {
        "char": "ʱ",
        "unicode": "02B1",
        "fr": "h crochet exposant",
        "en": "Modifier letter small h with hook"
      },
      {
        "char": "ʲ",
        "unicode": "02B2",
        "fr": "Exposant j",
        "en": "Modifier letter small j"
      },
      {
        "char": "ʳ",
        "unicode": "02B3",
        "fr": "Exposant r",
        "en": "Modifier letter small r"
      },
      {
        "char": "ʴ",
        "unicode": "02B4",
        "fr": "Exposant r crosse",
        "en": "Modifier letter small turned r"
      },
      {
        "char": "ʵ",
        "unicode": "02B5",
        "fr": "Exposant r crosse inversé",
        "en": "Modifier letter small turned r with hook"
      },
      {
        "char": "ʶ",
        "unicode": "02B6",
        "fr": "Exposant gamma",
        "en": "Modifier letter small capital inverted R"
      },
      {
        "char": "ʷ",
        "unicode": "02B7",
        "fr": "Exposant w",
        "en": "Modifier letter small w"
      },
      {
        "char": "ʸ",
        "unicode": "02B8",
        "fr": "Exposant y",
        "en": "Modifier letter small y"
      },
      {
        "char": "ʹ",
        "unicode": "02B9",
        "fr": "Apostrophe",
        "en": "Modifier letter prime"
      },
      {
        "char": "ʺ",
        "unicode": "02BA",
        "fr": "Guillemet",
        "en": "Modifier letter double prime"
      },
      {
        "char": "ʻ",
        "unicode": "02BB",
        "fr": "ʻ (hamza)",
        "en": "Modifier letter turned comma"
      },
      {
        "char": "ʼ",
        "unicode": "02BC",
        "fr": "Apostrophe droite",
        "en": "Modifier letter apostrophe"
      },
      {
        "char": "ʽ",
        "unicode": "02BD",
        "fr": "Apostrophe inversé",
        "en": "Modifier letter reversed comma"
      },
      {
        "char": "ʾ",
        "unicode": "02BE",
        "fr": "Demi-anneau droit",
        "en": "Modifier letter right half ring"
      },
      {
        "char": "ʿ",
        "unicode": "02BF",
        "fr": "Demi-anneau gauche",
        "en": "Modifier letter left half ring"
      },
      {
        "char": "ˀ",
        "unicode": "02C0",
        "fr": "Coup de glotte",
        "en": "Modifier letter glottal stop"
      },
      {
        "char": "ˁ",
        "unicode": "02C1",
        "fr": "Coup de glotte pharyngal",
        "en": "Modifier letter pharyngeal voiced fricative"
      },
      {
        "char": "˂",
        "unicode": "02C2",
        "fr": "Chevron gauche",
        "en": "Modifier letter left arrowhead"
      },
      {
        "char": "˃",
        "unicode": "02C3",
        "fr": "Chevron droit",
        "en": "Modifier letter right arrowhead"
      },
      {
        "char": "˄",
        "unicode": "02C4",
        "fr": "Accent circonflexe",
        "en": "Modifier letter up arrowhead"
      },
      {
        "char": "˅",
        "unicode": "02C5",
        "fr": "Accent circonflexe inversé",
        "en": "Modifier letter down arrowhead"
      },
      {
        "char": "ˆ",
        "unicode": "02C6",
        "fr": "Accent circonflexe",
        "en": "Modifier letter circumflex accent"
      },
      {
        "char": "ˇ",
        "unicode": "02C7",
        "fr": "Caron",
        "en": "Modifier letter caron"
      },
      {
        "char": "ˈ",
        "unicode": "02C8",
        "fr": "Accent aigu",
        "en": "Modifier letter vertical line"
      },
      {
        "char": "ˉ",
        "unicode": "02C9",
        "fr": "Macron",
        "en": "Modifier letter macron"
      },
      {
        "char": "ˊ",
        "unicode": "02CA",
        "fr": "Accent aigu",
        "en": "Modifier letter acute accent"
      },
      {
        "char": "ˋ",
        "unicode": "02CB",
        "fr": "Accent grave",
        "en": "Modifier letter grave accent"
      },
      {
        "char": "ˌ",
        "unicode": "02CC",
        "fr": "Accent grave bas",
        "en": "Modifier letter low vertical line"
      },
      {
        "char": "ˍ",
        "unicode": "02CD",
        "fr": "Tiret bas",
        "en": "Modifier letter low macron"
      },
      {
        "char": "ˎ",
        "unicode": "02CE",
        "fr": "Virgule basse",
        "en": "Modifier letter low grave accent"
      },
      {
        "char": "ˏ",
        "unicode": "02CF",
        "fr": "Virgule basse aiguë",
        "en": "Modifier letter low acute accent"
      },
      {
        "char": "ː",
        "unicode": "02D0",
        "fr": "Deux-points triangulaire",
        "en": "Modifier letter triangular colon"
      },
      {
        "char": "ˑ",
        "unicode": "02D1",
        "fr": "Demi-deux-points triangulaire",
        "en": "Modifier letter half triangular colon"
      },
      {
        "char": "˒",
        "unicode": "02D2",
        "fr": "Accent rhotique",
        "en": "Modifier letter centered right half ring"
      },
      {
        "char": "˓",
        "unicode": "02D3",
        "fr": "Accent rhotique inversé",
        "en": "Modifier letter centered left half ring"
      },
      {
        "char": "˔",
        "unicode": "02D4",
        "fr": "Accent rhotique haut",
        "en": "Modifier letter up tack"
      },
      {
        "char": "˕",
        "unicode": "02D5",
        "fr": "Accent rhotique bas",
        "en": "Modifier letter down tack"
      },
      {
        "char": "˖",
        "unicode": "02D6",
        "fr": "Exposant plus",
        "en": "Modifier letter plus sign"
      },
      {
        "char": "˗",
        "unicode": "02D7",
        "fr": "Exposant moins",
        "en": "Modifier letter minus sign"
      },
      {
        "char": "˘",
        "unicode": "02D8",
        "fr": "Brève",
        "en": "Modifier letter breve"
      },
      {
        "char": "˙",
        "unicode": "02D9",
        "fr": "Point en chef",
        "en": "Modifier letter dot above"
      },
      {
        "char": "˚",
        "unicode": "02DA",
        "fr": "Rond en chef",
        "en": "Modifier letter ring above"
      },
      {
        "char": "˛",
        "unicode": "02DB",
        "fr": "Ogonek",
        "en": "Modifier letter ogonek"
      },
      { "char": "˜", "unicode": "02DC", "fr": "Tilde", "en": "Small tilde" },
      {
        "char": "˙",
        "unicode": "02DD",
        "fr": "Double accent aigu",
        "en": "Modifier letter double acute accent"
      },
      {
        "char": "˞",
        "unicode": "02DE",
        "fr": "Crochet rhotique exposant",
        "en": "Modifier letter rhotic hook"
      },
      {
        "char": "˟",
        "unicode": "02DF",
        "fr": "Croix exposant",
        "en": "Modifier letter crossed h"
      },
      {
        "char": "ˠ",
        "unicode": "02E0",
        "fr": "Exposant g",
        "en": "Modifier letter small gamma"
      },
      {
        "char": "ˡ",
        "unicode": "02E1",
        "fr": "Exposant l",
        "en": "Modifier letter small l"
      },
      {
        "char": "ˢ",
        "unicode": "02E2",
        "fr": "Exposant s",
        "en": "Modifier letter small s"
      },
      {
        "char": "ˣ",
        "unicode": "02E3",
        "fr": "Exposant x",
        "en": "Modifier letter small x"
      },
      {
        "char": "ˤ",
        "unicode": "02E4",
        "fr": "Exposant pharyngal",
        "en": "Modifier letter small reversed glottal stop"
      },
      {
        "char": "˥",
        "unicode": "02E5",
        "fr": "Ton haut",
        "en": "Modifier letter extra-high tone bar"
      },
      {
        "char": "˦",
        "unicode": "02E6",
        "fr": "Ton haut-moyen",
        "en": "Modifier letter high tone bar"
      },
      {
        "char": "˧",
        "unicode": "02E7",
        "fr": "Ton moyen",
        "en": "Modifier letter mid tone bar"
      },
      {
        "char": "˨",
        "unicode": "02E8",
        "fr": "Ton bas-moyen",
        "en": "Modifier letter low tone bar"
      },
      {
        "char": "˩",
        "unicode": "02E9",
        "fr": "Ton bas",
        "en": "Modifier letter extra-low tone bar"
      },
      {
        "char": "˪",
        "unicode": "02EA",
        "fr": "Ton montant (bopomofo)",
        "en": "Modifier letter yin departing tone mark"
      },
      {
        "char": "˫",
        "unicode": "02EB",
        "fr": "Ton descendant (bopomofo)",
        "en": "Modifier letter yang departing tone mark"
      },
      {
        "char": "ˬ",
        "unicode": "02EC",
        "fr": "Virgule arrondie exposant",
        "en": "Modifier letter voicing"
      },
      {
        "char": "˭",
        "unicode": "02ED",
        "fr": "Tiret bas arrondi exposant",
        "en": "Modifier letter unaspirated"
      },
      {
        "char": "ˮ",
        "unicode": "02EE",
        "fr": "Touble apostrophe exposant",
        "en": "Modifier letter double apostrophe"
      },
      {
        "char": "˯",
        "unicode": "02EF",
        "fr": "Ton descendant extra-bas",
        "en": "Modifier letter low down arrowhead"
      },
      {
        "char": "˰",
        "unicode": "02F0",
        "fr": "Ton montant extra-haut",
        "en": "Modifier letter low up arrowhead"
      },
      {
        "char": "˱",
        "unicode": "02F1",
        "fr": "Ton montant descendant",
        "en": "Modifier letter low left arrowhead"
      },
      {
        "char": "˲",
        "unicode": "02F2",
        "fr": "Ton montant montant",
        "en": "Modifier letter low right arrowhead"
      },
      {
        "char": "˳",
        "unicode": "02F3",
        "fr": "Virgule basse double",
        "en": "Modifier letter low ring"
      },
      {
        "char": "˴",
        "unicode": "02F4",
        "fr": "Accent aigu double",
        "en": "Modifier letter middle grave accent"
      },
      {
        "char": "˵",
        "unicode": "02F5",
        "fr": "Accent grave double",
        "en": "Modifier letter middle double acute accent"
      },
      {
        "char": "˶",
        "unicode": "02F6",
        "fr": "Accent circonflexe double",
        "en": "Modifier letter middle double grave accent"
      },
      {
        "char": "˷",
        "unicode": "02F7",
        "fr": "Tilde double",
        "en": "Modifier letter middle tilde"
      },
      {
        "char": "˸",
        "unicode": "02F8",
        "fr": "Deux-points double",
        "en": "Modifier letter raising"
      },
      {
        "char": "˹",
        "unicode": "02F9",
        "fr": "Crochet droit",
        "en": "Modifier letter lowering"
      },
      {
        "char": "˺",
        "unicode": "02FA",
        "fr": "Crochet gauche",
        "en": "Modifier letter advanced"
      },
      {
        "char": "˻",
        "unicode": "02FB",
        "fr": "Crochet droit bas",
        "en": "Modifier letter retracted"
      },
      {
        "char": "˼",
        "unicode": "02FC",
        "fr": "Crochet gauche bas",
        "en": "Modifier letter centralized"
      },
      {
        "char": "˽",
        "unicode": "02FD",
        "fr": "Tiret bas central",
        "en": "Modifier letter mid-centralized"
      },
      {
        "char": "˾",
        "unicode": "02FE",
        "fr": "Tiret bas central double",
        "en": "Modifier letter syllabic"
      },
      {
        "char": "˿",
        "unicode": "02FF",
        "fr": "Tiret bas central triple",
        "en": "Modifier letter non-syllabic"
      }
    ]
  },
  {
    "name": "combining-diacritical-marks",
    "fr": "Marques diacritiques d’association",
    "en": "Combining Diacritical Marks",
    "characters": [
      {
        "char": "̀",
        "unicode": "0300",
        "fr": "Accent grave",
        "en": "Combining grave accent"
      },
      {
        "char": "́",
        "unicode": "0301",
        "fr": "Accent aigu",
        "en": "Combining acute accent"
      },
      {
        "char": "̂",
        "unicode": "0302",
        "fr": "Accent circonflexe",
        "en": "Combining circumflex accent"
      },
      { "char": "̃", "unicode": "0303", "fr": "Tilde", "en": "Combining tilde" },
      {
        "char": "̄",
        "unicode": "0304",
        "fr": "Macron",
        "en": "Combining macron"
      },
      {
        "char": "̅",
        "unicode": "0305",
        "fr": "Macron suscrit",
        "en": "Combining overline"
      },
      { "char": "̆", "unicode": "0306", "fr": "Brève", "en": "Combining breve" },
      {
        "char": "̇",
        "unicode": "0307",
        "fr": "Point en chef",
        "en": "Combining dot above"
      },
      {
        "char": "̈",
        "unicode": "0308",
        "fr": "Tréma",
        "en": "Combining diaeresis"
      },
      {
        "char": "̉",
        "unicode": "0309",
        "fr": "Crochet en chef",
        "en": "Combining hook above"
      },
      {
        "char": "̊",
        "unicode": "030A",
        "fr": "Rond en chef",
        "en": "Combining ring above"
      },
      {
        "char": "̋",
        "unicode": "030B",
        "fr": "Double accent aigu",
        "en": "Combining double acute accent"
      },
      { "char": "̌", "unicode": "030C", "fr": "Caron", "en": "Combining caron" },
      {
        "char": "̍",
        "unicode": "030D",
        "fr": "Trait vertical en chef",
        "en": "Combining vertical line above"
      },
      {
        "char": "̎",
        "unicode": "030E",
        "fr": "Double trait vertical en chef",
        "en": "Combining double vertical line above"
      },
      {
        "char": "̏",
        "unicode": "030F",
        "fr": "Double accent grave",
        "en": "Combining double grave accent"
      },
      {
        "char": "̐",
        "unicode": "0310",
        "fr": "Accent inversé en chef",
        "en": "Combining inverted breve"
      },
      {
        "char": "̑",
        "unicode": "0311",
        "fr": "Accent inversé",
        "en": "Combining turned comma above"
      },
      {
        "char": "̒",
        "unicode": "0312",
        "fr": "Virgule en chef",
        "en": "Combining comma above"
      },
      {
        "char": "̓",
        "unicode": "0313",
        "fr": "Esprit doux",
        "en": "Combining reversed comma above"
      },
      {
        "char": "̔",
        "unicode": "0314",
        "fr": "Esprit rude",
        "en": "Combining comma above right"
      },
      {
        "char": "̕",
        "unicode": "0315",
        "fr": "Virgule en chef à droite",
        "en": "Combining reversed comma above right"
      },
      {
        "char": "̖",
        "unicode": "0316",
        "fr": "Trait souscrit",
        "en": "Combining grave accent below"
      },
      {
        "char": "̗",
        "unicode": "0317",
        "fr": "Accent aigu souscrit",
        "en": "Combining acute accent below"
      },
      {
        "char": "̘",
        "unicode": "0318",
        "fr": "Crochet souscrit gauche",
        "en": "Combining left tack below"
      },
      {
        "char": "̙",
        "unicode": "0319",
        "fr": "Crochet souscrit droit",
        "en": "Combining right tack below"
      },
      {
        "char": "̚",
        "unicode": "031A",
        "fr": "Point virgule souscrit",
        "en": "Combining left angle above"
      },
      { "char": "̛", "unicode": "031B", "fr": "Corne", "en": "Combining horn" },
      {
        "char": "̜",
        "unicode": "031C",
        "fr": "Crochet souscrit",
        "en": "Combining left half ring below"
      },
      {
        "char": "̝",
        "unicode": "031D",
        "fr": "Élevé",
        "en": "Combining up tack below"
      },
      {
        "char": "̞",
        "unicode": "031E",
        "fr": "Baissé",
        "en": "Combining down tack below"
      },
      {
        "char": "̟",
        "unicode": "031F",
        "fr": "Avancé",
        "en": "Combining plus sign below"
      },
      {
        "char": "̠",
        "unicode": "0320",
        "fr": "Rétracté",
        "en": "Combining minus sign below"
      },
      {
        "char": "̡",
        "unicode": "0321",
        "fr": "Crochet palatal souscrit",
        "en": "Combining palatalized hook below"
      },
      {
        "char": "̢",
        "unicode": "0322",
        "fr": "Crochet rétroflexe souscrit",
        "en": "Combining retroflex hook below"
      },
      {
        "char": "̣",
        "unicode": "0323",
        "fr": "Point souscrit",
        "en": "Combining dot below"
      },
      {
        "char": "̤",
        "unicode": "0324",
        "fr": "Tréma souscrit",
        "en": "Combining diaeresis below"
      },
      {
        "char": "̥",
        "unicode": "0325",
        "fr": "Rond souscrit",
        "en": "Combining ring below"
      },
      {
        "char": "̦",
        "unicode": "0326",
        "fr": "Virgule souscrite",
        "en": "Combining comma below"
      },
      {
        "char": "̧",
        "unicode": "0327",
        "fr": "Cédille",
        "en": "Combining cedilla"
      },
      {
        "char": "̨",
        "unicode": "0328",
        "fr": "Ogonek",
        "en": "Combining ogonek"
      },
      {
        "char": "̩",
        "unicode": "0329",
        "fr": "Trait vertical souscrit",
        "en": "Combining vertical line below"
      },
      {
        "char": "̪",
        "unicode": "032A",
        "fr": "Pont souscrit",
        "en": "Combining bridge below"
      },
      {
        "char": "̫",
        "unicode": "032B",
        "fr": "Arc souscrit",
        "en": "Combining inverted double arch below"
      },
      {
        "char": "̬",
        "unicode": "032C",
        "fr": "Voisé",
        "en": "Combining caron below"
      },
      {
        "char": "̭",
        "unicode": "032D",
        "fr": "Caron souscrit",
        "en": "Combining circumflex accent below"
      },
      {
        "char": "̮",
        "unicode": "032E",
        "fr": "Brève souscrite",
        "en": "Combining breve below"
      },
      {
        "char": "̯",
        "unicode": "032F",
        "fr": "Brève inversée souscrite",
        "en": "Combining inverted breve below"
      },
      {
        "char": "̰",
        "unicode": "0330",
        "fr": "Tilde souscrit",
        "en": "Combining tilde below"
      },
      {
        "char": "̱",
        "unicode": "0331",
        "fr": "Macron souscrit",
        "en": "Combining macron below"
      },
      {
        "char": "̲",
        "unicode": "0332",
        "fr": "Tiret bas",
        "en": "Combining low line"
      },
      {
        "char": "̳",
        "unicode": "0333",
        "fr": "Double tiret bas",
        "en": "Combining double low line"
      },
      {
        "char": "̴",
        "unicode": "0334",
        "fr": "Barre oblique en chef",
        "en": "Combining tilde overlay"
      },
      {
        "char": "̵",
        "unicode": "0335",
        "fr": "Barre oblique",
        "en": "Combining short stroke overlay"
      },
      {
        "char": "̶",
        "unicode": "0336",
        "fr": "Barre oblique longue",
        "en": "Combining long stroke overlay"
      },
      {
        "char": "̷",
        "unicode": "0337",
        "fr": "Barre oblique double",
        "en": "Combining short solidus overlay"
      },
      {
        "char": "̸",
        "unicode": "0338",
        "fr": "Barre oblique double longue",
        "en": "Combining long solidus overlay"
      },
      {
        "char": "̹",
        "unicode": "0339",
        "fr": "Queue rétroflexe",
        "en": "Combining right half ring below"
      },
      {
        "char": "̺",
        "unicode": "033A",
        "fr": "Queue palatale",
        "en": "Combining inverted bridge below"
      },
      {
        "char": "̻",
        "unicode": "033B",
        "fr": "Queue linguo-labiale",
        "en": "Combining square below"
      },
      {
        "char": "̼",
        "unicode": "033C",
        "fr": "Queue linguo-dentale",
        "en": "Combining seagull below"
      },
      {
        "char": "̽",
        "unicode": "033D",
        "fr": "X suscrit",
        "en": "Combining x above"
      },
      {
        "char": "̾",
        "unicode": "033E",
        "fr": "Tilde double suscrit",
        "en": "Combining vertical tilde"
      },
      {
        "char": "̿",
        "unicode": "033F",
        "fr": "Trait double suscrit",
        "en": "Combining double overline"
      },
      {
        "char": "̀",
        "unicode": "0340",
        "fr": "Accent grave (obsolète)",
        "en": "Combining grave tone mark"
      },
      {
        "char": "́",
        "unicode": "0341",
        "fr": "Accent aigu (obsolète)",
        "en": "Combining acute tone mark"
      },
      {
        "char": "͂",
        "unicode": "0342",
        "fr": "Perispomène",
        "en": "Combining Greek perispomeni"
      },
      {
        "char": "̓",
        "unicode": "0343",
        "fr": "Koronis",
        "en": "Combining Greek koronis"
      },
      {
        "char": "̈́",
        "unicode": "0344",
        "fr": "Dialytika tonos",
        "en": "Combining Greek dialytika tonos"
      },
      {
        "char": "ͅ",
        "unicode": "0345",
        "fr": "Iota souscrit",
        "en": "Combining Greek ypogegrammeni"
      },
      {
        "char": "͆",
        "unicode": "0346",
        "fr": "Pont en chef",
        "en": "Combining bridge above"
      },
      {
        "char": "͇",
        "unicode": "0347",
        "fr": "Double trait souscrit",
        "en": "Combining equals sign below"
      },
      {
        "char": "͈",
        "unicode": "0348",
        "fr": "Double barre verticale souscrite",
        "en": "Combining double vertical line below"
      },
      {
        "char": "͉",
        "unicode": "0349",
        "fr": "Trait vertical court souscrit",
        "en": "Combining left angle below"
      },
      {
        "char": "͊",
        "unicode": "034A",
        "fr": "Crochet en chef gauche",
        "en": "Combining not tilde above"
      },
      {
        "char": "͋",
        "unicode": "034B",
        "fr": "Crochet en chef droit",
        "en": "Combining homothetic above"
      },
      {
        "char": "͌",
        "unicode": "034C",
        "fr": "Tilde gauche en chef",
        "en": "Combining almost equal to above"
      },
      {
        "char": "͍",
        "unicode": "034D",
        "fr": "Trait vertical double souscrit",
        "en": "Combining left right arrow below"
      },
      {
        "char": "͎",
        "unicode": "034E",
        "fr": "Tilde double souscrit",
        "en": "Combining up tack below"
      },
      {
        "char": "͏",
        "unicode": "034F",
        "fr": "Caractère combinant invisible",
        "en": "Combining grapheme joiner"
      },
      {
        "char": "͐",
        "unicode": "0350",
        "fr": "Anneau droit en chef",
        "en": "Combining right arrowhead above"
      },
      {
        "char": "͑",
        "unicode": "0351",
        "fr": "Anneau gauche en chef",
        "en": "Combining left half ring above"
      },
      {
        "char": "͒",
        "unicode": "0352",
        "fr": "Anneau droit souscrit",
        "en": "Combining fermata"
      },
      {
        "char": "͓",
        "unicode": "0353",
        "fr": "Virgule souscrite",
        "en": "Combining x below"
      },
      {
        "char": "͔",
        "unicode": "0354",
        "fr": "Virgule souscrite droite",
        "en": "Combining left arrowhead below"
      },
      {
        "char": "͕",
        "unicode": "0355",
        "fr": "Virgule souscrite gauche",
        "en": "Combining right arrowhead below"
      },
      {
        "char": "͖",
        "unicode": "0356",
        "fr": "Virgule souscrite double",
        "en": "Combining right arrowhead and up arrowhead below"
      },
      {
        "char": "͗",
        "unicode": "0357",
        "fr": "Virgule souscrite triple",
        "en": "Combining right half ring above"
      },
      {
        "char": "͘",
        "unicode": "0358",
        "fr": "Anneau double souscrit",
        "en": "Combining dot above right"
      },
      {
        "char": "͙",
        "unicode": "0359",
        "fr": "Point souscrit droit",
        "en": "Combining asterisk below"
      },
      {
        "char": "͚",
        "unicode": "035A",
        "fr": "Astérisque souscrit",
        "en": "Combining double ring below"
      },
      {
        "char": "͛",
        "unicode": "035B",
        "fr": "Double anneau souscrit",
        "en": "Combining zigzag above"
      },
      {
        "char": "͜",
        "unicode": "035C",
        "fr": "Liaison double en chef",
        "en": "Combining double breve below"
      },
      {
        "char": "͝",
        "unicode": "035D",
        "fr": "Liaison double souscrite",
        "en": "Combining double breve"
      },
      {
        "char": "͞",
        "unicode": "035E",
        "fr": "Liaison double suscrite",
        "en": "Combining double macron"
      },
      {
        "char": "͟",
        "unicode": "035F",
        "fr": "Macron triple suscrit",
        "en": "Combining double macron below"
      },
      {
        "char": "͠",
        "unicode": "0360",
        "fr": "Tilde double suscrit",
        "en": "Combining double tilde"
      },
      {
        "char": "͡",
        "unicode": "0361",
        "fr": "Liaison double suscrite",
        "en": "Combining double inverted breve"
      },
      {
        "char": "͢",
        "unicode": "0362",
        "fr": "Liaison double souscrite",
        "en": "Combining double rightwards arrow below"
      },
      {
        "char": "ͣ",
        "unicode": "0363",
        "fr": "A suscrit",
        "en": "Combining Latin small letter a"
      },
      {
        "char": "ͤ",
        "unicode": "0364",
        "fr": "E suscrit",
        "en": "Combining Latin small letter e"
      },
      {
        "char": "ͥ",
        "unicode": "0365",
        "fr": "I suscrit",
        "en": "Combining Latin small letter i"
      },
      {
        "char": "ͦ",
        "unicode": "0366",
        "fr": "O suscrit",
        "en": "Combining Latin small letter o"
      },
      {
        "char": "ͧ",
        "unicode": "0367",
        "fr": "U suscrit",
        "en": "Combining Latin small letter u"
      },
      {
        "char": "ͨ",
        "unicode": "0368",
        "fr": "C suscrit",
        "en": "Combining Latin small letter c"
      },
      {
        "char": "ͩ",
        "unicode": "0369",
        "fr": "D suscrit",
        "en": "Combining Latin small letter d"
      },
      {
        "char": "ͪ",
        "unicode": "036A",
        "fr": "H suscrit",
        "en": "Combining Latin small letter h"
      },
      {
        "char": "ͫ",
        "unicode": "036B",
        "fr": "M suscrit",
        "en": "Combining Latin small letter m"
      },
      {
        "char": "ͬ",
        "unicode": "036C",
        "fr": "R suscrit",
        "en": "Combining Latin small letter r"
      },
      {
        "char": "ͭ",
        "unicode": "036D",
        "fr": "T suscrit",
        "en": "Combining Latin small letter t"
      },
      {
        "char": "ͮ",
        "unicode": "036E",
        "fr": "V suscrit",
        "en": "Combining Latin small letter v"
      },
      {
        "char": "ͯ",
        "unicode": "036F",
        "fr": "X suscrit",
        "en": "Combining Latin small letter x"
      }
    ]
  },
  {
    "name": "greek-and-coptic",
    "fr": "Grec et copte",
    "en": "Greek and Coptic",
    "characters": [
      {
        "char": "Ͱ",
        "unicode": "0370",
        "fr": "Lettre grecque Héta majuscule",
        "en": "Greek capital letter Heta"
      },
      {
        "char": "ͱ",
        "unicode": "0371",
        "fr": "Lettre grecque héta minuscule",
        "en": "Greek small letter heta"
      },
      {
        "char": "Ͳ",
        "unicode": "0372",
        "fr": "Lettre grecque Sampi majuscule",
        "en": "Greek capital letter Sampi"
      },
      {
        "char": "ͳ",
        "unicode": "0373",
        "fr": "Lettre grecque sampi minuscule",
        "en": "Greek small letter sampi"
      },
      {
        "char": "ʹ",
        "unicode": "0374",
        "fr": "Numéral grec",
        "en": "Greek numeral sign"
      },
      {
        "char": "͵",
        "unicode": "0375",
        "fr": "Numéral grec bas",
        "en": "Greek lower numeral sign"
      },
      {
        "char": "Ͷ",
        "unicode": "0376",
        "fr": "Lettre grecque Pamphylien Digamma majuscule",
        "en": "Greek capital letter Pamphylian Digamma"
      },
      {
        "char": "ͷ",
        "unicode": "0377",
        "fr": "Lettre grecque pamphylien digamma minuscule",
        "en": "Greek small letter Pamphylian Digamma"
      },
      {
        "char": "ͺ",
        "unicode": "037A",
        "fr": "Ypogegrammeni",
        "en": "Greek Ypogegrammeni"
      },
      {
        "char": "ͻ",
        "unicode": "037B",
        "fr": "Lettre grecque Yot",
        "en": "Greek small reversed lunate sigma symbol"
      },
      {
        "char": "ͼ",
        "unicode": "037C",
        "fr": "Lettre grecque San",
        "en": "Greek small dotted lunate sigma symbol"
      },
      {
        "char": "ͽ",
        "unicode": "037D",
        "fr": "Lettre grecque Sampi",
        "en": "Greek small reversed dotted lunate sigma symbol"
      },
      {
        "char": ";",
        "unicode": "037E",
        "fr": "Point-virgule grec",
        "en": "Greek question mark"
      },
      {
        "char": "Ϳ",
        "unicode": "037F",
        "fr": "Lettre grecque Yot majuscule",
        "en": "Greek capital letter Yot"
      },
      {
        "char": "΄",
        "unicode": "0384",
        "fr": "Accent aigu grec",
        "en": "Greek tonos"
      },
      {
        "char": "΅",
        "unicode": "0385",
        "fr": "Dialytika tonos grec",
        "en": "Greek dialytika tonos"
      },
      {
        "char": "Ά",
        "unicode": "0386",
        "fr": "Alpha majuscule accent aigu",
        "en": "Greek capital letter Alpha with tonos"
      },
      {
        "char": "·",
        "unicode": "0387",
        "fr": "Point médian grec",
        "en": "Greek ano teleia"
      },
      {
        "char": "Έ",
        "unicode": "0388",
        "fr": "Epsilon majuscule accent aigu",
        "en": "Greek capital letter Epsilon with tonos"
      },
      {
        "char": "Ή",
        "unicode": "0389",
        "fr": "Êta majuscule accent aigu",
        "en": "Greek capital letter Eta with tonos"
      },
      {
        "char": "Ί",
        "unicode": "038A",
        "fr": "Iota majuscule accent aigu",
        "en": "Greek capital letter Iota with tonos"
      },
      {
        "char": "Ό",
        "unicode": "038C",
        "fr": "Omicron majuscule accent aigu",
        "en": "Greek capital letter Omicron with tonos"
      },
      {
        "char": "Ύ",
        "unicode": "038E",
        "fr": "Upsilon majuscule accent aigu",
        "en": "Greek capital letter Upsilon with tonos"
      },
      {
        "char": "Ώ",
        "unicode": "038F",
        "fr": "Oméga majuscule accent aigu",
        "en": "Greek capital letter Omega with tonos"
      },
      {
        "char": "ΐ",
        "unicode": "0390",
        "fr": "Iota minuscule tréma accent aigu",
        "en": "Greek small letter iota with dialytika and tonos"
      },
      {
        "char": "Α",
        "unicode": "0391",
        "fr": "Alpha majuscule",
        "en": "Greek capital letter Alpha"
      },
      {
        "char": "Β",
        "unicode": "0392",
        "fr": "Bêta majuscule",
        "en": "Greek capital letter Beta"
      },
      {
        "char": "Γ",
        "unicode": "0393",
        "fr": "Gamma majuscule",
        "en": "Greek capital letter Gamma"
      },
      {
        "char": "Δ",
        "unicode": "0394",
        "fr": "Delta majuscule",
        "en": "Greek capital letter Delta"
      },
      {
        "char": "Ε",
        "unicode": "0395",
        "fr": "Epsilon majuscule",
        "en": "Greek capital letter Epsilon"
      },
      {
        "char": "Ζ",
        "unicode": "0396",
        "fr": "Zêta majuscule",
        "en": "Greek capital letter Zeta"
      },
      {
        "char": "Η",
        "unicode": "0397",
        "fr": "Êta majuscule",
        "en": "Greek capital letter Eta"
      },
      {
        "char": "Θ",
        "unicode": "0398",
        "fr": "Thêta majuscule",
        "en": "Greek capital letter Theta"
      },
      {
        "char": "Ι",
        "unicode": "0399",
        "fr": "Iota majuscule",
        "en": "Greek capital letter Iota"
      },
      {
        "char": "Κ",
        "unicode": "039A",
        "fr": "Kappa majuscule",
        "en": "Greek capital letter Kappa"
      },
      {
        "char": "Λ",
        "unicode": "039B",
        "fr": "Lambda majuscule",
        "en": "Greek capital letter Lambda"
      },
      {
        "char": "Μ",
        "unicode": "039C",
        "fr": "Mu majuscule",
        "en": "Greek capital letter Mu"
      },
      {
        "char": "Ν",
        "unicode": "039D",
        "fr": "Nu majuscule",
        "en": "Greek capital letter Nu"
      },
      {
        "char": "Ξ",
        "unicode": "039E",
        "fr": "Xi majuscule",
        "en": "Greek capital letter Xi"
      },
      {
        "char": "Ο",
        "unicode": "039F",
        "fr": "Omicron majuscule",
        "en": "Greek capital letter Omicron"
      },
      {
        "char": "Π",
        "unicode": "03A0",
        "fr": "Pi majuscule",
        "en": "Greek capital letter Pi"
      },
      {
        "char": "Ρ",
        "unicode": "03A1",
        "fr": "Rho majuscule",
        "en": "Greek capital letter Rho"
      },
      {
        "char": "Σ",
        "unicode": "03A3",
        "fr": "Sigma majuscule",
        "en": "Greek capital letter Sigma"
      },
      {
        "char": "Τ",
        "unicode": "03A4",
        "fr": "Tau majuscule",
        "en": "Greek capital letter Tau"
      },
      {
        "char": "Υ",
        "unicode": "03A5",
        "fr": "Upsilon majuscule",
        "en": "Greek capital letter Upsilon"
      },
      {
        "char": "Φ",
        "unicode": "03A6",
        "fr": "Phi majuscule",
        "en": "Greek capital letter Phi"
      },
      {
        "char": "Χ",
        "unicode": "03A7",
        "fr": "Chi majuscule",
        "en": "Greek capital letter Chi"
      },
      {
        "char": "Ψ",
        "unicode": "03A8",
        "fr": "Psi majuscule",
        "en": "Greek capital letter Psi"
      },
      {
        "char": "Ω",
        "unicode": "03A9",
        "fr": "Oméga majuscule",
        "en": "Greek capital letter Omega"
      },
      {
        "char": "Ϊ",
        "unicode": "03AA",
        "fr": "Iota majuscule tréma",
        "en": "Greek capital letter Iota with dialytika"
      },
      {
        "char": "Ϋ",
        "unicode": "03AB",
        "fr": "Upsilon majuscule tréma",
        "en": "Greek capital letter Upsilon with dialytika"
      },
      {
        "char": "ά",
        "unicode": "03AC",
        "fr": "Alpha minuscule accent aigu",
        "en": "Greek small letter alpha with tonos"
      },
      {
        "char": "έ",
        "unicode": "03AD",
        "fr": "Epsilon minuscule accent aigu",
        "en": "Greek small letter epsilon with tonos"
      },
      {
        "char": "ή",
        "unicode": "03AE",
        "fr": "Êta minuscule accent aigu",
        "en": "Greek small letter eta with tonos"
      },
      {
        "char": "ί",
        "unicode": "03AF",
        "fr": "Iota minuscule accent aigu",
        "en": "Greek small letter iota with tonos"
      },
      {
        "char": "ΰ",
        "unicode": "03B0",
        "fr": "Upsilon minuscule tréma accent aigu",
        "en": "Greek small letter upsilon with dialytika and tonos"
      },
      {
        "char": "α",
        "unicode": "03B1",
        "fr": "Alpha minuscule",
        "en": "Greek small letter alpha"
      },
      {
        "char": "β",
        "unicode": "03B2",
        "fr": "Bêta minuscule",
        "en": "Greek small letter beta"
      },
      {
        "char": "γ",
        "unicode": "03B3",
        "fr": "Gamma minuscule",
        "en": "Greek small letter gamma"
      },
      {
        "char": "δ",
        "unicode": "03B4",
        "fr": "Delta minuscule",
        "en": "Greek small letter delta"
      },
      {
        "char": "ε",
        "unicode": "03B5",
        "fr": "Epsilon minuscule",
        "en": "Greek small letter epsilon"
      },
      {
        "char": "ζ",
        "unicode": "03B6",
        "fr": "Zêta minuscule",
        "en": "Greek small letter zeta"
      },
      {
        "char": "η",
        "unicode": "03B7",
        "fr": "Êta minuscule",
        "en": "Greek small letter eta"
      },
      {
        "char": "θ",
        "unicode": "03B8",
        "fr": "Thêta minuscule",
        "en": "Greek small letter theta"
      },
      {
        "char": "ι",
        "unicode": "03B9",
        "fr": "Iota minuscule",
        "en": "Greek small letter iota"
      },
      {
        "char": "κ",
        "unicode": "03BA",
        "fr": "Kappa minuscule",
        "en": "Greek small letter kappa"
      },
      {
        "char": "λ",
        "unicode": "03BB",
        "fr": "Lambda minuscule",
        "en": "Greek small letter lambda"
      },
      {
        "char": "μ",
        "unicode": "03BC",
        "fr": "Mu minuscule",
        "en": "Greek small letter mu"
      },
      {
        "char": "ν",
        "unicode": "03BD",
        "fr": "Nu minuscule",
        "en": "Greek small letter nu"
      },
      {
        "char": "ξ",
        "unicode": "03BE",
        "fr": "Xi minuscule",
        "en": "Greek small letter xi"
      },
      {
        "char": "ο",
        "unicode": "03BF",
        "fr": "Omicron minuscule",
        "en": "Greek small letter omicron"
      },
      {
        "char": "π",
        "unicode": "03C0",
        "fr": "Pi minuscule",
        "en": "Greek small letter pi"
      },
      {
        "char": "ρ",
        "unicode": "03C1",
        "fr": "Rho minuscule",
        "en": "Greek small letter rho"
      },
      {
        "char": "ς",
        "unicode": "03C2",
        "fr": "Sigma final minuscule",
        "en": "Greek small letter final sigma"
      },
      {
        "char": "σ",
        "unicode": "03C3",
        "fr": "Sigma minuscule",
        "en": "Greek small letter sigma"
      },
      {
        "char": "τ",
        "unicode": "03C4",
        "fr": "Tau minuscule",
        "en": "Greek small letter tau"
      },
      {
        "char": "υ",
        "unicode": "03C5",
        "fr": "Upsilon minuscule",
        "en": "Greek small letter upsilon"
      },
      {
        "char": "φ",
        "unicode": "03C6",
        "fr": "Phi minuscule",
        "en": "Greek small letter phi"
      },
      {
        "char": "χ",
        "unicode": "03C7",
        "fr": "Chi minuscule",
        "en": "Greek small letter chi"
      },
      {
        "char": "ψ",
        "unicode": "03C8",
        "fr": "Psi minuscule",
        "en": "Greek small letter psi"
      },
      {
        "char": "ω",
        "unicode": "03C9",
        "fr": "Oméga minuscule",
        "en": "Greek small letter omega"
      },
      {
        "char": "ϊ",
        "unicode": "03CA",
        "fr": "Iota minuscule tréma",
        "en": "Greek small letter iota with dialytika"
      },
      {
        "char": "ϋ",
        "unicode": "03CB",
        "fr": "Upsilon minuscule tréma",
        "en": "Greek small letter upsilon with dialytika"
      },
      {
        "char": "ό",
        "unicode": "03CC",
        "fr": "Omicron minuscule accent aigu",
        "en": "Greek small letter omicron with tonos"
      },
      {
        "char": "ύ",
        "unicode": "03CD",
        "fr": "Upsilon minuscule accent aigu",
        "en": "Greek small letter upsilon with tonos"
      },
      {
        "char": "ώ",
        "unicode": "03CE",
        "fr": "Oméga minuscule accent aigu",
        "en": "Greek small letter omega with tonos"
      },
      {
        "char": "ϐ",
        "unicode": "03D0",
        "fr": "Bêta minuscule bouclé",
        "en": "Greek beta symbol"
      },
      {
        "char": "ϑ",
        "unicode": "03D1",
        "fr": "Thêta minuscule bouclé",
        "en": "Greek theta symbol"
      },
      {
        "char": "ϒ",
        "unicode": "03D2",
        "fr": "Upsilon majuscule à crochet",
        "en": "Greek upsilon with hook symbol"
      },
      {
        "char": "ϓ",
        "unicode": "03D3",
        "fr": "Upsilon majuscule à crochet accent aigu",
        "en": "Greek upsilon with acute and hook symbol"
      },
      {
        "char": "ϔ",
        "unicode": "03D4",
        "fr": "Upsilon majuscule à crochet tréma",
        "en": "Greek upsilon with diaeresis and hook symbol"
      },
      {
        "char": "ϕ",
        "unicode": "03D5",
        "fr": "Phi minuscule droit",
        "en": "Greek phi symbol"
      },
      {
        "char": "ϖ",
        "unicode": "03D6",
        "fr": "Pi minuscule droit",
        "en": "Greek pi symbol"
      },
      {
        "char": "ϗ",
        "unicode": "03D7",
        "fr": "Kai symbol",
        "en": "Greek kai symbol"
      },
      {
        "char": "Ϙ",
        "unicode": "03D8",
        "fr": "Qoppa majuscule",
        "en": "Greek letter archaic koppa"
      },
      {
        "char": "ϙ",
        "unicode": "03D9",
        "fr": "Qoppa minuscule",
        "en": "Greek small letter archaic koppa"
      },
      {
        "char": "Ϛ",
        "unicode": "03DA",
        "fr": "Stigma majuscule",
        "en": "Greek letter stigma"
      },
      {
        "char": "ϛ",
        "unicode": "03DB",
        "fr": "Stigma minuscule",
        "en": "Greek small letter stigma"
      },
      {
        "char": "Ϝ",
        "unicode": "03DC",
        "fr": "Digamma majuscule",
        "en": "Greek letter digamma"
      },
      {
        "char": "ϝ",
        "unicode": "03DD",
        "fr": "Digamma minuscule",
        "en": "Greek small letter digamma"
      },
      {
        "char": "Ϟ",
        "unicode": "03DE",
        "fr": "Koppa majuscule",
        "en": "Greek letter koppa"
      },
      {
        "char": "ϟ",
        "unicode": "03DF",
        "fr": "Koppa minuscule",
        "en": "Greek small letter koppa"
      },
      {
        "char": "Ϡ",
        "unicode": "03E0",
        "fr": "Sampi majuscule",
        "en": "Greek letter sampi"
      },
      {
        "char": "ϡ",
        "unicode": "03E1",
        "fr": "Sampi minuscule",
        "en": "Greek small letter sampi"
      },
      {
        "char": "Ϣ",
        "unicode": "03E2",
        "fr": "Lettre copte Shei majuscule",
        "en": "Coptic capital letter shei"
      },
      {
        "char": "ϣ",
        "unicode": "03E3",
        "fr": "Lettre copte shei minuscule",
        "en": "Coptic small letter shei"
      },
      {
        "char": "Ϥ",
        "unicode": "03E4",
        "fr": "Lettre copte Fei majuscule",
        "en": "Coptic capital letter fei"
      },
      {
        "char": "ϥ",
        "unicode": "03E5",
        "fr": "Lettre copte fei minuscule",
        "en": "Coptic small letter fei"
      },
      {
        "char": "Ϧ",
        "unicode": "03E6",
        "fr": "Lettre copte Khei majuscule",
        "en": "Coptic capital letter khei"
      },
      {
        "char": "ϧ",
        "unicode": "03E7",
        "fr": "Lettre copte khei minuscule",
        "en": "Coptic small letter khei"
      },
      {
        "char": "Ϩ",
        "unicode": "03E8",
        "fr": "Lettre copte Hori majuscule",
        "en": "Coptic capital letter hori"
      },
      {
        "char": "ϩ",
        "unicode": "03E9",
        "fr": "Lettre copte hori minuscule",
        "en": "Coptic small letter hori"
      },
      {
        "char": "Ϫ",
        "unicode": "03EA",
        "fr": "Lettre copte Gangia majuscule",
        "en": "Coptic capital letter gangia"
      },
      {
        "char": "ϫ",
        "unicode": "03EB",
        "fr": "Lettre copte gangia minuscule",
        "en": "Coptic small letter gangia"
      },
      {
        "char": "Ϭ",
        "unicode": "03EC",
        "fr": "Lettre copte Shima majuscule",
        "en": "Coptic capital letter shima"
      },
      {
        "char": "ϭ",
        "unicode": "03ED",
        "fr": "Lettre copte shima minuscule",
        "en": "Coptic small letter shima"
      },
      {
        "char": "Ϯ",
        "unicode": "03EE",
        "fr": "Lettre copte Dei majuscule",
        "en": "Coptic capital letter dei"
      },
      {
        "char": "ϯ",
        "unicode": "03EF",
        "fr": "Lettre copte dei minuscule",
        "en": "Coptic small letter dei"
      },
      {
        "char": "ϰ",
        "unicode": "03F0",
        "fr": "Kappa minuscule bouclé",
        "en": "Greek kappa symbol"
      },
      {
        "char": "ϱ",
        "unicode": "03F1",
        "fr": "Rho minuscule bouclé",
        "en": "Greek rho symbol"
      },
      {
        "char": "ϲ",
        "unicode": "03F2",
        "fr": "Sigma lunaire minuscule",
        "en": "Greek lunate sigma symbol"
      },
      {
        "char": "ϳ",
        "unicode": "03F3",
        "fr": "Yot minuscule",
        "en": "Greek letter yot"
      },
      {
        "char": "ϴ",
        "unicode": "03F4",
        "fr": "Thêta majuscule symbolique",
        "en": "Greek capital theta symbol"
      },
      {
        "char": "ϵ",
        "unicode": "03F5",
        "fr": "Epsilon minuscule lunaire",
        "en": "Greek lunate epsilon symbol"
      },
      {
        "char": "϶",
        "unicode": "03F6",
        "fr": "Signe de renversement grec",
        "en": "Greek reversed lunate epsilon symbol"
      },
      {
        "char": "Ϸ",
        "unicode": "03F7",
        "fr": "Lettre grecque Sho majuscule",
        "en": "Greek capital letter sho"
      },
      {
        "char": "ϸ",
        "unicode": "03F8",
        "fr": "Lettre grecque sho minuscule",
        "en": "Greek small letter sho"
      },
      {
        "char": "Ϲ",
        "unicode": "03F9",
        "fr": "Sigma majuscule lunaire",
        "en": "Greek capital lunate sigma symbol"
      },
      {
        "char": "Ϻ",
        "unicode": "03FA",
        "fr": "San majuscule",
        "en": "Greek capital letter san"
      },
      {
        "char": "ϻ",
        "unicode": "03FB",
        "fr": "San minuscule",
        "en": "Greek small letter san"
      },
      {
        "char": "ϼ",
        "unicode": "03FC",
        "fr": "Rho minuscule inversé",
        "en": "Greek r symbol"
      },
      {
        "char": "Ͻ",
        "unicode": "03FD",
        "fr": "Sampi majuscule inversé",
        "en": "Greek capital reversed lunate sigma symbol"
      },
      {
        "char": "Ͼ",
        "unicode": "03FE",
        "fr": "Sampi majuscule lunaire",
        "en": "Greek capital dotted lunate sigma symbol"
      },
      {
        "char": "Ͽ",
        "unicode": "03FF",
        "fr": "Sampi majuscule lunaire inversé",
        "en": "Greek capital reversed dotted lunate sigma symbol"
      }
    ]
  },
  {
    "name": "cyrillic",
    "fr": "Cyrillique",
    "en": "Cyrillic",
    "characters": [
      {
        "char": "Ѐ",
        "unicode": "0400",
        "fr": "Ie majuscule accent grave",
        "en": "Cyrillic capital letter Ie with grave"
      },
      {
        "char": "Ё",
        "unicode": "0401",
        "fr": "Io majuscule",
        "en": "Cyrillic capital letter Io"
      },
      {
        "char": "Ђ",
        "unicode": "0402",
        "fr": "Djé majuscule",
        "en": "Cyrillic capital letter Dje"
      },
      {
        "char": "Ѓ",
        "unicode": "0403",
        "fr": "Gué majuscule accent aigu",
        "en": "Cyrillic capital letter Gje"
      },
      {
        "char": "Є",
        "unicode": "0404",
        "fr": "Ukrainien ie majuscule",
        "en": "Cyrillic capital letter Ukrainian Ie"
      },
      {
        "char": "Ѕ",
        "unicode": "0405",
        "fr": "Dze majuscule",
        "en": "Cyrillic capital letter Dze"
      },
      {
        "char": "І",
        "unicode": "0406",
        "fr": "I majuscule",
        "en": "Cyrillic capital letter Byelorussian-Ukrainian I"
      },
      {
        "char": "Ї",
        "unicode": "0407",
        "fr": "Yi majuscule",
        "en": "Cyrillic capital letter Yi"
      },
      {
        "char": "Ј",
        "unicode": "0408",
        "fr": "Je majuscule",
        "en": "Cyrillic capital letter Je"
      },
      {
        "char": "Љ",
        "unicode": "0409",
        "fr": "Lje majuscule",
        "en": "Cyrillic capital letter Lje"
      },
      {
        "char": "Њ",
        "unicode": "040A",
        "fr": "Nje majuscule",
        "en": "Cyrillic capital letter Nje"
      },
      {
        "char": "Ћ",
        "unicode": "040B",
        "fr": "Tshe majuscule",
        "en": "Cyrillic capital letter Tshe"
      },
      {
        "char": "Ќ",
        "unicode": "040C",
        "fr": "Kje majuscule",
        "en": "Cyrillic capital letter Kje"
      },
      {
        "char": "Ѝ",
        "unicode": "040D",
        "fr": "I majuscule accent grave",
        "en": "Cyrillic capital letter I with grave"
      },
      {
        "char": "Ў",
        "unicode": "040E",
        "fr": "Short U majuscule",
        "en": "Cyrillic capital letter Short U"
      },
      {
        "char": "Џ",
        "unicode": "040F",
        "fr": "Dzhe majuscule",
        "en": "Cyrillic capital letter Dzhe"
      },
      {
        "char": "А",
        "unicode": "0410",
        "fr": "A majuscule",
        "en": "Cyrillic capital letter A"
      },
      {
        "char": "Б",
        "unicode": "0411",
        "fr": "Be majuscule",
        "en": "Cyrillic capital letter Be"
      },
      {
        "char": "В",
        "unicode": "0412",
        "fr": "Ve majuscule",
        "en": "Cyrillic capital letter Ve"
      },
      {
        "char": "Г",
        "unicode": "0413",
        "fr": "Gue majuscule",
        "en": "Cyrillic capital letter Ghe"
      },
      {
        "char": "Д",
        "unicode": "0414",
        "fr": "De majuscule",
        "en": "Cyrillic capital letter De"
      },
      {
        "char": "Е",
        "unicode": "0415",
        "fr": "Ie majuscule",
        "en": "Cyrillic capital letter Ie"
      },
      {
        "char": "Ж",
        "unicode": "0416",
        "fr": "Zhe majuscule",
        "en": "Cyrillic capital letter Zhe"
      },
      {
        "char": "З",
        "unicode": "0417",
        "fr": "Ze majuscule",
        "en": "Cyrillic capital letter Ze"
      },
      {
        "char": "И",
        "unicode": "0418",
        "fr": "I majuscule",
        "en": "Cyrillic capital letter I"
      },
      {
        "char": "Й",
        "unicode": "0419",
        "fr": "Short I majuscule",
        "en": "Cyrillic capital letter Short I"
      },
      {
        "char": "К",
        "unicode": "041A",
        "fr": "Ka majuscule",
        "en": "Cyrillic capital letter Ka"
      },
      {
        "char": "Л",
        "unicode": "041B",
        "fr": "El majuscule",
        "en": "Cyrillic capital letter El"
      },
      {
        "char": "М",
        "unicode": "041C",
        "fr": "Em majuscule",
        "en": "Cyrillic capital letter Em"
      },
      {
        "char": "Н",
        "unicode": "041D",
        "fr": "En majuscule",
        "en": "Cyrillic capital letter En"
      },
      {
        "char": "О",
        "unicode": "041E",
        "fr": "O majuscule",
        "en": "Cyrillic capital letter O"
      },
      {
        "char": "П",
        "unicode": "041F",
        "fr": "Pe majuscule",
        "en": "Cyrillic capital letter Pe"
      },
      {
        "char": "Р",
        "unicode": "0420",
        "fr": "Er majuscule",
        "en": "Cyrillic capital letter Er"
      },
      {
        "char": "С",
        "unicode": "0421",
        "fr": "Es majuscule",
        "en": "Cyrillic capital letter Es"
      },
      {
        "char": "Т",
        "unicode": "0422",
        "fr": "Te majuscule",
        "en": "Cyrillic capital letter Te"
      },
      {
        "char": "У",
        "unicode": "0423",
        "fr": "Ou majuscule",
        "en": "Cyrillic capital letter U"
      },
      {
        "char": "Ф",
        "unicode": "0424",
        "fr": "Ef majuscule",
        "en": "Cyrillic capital letter Ef"
      },
      {
        "char": "Х",
        "unicode": "0425",
        "fr": "Ha majuscule",
        "en": "Cyrillic capital letter Ha"
      },
      {
        "char": "Ц",
        "unicode": "0426",
        "fr": "Tse majuscule",
        "en": "Cyrillic capital letter Tse"
      },
      {
        "char": "Ч",
        "unicode": "0427",
        "fr": "Che majuscule",
        "en": "Cyrillic capital letter Che"
      },
      {
        "char": "Ш",
        "unicode": "0428",
        "fr": "Sha majuscule",
        "en": "Cyrillic capital letter Sha"
      },
      {
        "char": "Щ",
        "unicode": "0429",
        "fr": "Shcha majuscule",
        "en": "Cyrillic capital letter Shcha"
      },
      {
        "char": "Ъ",
        "unicode": "042A",
        "fr": "Signe dur majuscule",
        "en": "Cyrillic capital letter Hard Sign"
      },
      {
        "char": "Ы",
        "unicode": "042B",
        "fr": "Yeru majuscule",
        "en": "Cyrillic capital letter Yeru"
      },
      {
        "char": "Ь",
        "unicode": "042C",
        "fr": "Signe mou majuscule",
        "en": "Cyrillic capital letter Soft Sign"
      },
      {
        "char": "Э",
        "unicode": "042D",
        "fr": "E majuscule",
        "en": "Cyrillic capital letter E"
      },
      {
        "char": "Ю",
        "unicode": "042E",
        "fr": "Iou majuscule",
        "en": "Cyrillic capital letter Yu"
      },
      {
        "char": "Я",
        "unicode": "042F",
        "fr": "Ia majuscule",
        "en": "Cyrillic capital letter Ya"
      },
      {
        "char": "а",
        "unicode": "0430",
        "fr": "A minuscule",
        "en": "Cyrillic small letter a"
      },
      {
        "char": "б",
        "unicode": "0431",
        "fr": "Be minuscule",
        "en": "Cyrillic small letter be"
      },
      {
        "char": "в",
        "unicode": "0432",
        "fr": "Ve minuscule",
        "en": "Cyrillic small letter ve"
      },
      {
        "char": "г",
        "unicode": "0433",
        "fr": "Gue minuscule",
        "en": "Cyrillic small letter ghe"
      },
      {
        "char": "д",
        "unicode": "0434",
        "fr": "De minuscule",
        "en": "Cyrillic small letter de"
      },
      {
        "char": "е",
        "unicode": "0435",
        "fr": "Ie minuscule",
        "en": "Cyrillic small letter ie"
      },
      {
        "char": "ж",
        "unicode": "0436",
        "fr": "Zhe minuscule",
        "en": "Cyrillic small letter zhe"
      },
      {
        "char": "з",
        "unicode": "0437",
        "fr": "Ze minuscule",
        "en": "Cyrillic small letter ze"
      },
      {
        "char": "и",
        "unicode": "0438",
        "fr": "I minuscule",
        "en": "Cyrillic small letter i"
      },
      {
        "char": "й",
        "unicode": "0439",
        "fr": "Short I minuscule",
        "en": "Cyrillic small letter short i"
      },
      {
        "char": "к",
        "unicode": "043A",
        "fr": "Ka minuscule",
        "en": "Cyrillic small letter ka"
      },
      {
        "char": "л",
        "unicode": "043B",
        "fr": "El minuscule",
        "en": "Cyrillic small letter el"
      },
      {
        "char": "м",
        "unicode": "043C",
        "fr": "Em minuscule",
        "en": "Cyrillic small letter em"
      },
      {
        "char": "н",
        "unicode": "043D",
        "fr": "En minuscule",
        "en": "Cyrillic small letter en"
      },
      {
        "char": "о",
        "unicode": "043E",
        "fr": "O minuscule",
        "en": "Cyrillic small letter o"
      },
      {
        "char": "п",
        "unicode": "043F",
        "fr": "Pe minuscule",
        "en": "Cyrillic small letter pe"
      },
      {
        "char": "р",
        "unicode": "0440",
        "fr": "Er minuscule",
        "en": "Cyrillic small letter er"
      },
      {
        "char": "с",
        "unicode": "0441",
        "fr": "Es minuscule",
        "en": "Cyrillic small letter es"
      },
      {
        "char": "т",
        "unicode": "0442",
        "fr": "Te minuscule",
        "en": "Cyrillic small letter te"
      },
      {
        "char": "у",
        "unicode": "0443",
        "fr": "Ou minuscule",
        "en": "Cyrillic small letter u"
      },
      {
        "char": "ф",
        "unicode": "0444",
        "fr": "Ef minuscule",
        "en": "Cyrillic small letter ef"
      },
      {
        "char": "х",
        "unicode": "0445",
        "fr": "Ha minuscule",
        "en": "Cyrillic small letter ha"
      },
      {
        "char": "ц",
        "unicode": "0446",
        "fr": "Tse minuscule",
        "en": "Cyrillic small letter tse"
      },
      {
        "char": "ч",
        "unicode": "0447",
        "fr": "Che minuscule",
        "en": "Cyrillic small letter che"
      },
      {
        "char": "ш",
        "unicode": "0448",
        "fr": "Sha minuscule",
        "en": "Cyrillic small letter sha"
      },
      {
        "char": "щ",
        "unicode": "0449",
        "fr": "Shcha minuscule",
        "en": "Cyrillic small letter shcha"
      },
      {
        "char": "ъ",
        "unicode": "044A",
        "fr": "Signe dur minuscule",
        "en": "Cyrillic small letter hard sign"
      },
      {
        "char": "ы",
        "unicode": "044B",
        "fr": "Yeru minuscule",
        "en": "Cyrillic small letter yeru"
      },
      {
        "char": "ь",
        "unicode": "044C",
        "fr": "Signe mou minuscule",
        "en": "Cyrillic small letter soft sign"
      },
      {
        "char": "э",
        "unicode": "044D",
        "fr": "E minuscule",
        "en": "Cyrillic small letter e"
      },
      {
        "char": "ю",
        "unicode": "044E",
        "fr": "Iou minuscule",
        "en": "Cyrillic small letter yu"
      },
      {
        "char": "я",
        "unicode": "044F",
        "fr": "Ia minuscule",
        "en": "Cyrillic small letter ya"
      },
      {
        "char": "ѐ",
        "unicode": "0450",
        "fr": "Ie minuscule accent grave",
        "en": "Cyrillic small letter ie with grave"
      },
      {
        "char": "ё",
        "unicode": "0451",
        "fr": "Io minuscule",
        "en": "Cyrillic small letter io"
      },
      {
        "char": "ђ",
        "unicode": "0452",
        "fr": "Djé minuscule",
        "en": "Cyrillic small letter dje"
      },
      {
        "char": "ѓ",
        "unicode": "0453",
        "fr": "Gué minuscule accent aigu",
        "en": "Cyrillic small letter gje"
      },
      {
        "char": "є",
        "unicode": "0454",
        "fr": "Ukrainien ie minuscule",
        "en": "Cyrillic small letter ukrainian ie"
      },
      {
        "char": "ѕ",
        "unicode": "0455",
        "fr": "Dze minuscule",
        "en": "Cyrillic small letter dze"
      },
      {
        "char": "і",
        "unicode": "0456",
        "fr": "I minuscule",
        "en": "Cyrillic small letter byelorussian-ukrainian i"
      },
      {
        "char": "ї",
        "unicode": "0457",
        "fr": "Yi minuscule",
        "en": "Cyrillic small letter yi"
      },
      {
        "char": "ј",
        "unicode": "0458",
        "fr": "Je minuscule",
        "en": "Cyrillic small letter je"
      },
      {
        "char": "љ",
        "unicode": "0459",
        "fr": "Lje minuscule",
        "en": "Cyrillic small letter lje"
      },
      {
        "char": "њ",
        "unicode": "045A",
        "fr": "Nje minuscule",
        "en": "Cyrillic small letter nje"
      },
      {
        "char": "ћ",
        "unicode": "045B",
        "fr": "Tshe minuscule",
        "en": "Cyrillic small letter tshe"
      },
      {
        "char": "ќ",
        "unicode": "045C",
        "fr": "Kje minuscule",
        "en": "Cyrillic small letter kje"
      },
      {
        "char": "ѝ",
        "unicode": "045D",
        "fr": "I minuscule accent grave",
        "en": "Cyrillic small letter i with grave"
      },
      {
        "char": "ў",
        "unicode": "045E",
        "fr": "Short U minuscule",
        "en": "Cyrillic small letter short u"
      },
      {
        "char": "џ",
        "unicode": "045F",
        "fr": "Dzhe minuscule",
        "en": "Cyrillic small letter dzhe"
      },
      {
        "char": "Ѡ",
        "unicode": "0460",
        "fr": "Omega majuscule",
        "en": "Cyrillic capital letter omega"
      },
      {
        "char": "ѡ",
        "unicode": "0461",
        "fr": "Omega minuscule",
        "en": "Cyrillic small letter omega"
      },
      {
        "char": "Ѣ",
        "unicode": "0462",
        "fr": "Yat majuscule",
        "en": "Cyrillic capital letter yat"
      },
      {
        "char": "ѣ",
        "unicode": "0463",
        "fr": "Yat minuscule",
        "en": "Cyrillic small letter yat"
      },
      {
        "char": "Ѥ",
        "unicode": "0464",
        "fr": "Iotifié E majuscule",
        "en": "Cyrillic capital letter iotified e"
      },
      {
        "char": "ѥ",
        "unicode": "0465",
        "fr": "Iotifié e minuscule",
        "en": "Cyrillic small letter iotified e"
      },
      {
        "char": "Ѧ",
        "unicode": "0466",
        "fr": "Petit yus majuscule",
        "en": "Cyrillic capital letter little yus"
      },
      {
        "char": "ѧ",
        "unicode": "0467",
        "fr": "Petit yus minuscule",
        "en": "Cyrillic small letter little yus"
      },
      {
        "char": "Ѩ",
        "unicode": "0468",
        "fr": "Iotifié petit yus majuscule",
        "en": "Cyrillic capital letter iotified little yus"
      },
      {
        "char": "ѩ",
        "unicode": "0469",
        "fr": "Iotifié petit yus minuscule",
        "en": "Cyrillic small letter iotified little yus"
      },
      {
        "char": "Ѫ",
        "unicode": "046A",
        "fr": "Grand yus majuscule",
        "en": "Cyrillic capital letter big yus"
      },
      {
        "char": "ѫ",
        "unicode": "046B",
        "fr": "Grand yus minuscule",
        "en": "Cyrillic small letter big yus"
      },
      {
        "char": "Ѭ",
        "unicode": "046C",
        "fr": "Iotifié grand yus majuscule",
        "en": "Cyrillic capital letter iotified big yus"
      },
      {
        "char": "ѭ",
        "unicode": "046D",
        "fr": "Iotifié grand yus minuscule",
        "en": "Cyrillic small letter iotified big yus"
      },
      {
        "char": "Ѯ",
        "unicode": "046E",
        "fr": "Ksi majuscule",
        "en": "Cyrillic capital letter ksi"
      },
      {
        "char": "ѯ",
        "unicode": "046F",
        "fr": "Ksi minuscule",
        "en": "Cyrillic small letter ksi"
      },
      {
        "char": "Ѱ",
        "unicode": "0470",
        "fr": "Psi majuscule",
        "en": "Cyrillic capital letter psi"
      },
      {
        "char": "ѱ",
        "unicode": "0471",
        "fr": "Psi minuscule",
        "en": "Cyrillic small letter psi"
      },
      {
        "char": "Ѳ",
        "unicode": "0472",
        "fr": "Fita majuscule",
        "en": "Cyrillic capital letter fita"
      },
      {
        "char": "ѳ",
        "unicode": "0473",
        "fr": "Fita minuscule",
        "en": "Cyrillic small letter fita"
      },
      {
        "char": "Ѵ",
        "unicode": "0474",
        "fr": "Izhitsa majuscule",
        "en": "Cyrillic capital letter izhitsa"
      },
      {
        "char": "ѵ",
        "unicode": "0475",
        "fr": "Izhitsa minuscule",
        "en": "Cyrillic small letter izhitsa"
      },
      {
        "char": "Ѷ",
        "unicode": "0476",
        "fr": "Izhitsa majuscule double diacritique",
        "en": "Cyrillic capital letter izhitsa with double grave accent"
      },
      {
        "char": "ѷ",
        "unicode": "0477",
        "fr": "Izhitsa minuscule double diacritique",
        "en": "Cyrillic small letter izhitsa with double grave accent"
      },
      {
        "char": "Ѹ",
        "unicode": "0478",
        "fr": "Uk majuscule",
        "en": "Cyrillic capital letter uk"
      },
      {
        "char": "ѹ",
        "unicode": "0479",
        "fr": "Uk minuscule",
        "en": "Cyrillic small letter uk"
      },
      {
        "char": "Ѻ",
        "unicode": "047A",
        "fr": "Round omega majuscule",
        "en": "Cyrillic capital letter round omega"
      },
      {
        "char": "ѻ",
        "unicode": "047B",
        "fr": "Round omega minuscule",
        "en": "Cyrillic small letter round omega"
      },
      {
        "char": "Ѽ",
        "unicode": "047C",
        "fr": "Omega titlo majuscule",
        "en": "Cyrillic capital letter omega with titlo"
      },
      {
        "char": "ѽ",
        "unicode": "047D",
        "fr": "Omega titlo minuscule",
        "en": "Cyrillic small letter omega with titlo"
      },
      {
        "char": "Ѿ",
        "unicode": "047E",
        "fr": "Ot majuscule",
        "en": "Cyrillic capital letter ot"
      },
      {
        "char": "ѿ",
        "unicode": "047F",
        "fr": "Ot minuscule",
        "en": "Cyrillic small letter ot"
      },
      {
        "char": "Ҁ",
        "unicode": "0480",
        "fr": "Koppa majuscule",
        "en": "Cyrillic capital letter koppa"
      },
      {
        "char": "ҁ",
        "unicode": "0481",
        "fr": "Koppa minuscule",
        "en": "Cyrillic small letter koppa"
      },
      {
        "char": "҂",
        "unicode": "0482",
        "fr": "Signe des milliers",
        "en": "Cyrillic thousands sign"
      },
      {
        "char": "҃",
        "unicode": "0483",
        "fr": "Titlo",
        "en": "Combining cyrillic titlo"
      },
      {
        "char": "҄",
        "unicode": "0484",
        "fr": "Palatalisation",
        "en": "Combining cyrillic palatalization"
      },
      {
        "char": "҅",
        "unicode": "0485",
        "fr": "Pokrytie",
        "en": "Combining cyrillic dasia pneumata"
      },
      {
        "char": "҆",
        "unicode": "0486",
        "fr": "Psili pneumata",
        "en": "Combining cyrillic psili pneumata"
      },
      {
        "char": "҇",
        "unicode": "0487",
        "fr": "Combining cyrillic pokrytie",
        "en": "Combining cyrillic pokrytie"
      },
      {
        "char": "҈",
        "unicode": "0488",
        "fr": "Combining cyrillic hundred thousands sign",
        "en": "Combining cyrillic hundred thousands sign"
      },
      {
        "char": "҉",
        "unicode": "0489",
        "fr": "Combining cyrillic millions sign",
        "en": "Combining cyrillic millions sign"
      },
      {
        "char": "Ҋ",
        "unicode": "048A",
        "fr": "Short I with tail majuscule",
        "en": "Cyrillic capital letter short i with tail"
      },
      {
        "char": "ҋ",
        "unicode": "048B",
        "fr": "Short I with tail minuscule",
        "en": "Cyrillic small letter short i with tail"
      },
      {
        "char": "Ҍ",
        "unicode": "048C",
        "fr": "Semisoft sign majuscule",
        "en": "Cyrillic capital letter semisoft sign"
      },
      {
        "char": "ҍ",
        "unicode": "048D",
        "fr": "Semisoft sign minuscule",
        "en": "Cyrillic small letter semisoft sign"
      },
      {
        "char": "Ҏ",
        "unicode": "048E",
        "fr": "Er with tick majuscule",
        "en": "Cyrillic capital letter er with tick"
      },
      {
        "char": "ҏ",
        "unicode": "048F",
        "fr": "Er with tick minuscule",
        "en": "Cyrillic small letter er with tick"
      },
      {
        "char": "Ґ",
        "unicode": "0490",
        "fr": "Ghe upturn majuscule",
        "en": "Cyrillic capital letter ghe with upturn"
      },
      {
        "char": "ґ",
        "unicode": "0491",
        "fr": "Ghe upturn minuscule",
        "en": "Cyrillic small letter ghe with upturn"
      },
      {
        "char": "Ғ",
        "unicode": "0492",
        "fr": "Ghe stroke majuscule",
        "en": "Cyrillic capital letter ghe with stroke"
      },
      {
        "char": "ғ",
        "unicode": "0493",
        "fr": "Ghe stroke minuscule",
        "en": "Cyrillic small letter ghe with stroke"
      },
      {
        "char": "Ҕ",
        "unicode": "0494",
        "fr": "Ghe middle hook majuscule",
        "en": "Cyrillic capital letter ghe with middle hook"
      },
      {
        "char": "ҕ",
        "unicode": "0495",
        "fr": "Ghe middle hook minuscule",
        "en": "Cyrillic small letter ghe with middle hook"
      },
      {
        "char": "Җ",
        "unicode": "0496",
        "fr": "Zhe descender majuscule",
        "en": "Cyrillic capital letter zhe with descender"
      },
      {
        "char": "җ",
        "unicode": "0497",
        "fr": "Zhe descender minuscule",
        "en": "Cyrillic small letter zhe with descender"
      },
      {
        "char": "Ҙ",
        "unicode": "0498",
        "fr": "Ze descender majuscule",
        "en": "Cyrillic capital letter ze with descender"
      },
      {
        "char": "ҙ",
        "unicode": "0499",
        "fr": "Ze descender minuscule",
        "en": "Cyrillic small letter ze with descender"
      },
      {
        "char": "Қ",
        "unicode": "049A",
        "fr": "Ka descender majuscule",
        "en": "Cyrillic capital letter ka with descender"
      },
      {
        "char": "қ",
        "unicode": "049B",
        "fr": "Ka descender minuscule",
        "en": "Cyrillic small letter ka with descender"
      },
      {
        "char": "Ҝ",
        "unicode": "049C",
        "fr": "Ka vertical stroke majuscule",
        "en": "Cyrillic capital letter ka with vertical stroke"
      },
      {
        "char": "ҝ",
        "unicode": "049D",
        "fr": "Ka vertical stroke minuscule",
        "en": "Cyrillic small letter ka with vertical stroke"
      },
      {
        "char": "Ҟ",
        "unicode": "049E",
        "fr": "Ka stroke majuscule",
        "en": "Cyrillic capital letter ka with stroke"
      },
      {
        "char": "ҟ",
        "unicode": "049F",
        "fr": "Ka stroke minuscule",
        "en": "Cyrillic small letter ka with stroke"
      },
      {
        "char": "Ҡ",
        "unicode": "04A0",
        "fr": "Bashkir ka majuscule",
        "en": "Cyrillic capital letter bashkir ka"
      },
      {
        "char": "ҡ",
        "unicode": "04A1",
        "fr": "Bashkir ka minuscule",
        "en": "Cyrillic small letter bashkir ka"
      },
      {
        "char": "Ң",
        "unicode": "04A2",
        "fr": "En descender majuscule",
        "en": "Cyrillic capital letter en with descender"
      },
      {
        "char": "ң",
        "unicode": "04A3",
        "fr": "En descender minuscule",
        "en": "Cyrillic small letter en with descender"
      },
      {
        "char": "Ҥ",
        "unicode": "04A4",
        "fr": "Lje majuscule",
        "en": "Cyrillic capital ligature en ghe"
      },
      {
        "char": "ҥ",
        "unicode": "04A5",
        "fr": "Lje minuscule",
        "en": "Cyrillic small ligature en ghe"
      },
      {
        "char": "Ҧ",
        "unicode": "04A6",
        "fr": "Pe middle hook majuscule",
        "en": "Cyrillic capital letter pe with middle hook"
      },
      {
        "char": "ҧ",
        "unicode": "04A7",
        "fr": "Pe middle hook minuscule",
        "en": "Cyrillic small letter pe with middle hook"
      },
      {
        "char": "Ҩ",
        "unicode": "04A8",
        "fr": "Abkhasian ha majuscule",
        "en": "Cyrillic capital letter abkhasian ha"
      },
      {
        "char": "ҩ",
        "unicode": "04A9",
        "fr": "Abkhasian ha minuscule",
        "en": "Cyrillic small letter abkhasian ha"
      },
      {
        "char": "Ҫ",
        "unicode": "04AA",
        "fr": "Es descender majuscule",
        "en": "Cyrillic capital letter es with descender"
      },
      {
        "char": "ҫ",
        "unicode": "04AB",
        "fr": "Es descender minuscule",
        "en": "Cyrillic small letter es with descender"
      },
      {
        "char": "Ҭ",
        "unicode": "04AC",
        "fr": "Te descender majuscule",
        "en": "Cyrillic capital letter te with descender"
      },
      {
        "char": "ҭ",
        "unicode": "04AD",
        "fr": "Te descender minuscule",
        "en": "Cyrillic small letter te with descender"
      },
      {
        "char": "Ү",
        "unicode": "04AE",
        "fr": "Ue majuscule",
        "en": "Cyrillic capital letter ue"
      },
      {
        "char": "ү",
        "unicode": "04AF",
        "fr": "Ue minuscule",
        "en": "Cyrillic small letter ue"
      },
      {
        "char": "Ұ",
        "unicode": "04B0",
        "fr": "Straight u majuscule",
        "en": "Cyrillic capital letter straight u"
      },
      {
        "char": "ұ",
        "unicode": "04B1",
        "fr": "Straight u minuscule",
        "en": "Cyrillic small letter straight u"
      },
      {
        "char": "Ҳ",
        "unicode": "04B2",
        "fr": "Ha descender majuscule",
        "en": "Cyrillic capital letter ha with descender"
      },
      {
        "char": "ҳ",
        "unicode": "04B3",
        "fr": "Ha descender minuscule",
        "en": "Cyrillic small letter ha with descender"
      },
      {
        "char": "Ҵ",
        "unicode": "04B4",
        "fr": "Che descender majuscule",
        "en": "Cyrillic capital letter che with descender"
      },
      {
        "char": "ҵ",
        "unicode": "04B5",
        "fr": "Che descender minuscule",
        "en": "Cyrillic small letter che with descender"
      },
      {
        "char": "Ҷ",
        "unicode": "04B6",
        "fr": "Che vertical stroke majuscule",
        "en": "Cyrillic capital letter che with vertical stroke"
      },
      {
        "char": "ҷ",
        "unicode": "04B7",
        "fr": "Che vertical stroke minuscule",
        "en": "Cyrillic small letter che with vertical stroke"
      },
      {
        "char": "Ҹ",
        "unicode": "04B8",
        "fr": "Che stroke majuscule",
        "en": "Cyrillic capital letter che with stroke"
      },
      {
        "char": "ҹ",
        "unicode": "04B9",
        "fr": "Che stroke minuscule",
        "en": "Cyrillic small letter che with stroke"
      },
      {
        "char": "Һ",
        "unicode": "04BA",
        "fr": "Shha majuscule",
        "en": "Cyrillic capital letter shha"
      },
      {
        "char": "һ",
        "unicode": "04BB",
        "fr": "Shha minuscule",
        "en": "Cyrillic small letter shha"
      },
      {
        "char": "Ҽ",
        "unicode": "04BC",
        "fr": "Abkhasian che majuscule",
        "en": "Cyrillic capital letter abkhasian che"
      },
      {
        "char": "ҽ",
        "unicode": "04BD",
        "fr": "Abkhasian che minuscule",
        "en": "Cyrillic small letter abkhasian che"
      },
      {
        "char": "Ҿ",
        "unicode": "04BE",
        "fr": "Abkhasian che descender majuscule",
        "en": "Cyrillic capital letter abkhasian che with descender"
      },
      {
        "char": "ҿ",
        "unicode": "04BF",
        "fr": "Abkhasian che descender minuscule",
        "en": "Cyrillic small letter abkhasian che with descender"
      },
      {
        "char": "Ӏ",
        "unicode": "04C0",
        "fr": "Palochka",
        "en": "Cyrillic letter palochka"
      },
      {
        "char": "Ӂ",
        "unicode": "04C1",
        "fr": "Zhe breve majuscule",
        "en": "Cyrillic capital letter zhe with breve"
      },
      {
        "char": "ӂ",
        "unicode": "04C2",
        "fr": "Zhe breve minuscule",
        "en": "Cyrillic small letter zhe with breve"
      },
      {
        "char": "Ӄ",
        "unicode": "04C3",
        "fr": "Ka hook majuscule",
        "en": "Cyrillic capital letter ka with hook"
      },
      {
        "char": "ӄ",
        "unicode": "04C4",
        "fr": "Ka hook minuscule",
        "en": "Cyrillic small letter ka with hook"
      },
      {
        "char": "Ӆ",
        "unicode": "04C5",
        "fr": "El tail majuscule",
        "en": "Cyrillic capital letter el with tail"
      },
      {
        "char": "ӆ",
        "unicode": "04C6",
        "fr": "El tail minuscule",
        "en": "Cyrillic small letter el with tail"
      },
      {
        "char": "Ӈ",
        "unicode": "04C7",
        "fr": "En hook majuscule",
        "en": "Cyrillic capital letter en with hook"
      },
      {
        "char": "ӈ",
        "unicode": "04C8",
        "fr": "En hook minuscule",
        "en": "Cyrillic small letter en with hook"
      },
      {
        "char": "Ӊ",
        "unicode": "04C9",
        "fr": "En tail majuscule",
        "en": "Cyrillic capital letter en with tail"
      },
      {
        "char": "ӊ",
        "unicode": "04CA",
        "fr": "En tail minuscule",
        "en": "Cyrillic small letter en with tail"
      },
      {
        "char": "Ӌ",
        "unicode": "04CB",
        "fr": "Che tail majuscule",
        "en": "Cyrillic capital letter che with tail"
      },
      {
        "char": "ӌ",
        "unicode": "04CC",
        "fr": "Che tail minuscule",
        "en": "Cyrillic small letter che with tail"
      },
      {
        "char": "Ӎ",
        "unicode": "04CD",
        "fr": "Em tail majuscule",
        "en": "Cyrillic capital letter em with tail"
      },
      {
        "char": "ӎ",
        "unicode": "04CE",
        "fr": "Em tail minuscule",
        "en": "Cyrillic small letter em with tail"
      },
      {
        "char": "ӏ",
        "unicode": "04CF",
        "fr": "Palochka minuscule",
        "en": "Cyrillic small letter palochka"
      },
      {
        "char": "Ӑ",
        "unicode": "04D0",
        "fr": "A breve majuscule",
        "en": "Cyrillic capital letter a with breve"
      },
      {
        "char": "ӑ",
        "unicode": "04D1",
        "fr": "A breve minuscule",
        "en": "Cyrillic small letter a with breve"
      },
      {
        "char": "Ӓ",
        "unicode": "04D2",
        "fr": "A tréma majuscule",
        "en": "Cyrillic capital letter a with diaeresis"
      },
      {
        "char": "ӓ",
        "unicode": "04D3",
        "fr": "A tréma minuscule",
        "en": "Cyrillic small letter a with diaeresis"
      },
      {
        "char": "Ӕ",
        "unicode": "04D4",
        "fr": "Ae majuscule",
        "en": "Cyrillic capital ligature a ie"
      },
      {
        "char": "ӕ",
        "unicode": "04D5",
        "fr": "Ae minuscule",
        "en": "Cyrillic small ligature a ie"
      },
      {
        "char": "Ӗ",
        "unicode": "04D6",
        "fr": "Ie breve majuscule",
        "en": "Cyrillic capital letter ie with breve"
      },
      {
        "char": "ӗ",
        "unicode": "04D7",
        "fr": "Ie breve minuscule",
        "en": "Cyrillic small letter ie with breve"
      },
      {
        "char": "Ә",
        "unicode": "04D8",
        "fr": "Schwa majuscule",
        "en": "Cyrillic capital letter schwa"
      },
      {
        "char": "ә",
        "unicode": "04D9",
        "fr": "Schwa minuscule",
        "en": "Cyrillic small letter schwa"
      },
      {
        "char": "Ӛ",
        "unicode": "04DA",
        "fr": "Schwa diaeresis majuscule",
        "en": "Cyrillic capital letter schwa with diaeresis"
      },
      {
        "char": "ӛ",
        "unicode": "04DB",
        "fr": "Schwa diaeresis minuscule",
        "en": "Cyrillic small letter schwa with diaeresis"
      },
      {
        "char": "Ӝ",
        "unicode": "04DC",
        "fr": "Zhe diaeresis majuscule",
        "en": "Cyrillic capital letter zhe with diaeresis"
      },
      {
        "char": "ӝ",
        "unicode": "04DD",
        "fr": "Zhe diaeresis minuscule",
        "en": "Cyrillic small letter zhe with diaeresis"
      },
      {
        "char": "Ӟ",
        "unicode": "04DE",
        "fr": "Ze diaeresis majuscule",
        "en": "Cyrillic capital letter ze with diaeresis"
      },
      {
        "char": "ӟ",
        "unicode": "04DF",
        "fr": "Ze diaeresis minuscule",
        "en": "Cyrillic small letter ze with diaeresis"
      },
      {
        "char": "Ӡ",
        "unicode": "04E0",
        "fr": "Abkhasian dze majuscule",
        "en": "Cyrillic capital letter abkhasian dze"
      },
      {
        "char": "ӡ",
        "unicode": "04E1",
        "fr": "Abkhasian dze minuscule",
        "en": "Cyrillic small letter abkhasian dze"
      },
      {
        "char": "Ӣ",
        "unicode": "04E2",
        "fr": "I macron majuscule",
        "en": "Cyrillic capital letter i with macron"
      },
      {
        "char": "ӣ",
        "unicode": "04E3",
        "fr": "I macron minuscule",
        "en": "Cyrillic small letter i with macron"
      },
      {
        "char": "Ӥ",
        "unicode": "04E4",
        "fr": "I diaeresis majuscule",
        "en": "Cyrillic capital letter i with diaeresis"
      },
      {
        "char": "ӥ",
        "unicode": "04E5",
        "fr": "I diaeresis minuscule",
        "en": "Cyrillic small letter i with diaeresis"
      },
      {
        "char": "Ӧ",
        "unicode": "04E6",
        "fr": "O diaeresis majuscule",
        "en": "Cyrillic capital letter o with diaeresis"
      },
      {
        "char": "ӧ",
        "unicode": "04E7",
        "fr": "O diaeresis minuscule",
        "en": "Cyrillic small letter o with diaeresis"
      },
      {
        "char": "Ө",
        "unicode": "04E8",
        "fr": "Barred o majuscule",
        "en": "Cyrillic capital letter barred o"
      },
      {
        "char": "ө",
        "unicode": "04E9",
        "fr": "Barred o minuscule",
        "en": "Cyrillic small letter barred o"
      },
      {
        "char": "Ӫ",
        "unicode": "04EA",
        "fr": "Barred o diaeresis majuscule",
        "en": "Cyrillic capital letter barred o with diaeresis"
      },
      {
        "char": "ӫ",
        "unicode": "04EB",
        "fr": "Barred o diaeresis minuscule",
        "en": "Cyrillic small letter barred o with diaeresis"
      },
      {
        "char": "Ӭ",
        "unicode": "04EC",
        "fr": "E diaeresis majuscule",
        "en": "Cyrillic capital letter e with diaeresis"
      },
      {
        "char": "ӭ",
        "unicode": "04ED",
        "fr": "E diaeresis minuscule",
        "en": "Cyrillic small letter e with diaeresis"
      },
      {
        "char": "Ӯ",
        "unicode": "04EE",
        "fr": "U macron majuscule",
        "en": "Cyrillic capital letter u with macron"
      },
      {
        "char": "ӯ",
        "unicode": "04EF",
        "fr": "U macron minuscule",
        "en": "Cyrillic small letter u with macron"
      },
      {
        "char": "Ӱ",
        "unicode": "04F0",
        "fr": "U diaeresis majuscule",
        "en": "Cyrillic capital letter u with diaeresis"
      },
      {
        "char": "ӱ",
        "unicode": "04F1",
        "fr": "U diaeresis minuscule",
        "en": "Cyrillic small letter u with diaeresis"
      },
      {
        "char": "Ӳ",
        "unicode": "04F2",
        "fr": "U double acute majuscule",
        "en": "Cyrillic capital letter u with double acute"
      },
      {
        "char": "ӳ",
        "unicode": "04F3",
        "fr": "U double acute minuscule",
        "en": "Cyrillic small letter u with double acute"
      },
      {
        "char": "Ӵ",
        "unicode": "04F4",
        "fr": "Che diaeresis majuscule",
        "en": "Cyrillic capital letter che with diaeresis"
      },
      {
        "char": "ӵ",
        "unicode": "04F5",
        "fr": "Che diaeresis minuscule",
        "en": "Cyrillic small letter che with diaeresis"
      },
      {
        "char": "Ӷ",
        "unicode": "04F6",
        "fr": "Ghe with descender majuscule",
        "en": "Cyrillic capital letter ghe with descender"
      },
      {
        "char": "ӷ",
        "unicode": "04F7",
        "fr": "Ghe with descender minuscule",
        "en": "Cyrillic small letter ghe with descender"
      },
      {
        "char": "Ӹ",
        "unicode": "04F8",
        "fr": "Yeru diaeresis majuscule",
        "en": "Cyrillic capital letter yeru with diaeresis"
      },
      {
        "char": "ӹ",
        "unicode": "04F9",
        "fr": "Yeru diaeresis minuscule",
        "en": "Cyrillic small letter yeru with diaeresis"
      },
      {
        "char": "Ӻ",
        "unicode": "04FA",
        "fr": "Oe majuscule",
        "en": "Cyrillic capital letter oe"
      },
      {
        "char": "ӻ",
        "unicode": "04FB",
        "fr": "Oe minuscule",
        "en": "Cyrillic small letter oe"
      },
      {
        "char": "Ӽ",
        "unicode": "04FC",
        "fr": "Ha with hook majuscule",
        "en": "Cyrillic capital letter ha with hook"
      },
      {
        "char": "ӽ",
        "unicode": "04FD",
        "fr": "Ha with hook minuscule",
        "en": "Cyrillic small letter ha with hook"
      },
      {
        "char": "Ӿ",
        "unicode": "04FE",
        "fr": "Ha with descender majuscule",
        "en": "Cyrillic capital letter ha with descender"
      },
      {
        "char": "ӿ",
        "unicode": "04FF",
        "fr": "Ha with descender minuscule",
        "en": "Cyrillic small letter ha with descender"
      }
    ]
  },
  {
    "name": "hebrew",
    "fr": "Hébreu",
    "en": "Hebrew",
    "characters": [
      {
        "char": "ְ",
        "unicode": "05B0",
        "fr": "Sheva",
        "en": "Hebrew point sheva"
      },
      {
        "char": "ֱ",
        "unicode": "05B1",
        "fr": "Hatef segol",
        "en": "Hebrew point hatef segol"
      },
      {
        "char": "ֲ",
        "unicode": "05B2",
        "fr": "Hatef patah",
        "en": "Hebrew point hatef patah"
      },
      {
        "char": "ֳ",
        "unicode": "05B3",
        "fr": "Hatef qamats",
        "en": "Hebrew point hatef qamats"
      },
      {
        "char": "ִ",
        "unicode": "05B4",
        "fr": "Hiriq",
        "en": "Hebrew point hiriq"
      },
      {
        "char": "ֵ",
        "unicode": "05B5",
        "fr": "Tsere",
        "en": "Hebrew point tsere"
      },
      {
        "char": "ֶ",
        "unicode": "05B6",
        "fr": "Segol",
        "en": "Hebrew point segol"
      },
      {
        "char": "ַ",
        "unicode": "05B7",
        "fr": "Patah",
        "en": "Hebrew point patah"
      },
      {
        "char": "ָ",
        "unicode": "05B8",
        "fr": "Qamats",
        "en": "Hebrew point qamats"
      },
      {
        "char": "ֹ",
        "unicode": "05B9",
        "fr": "Holam",
        "en": "Hebrew point holam"
      },
      {
        "char": "ֺ",
        "unicode": "05BA",
        "fr": "Holam haser for vav",
        "en": "Hebrew point holam haser for vav"
      },
      {
        "char": "ֻ",
        "unicode": "05BB",
        "fr": "Qubuts",
        "en": "Hebrew point qubuts"
      },
      {
        "char": "ּ",
        "unicode": "05BC",
        "fr": "Dagesh ou mappiq",
        "en": "Hebrew point dagesh or mappiq"
      },
      {
        "char": "ֽ",
        "unicode": "05BD",
        "fr": "Meteg",
        "en": "Hebrew point meteg"
      },
      {
        "char": "־",
        "unicode": "05BE",
        "fr": "Maqaf",
        "en": "Hebrew punctuation maqaf"
      },
      {
        "char": "ֿ",
        "unicode": "05BF",
        "fr": "Rafe",
        "en": "Hebrew point rafe"
      },
      {
        "char": "׀",
        "unicode": "05C0",
        "fr": "Paseq",
        "en": "Hebrew punctuation paseq"
      },
      {
        "char": "ׁ",
        "unicode": "05C1",
        "fr": "Shin dot",
        "en": "Hebrew point shin dot"
      },
      {
        "char": "ׂ",
        "unicode": "05C2",
        "fr": "Sin dot",
        "en": "Hebrew point sin dot"
      },
      {
        "char": "׃",
        "unicode": "05C3",
        "fr": "Sof pasuq",
        "en": "Hebrew punctuation sof pasuq"
      },
      {
        "char": "ׄ",
        "unicode": "05C4",
        "fr": "Upper dot",
        "en": "Hebrew mark upper dot"
      },
      {
        "char": "ׅ",
        "unicode": "05C5",
        "fr": "Lower dot",
        "en": "Hebrew mark lower dot"
      },
      {
        "char": "׆",
        "unicode": "05C6",
        "fr": "signe yod",
        "en": "Hebrew punctuation yod"
      },
      {
        "char": "ׇ",
        "unicode": "05C7",
        "fr": "Qamats qatan",
        "en": "Hebrew point qamats qatan"
      },
      {
        "char": "א",
        "unicode": "05D0",
        "fr": "Aleph",
        "en": "Hebrew letter Alef"
      },
      {
        "char": "ב",
        "unicode": "05D1",
        "fr": "Beth",
        "en": "Hebrew letter Bet"
      },
      {
        "char": "ג",
        "unicode": "05D2",
        "fr": "Gimel",
        "en": "Hebrew letter Gimel"
      },
      {
        "char": "ד",
        "unicode": "05D3",
        "fr": "Daleth",
        "en": "Hebrew letter Dalet"
      },
      { "char": "ה", "unicode": "05D4", "fr": "He", "en": "Hebrew letter He" },
      {
        "char": "ו",
        "unicode": "05D5",
        "fr": "Vav",
        "en": "Hebrew letter Vav"
      },
      {
        "char": "ז",
        "unicode": "05D6",
        "fr": "Zayin",
        "en": "Hebrew letter Zayin"
      },
      {
        "char": "ח",
        "unicode": "05D7",
        "fr": "Heth",
        "en": "Hebrew letter Het"
      },
      {
        "char": "ט",
        "unicode": "05D8",
        "fr": "Teth",
        "en": "Hebrew letter Tet"
      },
      {
        "char": "י",
        "unicode": "05D9",
        "fr": "Yod",
        "en": "Hebrew letter Yod"
      },
      {
        "char": "כ",
        "unicode": "05DB",
        "fr": "Kaph",
        "en": "Hebrew letter Kaf"
      },
      {
        "char": "ך",
        "unicode": "05DA",
        "fr": "Kaph final",
        "en": "Hebrew letter Final Kaf"
      },
      {
        "char": "ל",
        "unicode": "05DC",
        "fr": "Lamed",
        "en": "Hebrew letter Lamed"
      },
      {
        "char": "מ",
        "unicode": "05DE",
        "fr": "Mem",
        "en": "Hebrew letter Mem"
      },
      {
        "char": "ם",
        "unicode": "05DD",
        "fr": "Mem final",
        "en": "Hebrew letter Final Mem"
      },
      {
        "char": "נ",
        "unicode": "05E0",
        "fr": "Nun",
        "en": "Hebrew letter Nun"
      },
      {
        "char": "ן",
        "unicode": "05DF",
        "fr": "Nun final",
        "en": "Hebrew letter Final Nun"
      },
      {
        "char": "ס",
        "unicode": "05E1",
        "fr": "Samekh",
        "en": "Hebrew letter Samekh"
      },
      {
        "char": "ע",
        "unicode": "05E2",
        "fr": "Ayin",
        "en": "Hebrew letter Ayin"
      },
      { "char": "פ", "unicode": "05E4", "fr": "Pe", "en": "Hebrew letter Pe" },
      {
        "char": "ף",
        "unicode": "05E3",
        "fr": "Pe final",
        "en": "Hebrew letter Final Pe"
      },
      {
        "char": "צ",
        "unicode": "05E6",
        "fr": "Tsade",
        "en": "Hebrew letter Tsadi"
      },
      {
        "char": "ץ",
        "unicode": "05E5",
        "fr": "Tsade final",
        "en": "Hebrew letter Final Tsadi"
      },
      {
        "char": "ק",
        "unicode": "05E7",
        "fr": "Qoph",
        "en": "Hebrew letter Qof"
      },
      {
        "char": "ר",
        "unicode": "05E8",
        "fr": "Resh",
        "en": "Hebrew letter Resh"
      },
      {
        "char": "ש",
        "unicode": "05E9",
        "fr": "Shin",
        "en": "Hebrew letter Shin"
      },
      {
        "char": "ת",
        "unicode": "05EA",
        "fr": "Tav",
        "en": "Hebrew letter Tav"
      },

      {
        "char": "װ",
        "unicode": "05F0",
        "fr": "Hébreu ligature double vav Yiddish",
        "en": "Hebrew ligature Yiddish double vav"
      },
      {
        "char": "ױ",
        "unicode": "05F1",
        "fr": "Hébreu ligature vav yod Yiddish",
        "en": "Hebrew ligature Yiddish vav yod"
      },
      {
        "char": "ײ",
        "unicode": "05F2",
        "fr": "Hébreu ligature double yod Yiddish",
        "en": "Hebrew ligature Yiddish double yod"
      },
      {
        "char": "׳",
        "unicode": "05F3",
        "fr": "Guillemet hébreu simple (geresh)",
        "en": "Hebrew punctuation geresh"
      },
      {
        "char": "״",
        "unicode": "05F4",
        "fr": "Guillemet hébreu double (gershayim)",
        "en": "Hebrew punctuation gershayim"
      }
    ]
  },
  {
    "name": "arabic",
    "fr": "Arabe",
    "en": "Arabic",
    "characters": [
      {
        "char": "ء",
        "unicode": "0621",
        "fr": "Hamza",
        "en": "Arabic letter hamza"
      },
      {
        "char": "آ",
        "unicode": "0622",
        "fr": "Alif madda",
        "en": "Arabic letter alef with madda above"
      },
      {
        "char": "أ",
        "unicode": "0623",
        "fr": "Alif hamza suscrite",
        "en": "Arabic letter alef with hamza above"
      },
      {
        "char": "ؤ",
        "unicode": "0624",
        "fr": "Waw hamza",
        "en": "Arabic letter waw with hamza above"
      },
      {
        "char": "إ",
        "unicode": "0625",
        "fr": "Alif hamza souscrite",
        "en": "Arabic letter alef with hamza below"
      },
      {
        "char": "ئ",
        "unicode": "0626",
        "fr": "Yeh hamza",
        "en": "Arabic letter yeh with hamza above"
      },
      {
        "char": "ا",
        "unicode": "0627",
        "fr": "Alif",
        "en": "Arabic letter alef"
      },
      { "char": "ب", "unicode": "0628", "fr": "Ba", "en": "Arabic letter beh" },
      {
        "char": "ة",
        "unicode": "0629",
        "fr": "Ta marbuta",
        "en": "Arabic letter teh marbuta"
      },
      { "char": "ت", "unicode": "062A", "fr": "Ta", "en": "Arabic letter teh" },
      {
        "char": "ث",
        "unicode": "062B",
        "fr": "Tha",
        "en": "Arabic letter theh"
      },
      {
        "char": "ج",
        "unicode": "062C",
        "fr": "Jim",
        "en": "Arabic letter jeem"
      },
      { "char": "ح", "unicode": "062D", "fr": "Ha", "en": "Arabic letter hah" },
      {
        "char": "خ",
        "unicode": "062E",
        "fr": "Kha",
        "en": "Arabic letter khah"
      },
      {
        "char": "د",
        "unicode": "062F",
        "fr": "Dal",
        "en": "Arabic letter dal"
      },
      {
        "char": "ذ",
        "unicode": "0630",
        "fr": "Dhal",
        "en": "Arabic letter thal"
      },
      { "char": "ر", "unicode": "0631", "fr": "Ra", "en": "Arabic letter reh" },
      {
        "char": "ز",
        "unicode": "0632",
        "fr": "Zay",
        "en": "Arabic letter zain"
      },
      {
        "char": "س",
        "unicode": "0633",
        "fr": "Sin",
        "en": "Arabic letter seen"
      },
      {
        "char": "ش",
        "unicode": "0634",
        "fr": "Shin",
        "en": "Arabic letter sheen"
      },
      {
        "char": "ص",
        "unicode": "0635",
        "fr": "Sad",
        "en": "Arabic letter sad"
      },
      {
        "char": "ض",
        "unicode": "0636",
        "fr": "Dad",
        "en": "Arabic letter dad"
      },
      {
        "char": "ط",
        "unicode": "0637",
        "fr": "Ta emphatique",
        "en": "Arabic letter tah"
      },
      {
        "char": "ظ",
        "unicode": "0638",
        "fr": "Za emphatique",
        "en": "Arabic letter zah"
      },
      {
        "char": "ع",
        "unicode": "0639",
        "fr": "Ayn",
        "en": "Arabic letter ain"
      },
      {
        "char": "غ",
        "unicode": "063A",
        "fr": "Ghayn",
        "en": "Arabic letter ghain"
      },
      { "char": "ف", "unicode": "0641", "fr": "Fa", "en": "Arabic letter feh" },
      {
        "char": "ق",
        "unicode": "0642",
        "fr": "Qaf",
        "en": "Arabic letter qaf"
      },
      {
        "char": "ك",
        "unicode": "0643",
        "fr": "Kaf",
        "en": "Arabic letter kaf"
      },
      {
        "char": "ل",
        "unicode": "0644",
        "fr": "Lam",
        "en": "Arabic letter lam"
      },
      {
        "char": "م",
        "unicode": "0645",
        "fr": "Mim",
        "en": "Arabic letter meem"
      },
      {
        "char": "ن",
        "unicode": "0646",
        "fr": "Nun",
        "en": "Arabic letter noon"
      },
      { "char": "ه", "unicode": "0647", "fr": "Ha", "en": "Arabic letter heh" },
      {
        "char": "و",
        "unicode": "0648",
        "fr": "Waw",
        "en": "Arabic letter waw"
      },
      {
        "char": "ى",
        "unicode": "0649",
        "fr": "Alif maqsurah",
        "en": "Arabic letter alef maksura"
      },
      { "char": "ي", "unicode": "064A", "fr": "Ya", "en": "Arabic letter yeh" },
      {
        "char": "َ",
        "unicode": "064E",
        "fr": "Fatha",
        "en": "Arabic fathatan"
      },
      {
        "char": "ً",
        "unicode": "064B",
        "fr": "Fathatan",
        "en": "Arabic fathatan"
      },
      { "char": "ُ", "unicode": "064F", "fr": "Damma", "en": "Arabic damma" },
      {
        "char": "ٌ",
        "unicode": "064C",
        "fr": "Dammatan",
        "en": "Arabic dammatan"
      },
      { "char": "ِ", "unicode": "0650", "fr": "Kasra", "en": "Arabic kasra" },
      {
        "char": "ٍ",
        "unicode": "064D",
        "fr": "Kasratan",
        "en": "Arabic kasratan"
      },
      { "char": "ْ", "unicode": "0652", "fr": "Sukun", "en": "Arabic sukun" },
      { "char": "ّ", "unicode": "0651", "fr": "Shadda", "en": "Arabic shadda" },
      {
        "char": "ٰ",
        "unicode": "0670",
        "fr": "Dagger alif",
        "en": "Arabic letter superscript alef"
      },
      {
        "char": "ْ",
        "unicode": "0652",
        "fr": "Sukun (absence de voyelle)",
        "en": "Arabic diacritic sukun"
      },
      {
        "char": "٠",
        "unicode": "0660",
        "fr": "Chiffre arabe zéro",
        "en": "Arabic-Indic Digit Zero"
      },
      {
        "char": "١",
        "unicode": "0661",
        "fr": "Chiffre arabe un",
        "en": "Arabic-Indic Digit One"
      },
      {
        "char": "٢",
        "unicode": "0662",
        "fr": "Chiffre arabe deux",
        "en": "Arabic-Indic Digit Two"
      },
      {
        "char": "٣",
        "unicode": "0663",
        "fr": "Chiffre arabe trois",
        "en": "Arabic-Indic Digit Three"
      },
      {
        "char": "٤",
        "unicode": "0664",
        "fr": "Chiffre arabe quatre",
        "en": "Arabic-Indic Digit Four"
      },
      {
        "char": "٥",
        "unicode": "0665",
        "fr": "Chiffre arabe cinq",
        "en": "Arabic-Indic Digit Five"
      },
      {
        "char": "٦",
        "unicode": "0666",
        "fr": "Chiffre arabe six",
        "en": "Arabic-Indic Digit Six"
      },
      {
        "char": "٧",
        "unicode": "0667",
        "fr": "Chiffre arabe sept",
        "en": "Arabic-Indic Digit Seven"
      },
      {
        "char": "٨",
        "unicode": "0668",
        "fr": "Chiffre arabe huit",
        "en": "Arabic-Indic Digit Eight"
      },
      {
        "char": "٩",
        "unicode": "0669",
        "fr": "Chiffre arabe neuf",
        "en": "Arabic-Indic Digit Nine"
      },
      {
        "char": "۰",
        "unicode": "06F0",
        "fr": "Chiffre arabe étendu zéro",
        "en": "Extended Arabic-Indic Digit Zero"
      },
      {
        "char": "۱",
        "unicode": "06F1",
        "fr": "Chiffre arabe étendu un",
        "en": "Extended Arabic-Indic Digit One"
      },
      {
        "char": "۲",
        "unicode": "06F2",
        "fr": "Chiffre arabe étendu deux",
        "en": "Extended Arabic-Indic Digit Two"
      },
      {
        "char": "۳",
        "unicode": "06F3",
        "fr": "Chiffre arabe étendu trois",
        "en": "Extended Arabic-Indic Digit Three"
      },
      {
        "char": "۴",
        "unicode": "06F4",
        "fr": "Chiffre arabe étendu quatre",
        "en": "Extended Arabic-Indic Digit Four"
      },
      {
        "char": "۵",
        "unicode": "06F5",
        "fr": "Chiffre arabe étendu cinq",
        "en": "Extended Arabic-Indic Digit Five"
      },
      {
        "char": "۶",
        "unicode": "06F6",
        "fr": "Chiffre arabe étendu six",
        "en": "Extended Arabic-Indic Digit Six"
      },
      {
        "char": "۷",
        "unicode": "06F7",
        "fr": "Chiffre arabe étendu sept",
        "en": "Extended Arabic-Indic Digit Seven"
      },
      {
        "char": "۸",
        "unicode": "06F8",
        "fr": "Chiffre arabe étendu huit",
        "en": "Extended Arabic-Indic Digit Eight"
      },
      {
        "char": "۹",
        "unicode": "06F9",
        "fr": "Chiffre arabe étendu neuf",
        "en": "Extended Arabic-Indic Digit Nine"
      }
    ]
  },
  {
    "name": "latin-extended-additional",
    "fr": "Latin étendu additionnel",
    "en": "Latin Extended Additional",
    "characters": [
      {
        "char": "Ḁ",
        "unicode": "1E00",
        "fr": "A majuscule rond souscrit",
        "en": "Latin capital letter A with ring below"
      },
      {
        "char": "ḁ",
        "unicode": "1E01",
        "fr": "A minuscule rond souscrit",
        "en": "Latin small letter a with ring below"
      },
      {
        "char": "Ḃ",
        "unicode": "1E02",
        "fr": "B majuscule point dessus",
        "en": "Latin capital letter B with dot above"
      },
      {
        "char": "ḃ",
        "unicode": "1E03",
        "fr": "B minuscule point dessus",
        "en": "Latin small letter b with dot above"
      },
      {
        "char": "Ḅ",
        "unicode": "1E04",
        "fr": "B majuscule point souscrit",
        "en": "Latin capital letter B with dot below"
      },
      {
        "char": "ḅ",
        "unicode": "1E05",
        "fr": "B minuscule point souscrit",
        "en": "Latin small letter b with dot below"
      },
      {
        "char": "Ḇ",
        "unicode": "1E06",
        "fr": "B majuscule barre",
        "en": "Latin capital letter B with line below"
      },
      {
        "char": "ḇ",
        "unicode": "1E07",
        "fr": "B minuscule barre",
        "en": "Latin small letter b with line below"
      },
      {
        "char": "Ḉ",
        "unicode": "1E08",
        "fr": "C majuscule cédille accent aigu",
        "en": "Latin capital letter C with cedilla and acute"
      },
      {
        "char": "ḉ",
        "unicode": "1E09",
        "fr": "C minuscule cédille accent aigu",
        "en": "Latin small letter c with cedilla and acute"
      },
      {
        "char": "Ḋ",
        "unicode": "1E0A",
        "fr": "D majuscule point dessus",
        "en": "Latin capital letter D with dot above"
      },
      {
        "char": "ḋ",
        "unicode": "1E0B",
        "fr": "D minuscule point dessus",
        "en": "Latin small letter d with dot above"
      },
      {
        "char": "Ḍ",
        "unicode": "1E0C",
        "fr": "D majuscule point souscrit",
        "en": "Latin capital letter D with dot below"
      },
      {
        "char": "ḍ",
        "unicode": "1E0D",
        "fr": "D minuscule point souscrit",
        "en": "Latin small letter d with dot below"
      },
      {
        "char": "Ḏ",
        "unicode": "1E0E",
        "fr": "D majuscule barre",
        "en": "Latin capital letter D with line below"
      },
      {
        "char": "ḏ",
        "unicode": "1E0F",
        "fr": "D minuscule barre",
        "en": "Latin small letter d with line below"
      },
      {
        "char": "Ḑ",
        "unicode": "1E10",
        "fr": "D majuscule cédille",
        "en": "Latin capital letter D with cedilla"
      },
      {
        "char": "ḑ",
        "unicode": "1E11",
        "fr": "D minuscule cédille",
        "en": "Latin small letter d with cedilla"
      },
      {
        "char": "Ḓ",
        "unicode": "1E12",
        "fr": "D majuscule circonflexe souscrit",
        "en": "Latin capital letter D with circumflex below"
      },
      {
        "char": "ḓ",
        "unicode": "1E13",
        "fr": "D minuscule circonflexe souscrit",
        "en": "Latin small letter d with circumflex below"
      },
      {
        "char": "Ḕ",
        "unicode": "1E14",
        "fr": "E majuscule macron grave",
        "en": "Latin capital letter E with macron and grave"
      },
      {
        "char": "ḕ",
        "unicode": "1E15",
        "fr": "E minuscule macron grave",
        "en": "Latin small letter e with macron and grave"
      },
      {
        "char": "Ḗ",
        "unicode": "1E16",
        "fr": "E majuscule macron aigu",
        "en": "Latin capital letter E with macron and acute"
      },
      {
        "char": "ḗ",
        "unicode": "1E17",
        "fr": "E minuscule macron aigu",
        "en": "Latin small letter e with macron and acute"
      },
      {
        "char": "Ḙ",
        "unicode": "1E18",
        "fr": "E majuscule circonflexe souscrit",
        "en": "Latin capital letter E with circumflex below"
      },
      {
        "char": "ḙ",
        "unicode": "1E19",
        "fr": "E minuscule circonflexe souscrit",
        "en": "Latin small letter e with circumflex below"
      },
      {
        "char": "Ḛ",
        "unicode": "1E1A",
        "fr": "E majuscule tilde souscrit",
        "en": "Latin capital letter E with tilde below"
      },
      {
        "char": "ḛ",
        "unicode": "1E1B",
        "fr": "E minuscule tilde souscrit",
        "en": "Latin small letter e with tilde below"
      },
      {
        "char": "Ḝ",
        "unicode": "1E1C",
        "fr": "E majuscule cedille macron",
        "en": "Latin capital letter E with cedilla and breve"
      },
      {
        "char": "ḝ",
        "unicode": "1E1D",
        "fr": "E minuscule cedille macron",
        "en": "Latin small letter e with cedilla and breve"
      },
      {
        "char": "Ḟ",
        "unicode": "1E1E",
        "fr": "F majuscule point dessus",
        "en": "Latin capital letter F with dot above"
      },
      {
        "char": "ḟ",
        "unicode": "1E1F",
        "fr": "F minuscule point dessus",
        "en": "Latin small letter f with dot above"
      },
      {
        "char": "Ḡ",
        "unicode": "1E20",
        "fr": "G majuscule macron",
        "en": "Latin capital letter G with macron"
      },
      {
        "char": "ḡ",
        "unicode": "1E21",
        "fr": "G minuscule macron",
        "en": "Latin small letter g with macron"
      },
      {
        "char": "Ḣ",
        "unicode": "1E22",
        "fr": "H majuscule point dessus",
        "en": "Latin capital letter H with dot above"
      },
      {
        "char": "ḣ",
        "unicode": "1E23",
        "fr": "H minuscule point dessus",
        "en": "Latin small letter h with dot above"
      },
      {
        "char": "Ḥ",
        "unicode": "1E24",
        "fr": "H majuscule point souscrit",
        "en": "Latin capital letter H with dot below"
      },
      {
        "char": "ḥ",
        "unicode": "1E25",
        "fr": "H minuscule point souscrit",
        "en": "Latin small letter h with dot below"
      },
      {
        "char": "Ḧ",
        "unicode": "1E26",
        "fr": "H majuscule tréma",
        "en": "Latin capital letter H with diaeresis"
      },
      {
        "char": "ḧ",
        "unicode": "1E27",
        "fr": "H minuscule tréma",
        "en": "Latin small letter h with diaeresis"
      },
      {
        "char": "Ḩ",
        "unicode": "1E28",
        "fr": "H majuscule cédille",
        "en": "Latin capital letter H with cedilla"
      },
      {
        "char": "ḩ",
        "unicode": "1E29",
        "fr": "H minuscule cédille",
        "en": "Latin small letter h with cedilla"
      },
      {
        "char": "Ḫ",
        "unicode": "1E2A",
        "fr": "H majuscule trait souscrit",
        "en": "Latin capital letter H with breve below"
      },
      {
        "char": "ḫ",
        "unicode": "1E2B",
        "fr": "H minuscule trait souscrit",
        "en": "Latin small letter h with breve below"
      },
      {
        "char": "Ḭ",
        "unicode": "1E2C",
        "fr": "I majuscule tilde souscrit",
        "en": "Latin capital letter I with tilde below"
      },
      {
        "char": "ḭ",
        "unicode": "1E2D",
        "fr": "I minuscule tilde souscrit",
        "en": "Latin small letter i with tilde below"
      },
      {
        "char": "Ḯ",
        "unicode": "1E2E",
        "fr": "I majuscule tréma accent aigu",
        "en": "Latin capital letter I with diaeresis and acute"
      },
      {
        "char": "ḯ",
        "unicode": "1E2F",
        "fr": "I minuscule tréma accent aigu",
        "en": "Latin small letter i with diaeresis and acute"
      },
      {
        "char": "Ḱ",
        "unicode": "1E30",
        "fr": "K majuscule accent aigu",
        "en": "Latin capital letter K with acute"
      },
      {
        "char": "ḱ",
        "unicode": "1E31",
        "fr": "K minuscule accent aigu",
        "en": "Latin small letter k with acute"
      },
      {
        "char": "Ḳ",
        "unicode": "1E32",
        "fr": "K majuscule point souscrit",
        "en": "Latin capital letter K with dot below"
      },
      {
        "char": "ḳ",
        "unicode": "1E33",
        "fr": "K minuscule point souscrit",
        "en": "Latin small letter k with dot below"
      },
      {
        "char": "Ḵ",
        "unicode": "1E34",
        "fr": "K majuscule barre",
        "en": "Latin capital letter K with line below"
      },
      {
        "char": "ḵ",
        "unicode": "1E35",
        "fr": "K minuscule barre",
        "en": "Latin small letter k with line below"
      },
      {
        "char": "Ḷ",
        "unicode": "1E36",
        "fr": "L majuscule point souscrit",
        "en": "Latin capital letter L with dot below"
      },
      {
        "char": "ḷ",
        "unicode": "1E37",
        "fr": "L minuscule point souscrit",
        "en": "Latin small letter l with dot below"
      },
      {
        "char": "Ḹ",
        "unicode": "1E38",
        "fr": "L majuscule point souscrit macron",
        "en": "Latin capital letter L with dot below and macron"
      },
      {
        "char": "ḹ",
        "unicode": "1E39",
        "fr": "L minuscule point souscrit macron",
        "en": "Latin small letter l with dot below and macron"
      },
      {
        "char": "Ḻ",
        "unicode": "1E3A",
        "fr": "L majuscule barre",
        "en": "Latin capital letter L with line below"
      },
      {
        "char": "ḻ",
        "unicode": "1E3B",
        "fr": "L minuscule barre",
        "en": "Latin small letter l with line below"
      },
      {
        "char": "Ḽ",
        "unicode": "1E3C",
        "fr": "L majuscule circonflexe souscrit",
        "en": "Latin capital letter L with circumflex below"
      },
      {
        "char": "ḽ",
        "unicode": "1E3D",
        "fr": "L minuscule circonflexe souscrit",
        "en": "Latin small letter l with circumflex below"
      },
      {
        "char": "Ḿ",
        "unicode": "1E3E",
        "fr": "M majuscule accent aigu",
        "en": "Latin capital letter M with acute"
      },
      {
        "char": "ḿ",
        "unicode": "1E3F",
        "fr": "M minuscule accent aigu",
        "en": "Latin small letter m with acute"
      },
      {
        "char": "Ṁ",
        "unicode": "1E40",
        "fr": "M majuscule point dessus",
        "en": "Latin capital letter M with dot above"
      },
      {
        "char": "ṁ",
        "unicode": "1E41",
        "fr": "M minuscule point dessus",
        "en": "Latin small letter m with dot above"
      },
      {
        "char": "Ṃ",
        "unicode": "1E42",
        "fr": "M majuscule point souscrit",
        "en": "Latin capital letter M with dot below"
      },
      {
        "char": "ṃ",
        "unicode": "1E43",
        "fr": "M minuscule point souscrit",
        "en": "Latin small letter m with dot below"
      },
      {
        "char": "Ṅ",
        "unicode": "1E44",
        "fr": "N majuscule point dessus",
        "en": "Latin capital letter N with dot above"
      },
      {
        "char": "ṅ",
        "unicode": "1E45",
        "fr": "N minuscule point dessus",
        "en": "Latin small letter n with dot above"
      },
      {
        "char": "Ṇ",
        "unicode": "1E46",
        "fr": "N majuscule point souscrit",
        "en": "Latin capital letter N with dot below"
      },
      {
        "char": "ṇ",
        "unicode": "1E47",
        "fr": "N minuscule point souscrit",
        "en": "Latin small letter n with dot below"
      },
      {
        "char": "Ṉ",
        "unicode": "1E48",
        "fr": "N majuscule barre",
        "en": "Latin capital letter N with line below"
      },
      {
        "char": "ṉ",
        "unicode": "1E49",
        "fr": "N minuscule barre",
        "en": "Latin small letter n with line below"
      },
      {
        "char": "Ṋ",
        "unicode": "1E4A",
        "fr": "N majuscule circonflexe souscrit",
        "en": "Latin capital letter N with circumflex below"
      },
      {
        "char": "ṋ",
        "unicode": "1E4B",
        "fr": "N minuscule circonflexe souscrit",
        "en": "Latin small letter n with circumflex below"
      },
      {
        "char": "Ṍ",
        "unicode": "1E4C",
        "fr": "O majuscule tilde accent aigu",
        "en": "Latin capital letter O with tilde and acute"
      },
      {
        "char": "ṍ",
        "unicode": "1E4D",
        "fr": "O minuscule tilde accent aigu",
        "en": "Latin small letter o with tilde and acute"
      },
      {
        "char": "Ṏ",
        "unicode": "1E4E",
        "fr": "O majuscule tilde tréma",
        "en": "Latin capital letter O with tilde and diaeresis"
      },
      {
        "char": "ṏ",
        "unicode": "1E4F",
        "fr": "O minuscule tilde tréma",
        "en": "Latin small letter o with tilde and diaeresis"
      },
      {
        "char": "Ṑ",
        "unicode": "1E50",
        "fr": "O majuscule macron grave",
        "en": "Latin capital letter O with macron and grave"
      },
      {
        "char": "ṑ",
        "unicode": "1E51",
        "fr": "O minuscule macron grave",
        "en": "Latin small letter o with macron and grave"
      },
      {
        "char": "Ṓ",
        "unicode": "1E52",
        "fr": "O majuscule macron aigu",
        "en": "Latin capital letter O with macron and acute"
      },
      {
        "char": "ṓ",
        "unicode": "1E53",
        "fr": "O minuscule macron aigu",
        "en": "Latin small letter o with macron and acute"
      },
      {
        "char": "Ṕ",
        "unicode": "1E54",
        "fr": "P majuscule accent aigu",
        "en": "Latin capital letter P with acute"
      },
      {
        "char": "ṕ",
        "unicode": "1E55",
        "fr": "P minuscule accent aigu",
        "en": "Latin small letter p with acute"
      },
      {
        "char": "Ṗ",
        "unicode": "1E56",
        "fr": "P majuscule point dessus",
        "en": "Latin capital letter P with dot above"
      },
      {
        "char": "ṗ",
        "unicode": "1E57",
        "fr": "P minuscule point dessus",
        "en": "Latin small letter p with dot above"
      },
      {
        "char": "Ṙ",
        "unicode": "1E58",
        "fr": "R majuscule point dessus",
        "en": "Latin capital letter R with dot above"
      },
      {
        "char": "ṙ",
        "unicode": "1E59",
        "fr": "R minuscule point dessus",
        "en": "Latin small letter r with dot above"
      },
      {
        "char": "Ṛ",
        "unicode": "1E5A",
        "fr": "R majuscule point souscrit",
        "en": "Latin capital letter R with dot below"
      },
      {
        "char": "ṛ",
        "unicode": "1E5B",
        "fr": "R minuscule point souscrit",
        "en": "Latin small letter r with dot below"
      },
      {
        "char": "Ṝ",
        "unicode": "1E5C",
        "fr": "R majuscule point souscrit macron",
        "en": "Latin capital letter R with dot below and macron"
      },
      {
        "char": "ṝ",
        "unicode": "1E5D",
        "fr": "R minuscule point souscrit macron",
        "en": "Latin small letter r with dot below and macron"
      },
      {
        "char": "Ṟ",
        "unicode": "1E5E",
        "fr": "R majuscule barre",
        "en": "Latin capital letter R with line below"
      },
      {
        "char": "ṟ",
        "unicode": "1E5F",
        "fr": "R minuscule barre",
        "en": "Latin small letter r with line below"
      },
      {
        "char": "Ṡ",
        "unicode": "1E60",
        "fr": "S majuscule point dessus",
        "en": "Latin capital letter S with dot above"
      },
      {
        "char": "ṡ",
        "unicode": "1E61",
        "fr": "S minuscule point dessus",
        "en": "Latin small letter s with dot above"
      },
      {
        "char": "Ṣ",
        "unicode": "1E62",
        "fr": "S majuscule point souscrit",
        "en": "Latin capital letter S with dot below"
      },
      {
        "char": "ṣ",
        "unicode": "1E63",
        "fr": "S minuscule point souscrit",
        "en": "Latin small letter s with dot below"
      },
      {
        "char": "Ṥ",
        "unicode": "1E64",
        "fr": "S majuscule accent aigu point dessus",
        "en": "Latin capital letter S with acute and dot above"
      },
      {
        "char": "ṥ",
        "unicode": "1E65",
        "fr": "S minuscule accent aigu point dessus",
        "en": "Latin small letter s with acute and dot above"
      },
      {
        "char": "Ṧ",
        "unicode": "1E66",
        "fr": "S majuscule tilde point dessus",
        "en": "Latin capital letter S with caron and dot above"
      },
      {
        "char": "ṧ",
        "unicode": "1E67",
        "fr": "S minuscule tilde point dessus",
        "en": "Latin small letter s with caron and dot above"
      },
      {
        "char": "Ṩ",
        "unicode": "1E68",
        "fr": "S majuscule point dessus point souscrit",
        "en": "Latin capital letter S with dot below and dot above"
      },
      {
        "char": "ṩ",
        "unicode": "1E69",
        "fr": "S minuscule point dessus point souscrit",
        "en": "Latin small letter s with dot below and dot above"
      },
      {
        "char": "Ṫ",
        "unicode": "1E6A",
        "fr": "T majuscule point dessus",
        "en": "Latin capital letter T with dot above"
      },
      {
        "char": "ṫ",
        "unicode": "1E6B",
        "fr": "T minuscule point dessus",
        "en": "Latin small letter t with dot above"
      },
      {
        "char": "Ṭ",
        "unicode": "1E6C",
        "fr": "T majuscule point souscrit",
        "en": "Latin capital letter T with dot below"
      },
      {
        "char": "ṭ",
        "unicode": "1E6D",
        "fr": "T minuscule point souscrit",
        "en": "Latin small letter t with dot below"
      },
      {
        "char": "Ṯ",
        "unicode": "1E6E",
        "fr": "T majuscule barre",
        "en": "Latin capital letter T with line below"
      },
      {
        "char": "ṯ",
        "unicode": "1E6F",
        "fr": "T minuscule barre",
        "en": "Latin small letter t with line below"
      },
      {
        "char": "Ṱ",
        "unicode": "1E70",
        "fr": "T majuscule circonflexe souscrit",
        "en": "Latin capital letter T with circumflex below"
      },
      {
        "char": "ṱ",
        "unicode": "1E71",
        "fr": "T minuscule circonflexe souscrit",
        "en": "Latin small letter t with circumflex below"
      },
      {
        "char": "Ṳ",
        "unicode": "1E72",
        "fr": "U majuscule tilde souscrit",
        "en": "Latin capital letter U with tilde below"
      },
      {
        "char": "ṳ",
        "unicode": "1E73",
        "fr": "U minuscule tilde souscrit",
        "en": "Latin small letter u with tilde below"
      },
      {
        "char": "Ṵ",
        "unicode": "1E74",
        "fr": "U majuscule circonflexe souscrit",
        "en": "Latin capital letter U with circumflex below"
      },
      {
        "char": "ṵ",
        "unicode": "1E75",
        "fr": "U minuscule circonflexe souscrit",
        "en": "Latin small letter u with circumflex below"
      },
      {
        "char": "Ṷ",
        "unicode": "1E76",
        "fr": "U majuscule rond souscrit",
        "en": "Latin capital letter U with tilde below"
      },
      {
        "char": "ṷ",
        "unicode": "1E77",
        "fr": "U minuscule rond souscrit",
        "en": "Latin small letter u with tilde below"
      },
      {
        "char": "Ṹ",
        "unicode": "1E78",
        "fr": "U majuscule tilde accent aigu",
        "en": "Latin capital letter U with tilde and acute"
      },
      {
        "char": "ṹ",
        "unicode": "1E79",
        "fr": "U minuscule tilde accent aigu",
        "en": "Latin small letter u with tilde and acute"
      },
      {
        "char": "Ṻ",
        "unicode": "1E7A",
        "fr": "U majuscule macron tréma",
        "en": "Latin capital letter U with macron and diaeresis"
      },
      {
        "char": "ṻ",
        "unicode": "1E7B",
        "fr": "U minuscule macron tréma",
        "en": "Latin small letter u with macron and diaeresis"
      },
      {
        "char": "Ṽ",
        "unicode": "1E7C",
        "fr": "V majuscule tilde",
        "en": "Latin capital letter V with tilde"
      },
      {
        "char": "ṽ",
        "unicode": "1E7D",
        "fr": "V minuscule tilde",
        "en": "Latin small letter v with tilde"
      },
      {
        "char": "Ṿ",
        "unicode": "1E7E",
        "fr": "V majuscule point souscrit",
        "en": "Latin capital letter V with dot below"
      },
      {
        "char": "ṿ",
        "unicode": "1E7F",
        "fr": "V minuscule point souscrit",
        "en": "Latin small letter v with dot below"
      },
      {
        "char": "Ẁ",
        "unicode": "1E80",
        "fr": "W majuscule accent grave",
        "en": "Latin capital letter W with grave"
      },
      {
        "char": "ẁ",
        "unicode": "1E81",
        "fr": "W minuscule accent grave",
        "en": "Latin small letter w with grave"
      },
      {
        "char": "Ẃ",
        "unicode": "1E82",
        "fr": "W majuscule accent aigu",
        "en": "Latin capital letter W with acute"
      },
      {
        "char": "ẃ",
        "unicode": "1E83",
        "fr": "W minuscule accent aigu",
        "en": "Latin small letter w with acute"
      },
      {
        "char": "Ẅ",
        "unicode": "1E84",
        "fr": "W majuscule tréma",
        "en": "Latin capital letter W with diaeresis"
      },
      {
        "char": "ẅ",
        "unicode": "1E85",
        "fr": "W minuscule tréma",
        "en": "Latin small letter w with diaeresis"
      },
      {
        "char": "Ẇ",
        "unicode": "1E86",
        "fr": "W majuscule point dessus",
        "en": "Latin capital letter W with dot above"
      },
      {
        "char": "ẇ",
        "unicode": "1E87",
        "fr": "W minuscule point dessus",
        "en": "Latin small letter w with dot above"
      },
      {
        "char": "Ẉ",
        "unicode": "1E88",
        "fr": "W majuscule point souscrit",
        "en": "Latin capital letter W with dot below"
      },
      {
        "char": "ẉ",
        "unicode": "1E89",
        "fr": "W minuscule point souscrit",
        "en": "Latin small letter w with dot below"
      },
      {
        "char": "Ẋ",
        "unicode": "1E8A",
        "fr": "X majuscule point dessus",
        "en": "Latin capital letter X with dot above"
      },
      {
        "char": "ẋ",
        "unicode": "1E8B",
        "fr": "X minuscule point dessus",
        "en": "Latin small letter x with dot above"
      },
      {
        "char": "Ẍ",
        "unicode": "1E8C",
        "fr": "X majuscule tréma",
        "en": "Latin capital letter X with diaeresis"
      },
      {
        "char": "ẍ",
        "unicode": "1E8D",
        "fr": "X minuscule tréma",
        "en": "Latin small letter x with diaeresis"
      },
      {
        "char": "Ẏ",
        "unicode": "1E8E",
        "fr": "Y majuscule point dessus",
        "en": "Latin capital letter Y with dot above"
      },
      {
        "char": "ẏ",
        "unicode": "1E8F",
        "fr": "Y minuscule point dessus",
        "en": "Latin small letter y with dot above"
      },
      {
        "char": "Ẑ",
        "unicode": "1E90",
        "fr": "Z majuscule circonflexe",
        "en": "Latin capital letter Z with circumflex"
      },
      {
        "char": "ẑ",
        "unicode": "1E91",
        "fr": "Z minuscule circonflexe",
        "en": "Latin small letter z with circumflex"
      },
      {
        "char": "Ẓ",
        "unicode": "1E92",
        "fr": "Z majuscule point souscrit",
        "en": "Latin capital letter Z with dot below"
      },
      {
        "char": "ẓ",
        "unicode": "1E93",
        "fr": "Z minuscule point souscrit",
        "en": "Latin small letter z with dot below"
      },
      {
        "char": "Ẕ",
        "unicode": "1E94",
        "fr": "Z majuscule barre",
        "en": "Latin capital letter Z with line below"
      },
      {
        "char": "ẕ",
        "unicode": "1E95",
        "fr": "Z minuscule barre",
        "en": "Latin small letter z with line below"
      },
      {
        "char": "ẖ",
        "unicode": "1E96",
        "fr": "H minuscule barre",
        "en": "Latin small letter h with line below"
      },
      {
        "char": "ẗ",
        "unicode": "1E97",
        "fr": "T minuscule tréma",
        "en": "Latin small letter t with diaeresis"
      },
      {
        "char": "ẘ",
        "unicode": "1E98",
        "fr": "W minuscule rond en chef",
        "en": "Latin small letter w with ring above"
      },
      {
        "char": "ẙ",
        "unicode": "1E99",
        "fr": "Y minuscule rond en chef",
        "en": "Latin small letter y with ring above"
      },
      {
        "char": "ẚ",
        "unicode": "1E9A",
        "fr": "A minuscule accent grave",
        "en": "Latin small letter a with right half ring"
      },
      {
        "char": "ẛ",
        "unicode": "1E9B",
        "fr": "S minuscule point dessus",
        "en": "Latin small letter long s with dot above"
      },
      {
        "char": "ẜ",
        "unicode": "1E9C",
        "fr": "S minuscule crochet",
        "en": "Latin small letter long s with diagonal stroke"
      },
      {
        "char": "ẝ",
        "unicode": "1E9D",
        "fr": "S minuscule crochet",
        "en": "Latin small letter long s with high stroke"
      },
      {
        "char": "ẞ",
        "unicode": "1E9E",
        "fr": "Eszett majuscule",
        "en": "Latin capital letter sharp s"
      },
      {
        "char": "ẟ",
        "unicode": "1E9F",
        "fr": "Delta minuscule",
        "en": "Latin small letter delta"
      },
      {
        "char": "Ạ",
        "unicode": "1EA0",
        "fr": "A majuscule point souscrit",
        "en": "Latin capital letter A with dot below"
      },
      {
        "char": "ạ",
        "unicode": "1EA1",
        "fr": "A minuscule point souscrit",
        "en": "Latin small letter a with dot below"
      },
      {
        "char": "Ả",
        "unicode": "1EA2",
        "fr": "A majuscule crochet en chef",
        "en": "Latin capital letter A with hook above"
      },
      {
        "char": "ả",
        "unicode": "1EA3",
        "fr": "A minuscule crochet en chef",
        "en": "Latin small letter a with hook above"
      },
      {
        "char": "Ấ",
        "unicode": "1EA4",
        "fr": "A majuscule circonflexe accent aigu",
        "en": "Latin capital letter A with circumflex and acute"
      },
      {
        "char": "ấ",
        "unicode": "1EA5",
        "fr": "A minuscule circonflexe accent aigu",
        "en": "Latin small letter a with circumflex and acute"
      },
      {
        "char": "Ầ",
        "unicode": "1EA6",
        "fr": "A majuscule circonflexe accent grave",
        "en": "Latin capital letter A with circumflex and grave"
      },
      {
        "char": "ầ",
        "unicode": "1EA7",
        "fr": "A minuscule circonflexe accent grave",
        "en": "Latin small letter a with circumflex and grave"
      },
      {
        "char": "Ẩ",
        "unicode": "1EA8",
        "fr": "A majuscule circonflexe crochet en chef",
        "en": "Latin capital letter A with circumflex and hook above"
      },
      {
        "char": "ẩ",
        "unicode": "1EA9",
        "fr": "A minuscule circonflexe crochet en chef",
        "en": "Latin small letter a with circumflex and hook above"
      },
      {
        "char": "Ẫ",
        "unicode": "1EAA",
        "fr": "A majuscule circonflexe tilde",
        "en": "Latin capital letter A with circumflex and tilde"
      },
      {
        "char": "ẫ",
        "unicode": "1EAB",
        "fr": "A minuscule circonflexe tilde",
        "en": "Latin small letter a with circumflex and tilde"
      },
      {
        "char": "Ậ",
        "unicode": "1EAC",
        "fr": "A majuscule circonflexe point souscrit",
        "en": "Latin capital letter A with circumflex and dot below"
      },
      {
        "char": "ậ",
        "unicode": "1EAD",
        "fr": "A minuscule circonflexe point souscrit",
        "en": "Latin small letter a with circumflex and dot below"
      },
      {
        "char": "Ắ",
        "unicode": "1EAE",
        "fr": "A majuscule brève accent aigu",
        "en": "Latin capital letter A with breve and acute"
      },
      {
        "char": "ắ",
        "unicode": "1EAF",
        "fr": "A minuscule brève accent aigu",
        "en": "Latin small letter a with breve and acute"
      },
      {
        "char": "Ằ",
        "unicode": "1EB0",
        "fr": "A majuscule brève accent grave",
        "en": "Latin capital letter A with breve and grave"
      },
      {
        "char": "ằ",
        "unicode": "1EB1",
        "fr": "A minuscule brève accent grave",
        "en": "Latin small letter a with breve and grave"
      },
      {
        "char": "Ẳ",
        "unicode": "1EB2",
        "fr": "A majuscule brève crochet en chef",
        "en": "Latin capital letter A with breve and hook above"
      },
      {
        "char": "ẳ",
        "unicode": "1EB3",
        "fr": "A minuscule brève crochet en chef",
        "en": "Latin small letter a with breve and hook above"
      },
      {
        "char": "Ẵ",
        "unicode": "1EB4",
        "fr": "A majuscule brève tilde",
        "en": "Latin capital letter A with breve and tilde"
      },
      {
        "char": "ẵ",
        "unicode": "1EB5",
        "fr": "A minuscule brève tilde",
        "en": "Latin small letter a with breve and tilde"
      },
      {
        "char": "Ặ",
        "unicode": "1EB6",
        "fr": "A majuscule brève point souscrit",
        "en": "Latin capital letter A with breve and dot below"
      },
      {
        "char": "ặ",
        "unicode": "1EB7",
        "fr": "A minuscule brève point souscrit",
        "en": "Latin small letter a with breve and dot below"
      },
      {
        "char": "Ẹ",
        "unicode": "1EB8",
        "fr": "E majuscule point souscrit",
        "en": "Latin capital letter E with dot below"
      },
      {
        "char": "ẹ",
        "unicode": "1EB9",
        "fr": "E minuscule point souscrit",
        "en": "Latin small letter e with dot below"
      },
      {
        "char": "Ẻ",
        "unicode": "1EBA",
        "fr": "E majuscule crochet en chef",
        "en": "Latin capital letter E with hook above"
      },
      {
        "char": "ẻ",
        "unicode": "1EBB",
        "fr": "E minuscule crochet en chef",
        "en": "Latin small letter e with hook above"
      },
      {
        "char": "Ẽ",
        "unicode": "1EBC",
        "fr": "E majuscule tilde",
        "en": "Latin capital letter E with tilde"
      },
      {
        "char": "ẽ",
        "unicode": "1EBD",
        "fr": "E minuscule tilde",
        "en": "Latin small letter e with tilde"
      },
      {
        "char": "Ế",
        "unicode": "1EBE",
        "fr": "E majuscule circonflexe accent aigu",
        "en": "Latin capital letter E with circumflex and acute"
      },
      {
        "char": "ế",
        "unicode": "1EBF",
        "fr": "E minuscule circonflexe accent aigu",
        "en": "Latin small letter e with circumflex and acute"
      },
      {
        "char": "Ề",
        "unicode": "1EC0",
        "fr": "E majuscule circonflexe accent grave",
        "en": "Latin capital letter E with circumflex and grave"
      },
      {
        "char": "ề",
        "unicode": "1EC1",
        "fr": "E minuscule circonflexe accent grave",
        "en": "Latin small letter e with circumflex and grave"
      },
      {
        "char": "Ể",
        "unicode": "1EC2",
        "fr": "E majuscule circonflexe crochet en chef",
        "en": "Latin capital letter E with circumflex and hook above"
      },
      {
        "char": "ể",
        "unicode": "1EC3",
        "fr": "E minuscule circonflexe crochet en chef",
        "en": "Latin small letter e with circumflex and hook above"
      },
      {
        "char": "Ễ",
        "unicode": "1EC4",
        "fr": "E majuscule circonflexe tilde",
        "en": "Latin capital letter E with circumflex and tilde"
      },
      {
        "char": "ễ",
        "unicode": "1EC5",
        "fr": "E minuscule circonflexe tilde",
        "en": "Latin small letter e with circumflex and tilde"
      },
      {
        "char": "Ệ",
        "unicode": "1EC6",
        "fr": "E majuscule circonflexe point souscrit",
        "en": "Latin capital letter E with circumflex and dot below"
      },
      {
        "char": "ệ",
        "unicode": "1EC7",
        "fr": "E minuscule circonflexe point souscrit",
        "en": "Latin small letter e with circumflex and dot below"
      },
      {
        "char": "Ỉ",
        "unicode": "1EC8",
        "fr": "I majuscule crochet en chef",
        "en": "Latin capital letter I with hook above"
      },
      {
        "char": "ỉ",
        "unicode": "1EC9",
        "fr": "I minuscule crochet en chef",
        "en": "Latin small letter i with hook above"
      },
      {
        "char": "Ị",
        "unicode": "1ECA",
        "fr": "I majuscule point souscrit",
        "en": "Latin capital letter I with dot below"
      },
      {
        "char": "ị",
        "unicode": "1ECB",
        "fr": "I minuscule point souscrit",
        "en": "Latin small letter i with dot below"
      },
      {
        "char": "Ọ",
        "unicode": "1ECC",
        "fr": "O majuscule point souscrit",
        "en": "Latin capital letter O with dot below"
      },
      {
        "char": "ọ",
        "unicode": "1ECD",
        "fr": "O minuscule point souscrit",
        "en": "Latin small letter o with dot below"
      },
      {
        "char": "Ỏ",
        "unicode": "1ECE",
        "fr": "O majuscule crochet en chef",
        "en": "Latin capital letter O with hook above"
      },
      {
        "char": "ỏ",
        "unicode": "1ECF",
        "fr": "O minuscule crochet en chef",
        "en": "Latin small letter o with hook above"
      },
      {
        "char": "Ố",
        "unicode": "1ED0",
        "fr": "O majuscule circonflexe accent aigu",
        "en": "Latin capital letter O with circumflex and acute"
      },
      {
        "char": "ố",
        "unicode": "1ED1",
        "fr": "O minuscule circonflexe accent aigu",
        "en": "Latin small letter o with circumflex and acute"
      },
      {
        "char": "Ồ",
        "unicode": "1ED2",
        "fr": "O majuscule circonflexe accent grave",
        "en": "Latin capital letter O with circumflex and grave"
      },
      {
        "char": "ồ",
        "unicode": "1ED3",
        "fr": "O minuscule circonflexe accent grave",
        "en": "Latin small letter o with circumflex and grave"
      },
      {
        "char": "Ổ",
        "unicode": "1ED4",
        "fr": "O majuscule circonflexe crochet en chef",
        "en": "Latin capital letter O with circumflex and hook above"
      },
      {
        "char": "ổ",
        "unicode": "1ED5",
        "fr": "O minuscule circonflexe crochet en chef",
        "en": "Latin small letter o with circumflex and hook above"
      },
      {
        "char": "Ỗ",
        "unicode": "1ED6",
        "fr": "O majuscule circonflexe tilde",
        "en": "Latin capital letter O with circumflex and tilde"
      },
      {
        "char": "ỗ",
        "unicode": "1ED7",
        "fr": "O minuscule circonflexe tilde",
        "en": "Latin small letter o with circumflex and tilde"
      },
      {
        "char": "Ộ",
        "unicode": "1ED8",
        "fr": "O majuscule circonflexe point souscrit",
        "en": "Latin capital letter O with circumflex and dot below"
      },
      {
        "char": "ộ",
        "unicode": "1ED9",
        "fr": "O minuscule circonflexe point souscrit",
        "en": "Latin small letter o with circumflex and dot below"
      },
      {
        "char": "Ớ",
        "unicode": "1EDA",
        "fr": "O majuscule corne accent aigu",
        "en": "Latin capital letter O with horn and acute"
      },
      {
        "char": "ớ",
        "unicode": "1EDB",
        "fr": "O minuscule corne accent aigu",
        "en": "Latin small letter o with horn and acute"
      },
      {
        "char": "Ờ",
        "unicode": "1EDC",
        "fr": "O majuscule corne accent grave",
        "en": "Latin capital letter O with horn and grave"
      },
      {
        "char": "ờ",
        "unicode": "1EDD",
        "fr": "O minuscule corne accent grave",
        "en": "Latin small letter o with horn and grave"
      },
      {
        "char": "Ở",
        "unicode": "1EDE",
        "fr": "O majuscule corne crochet en chef",
        "en": "Latin capital letter O with horn and hook above"
      },
      {
        "char": "ở",
        "unicode": "1EDF",
        "fr": "O minuscule corne crochet en chef",
        "en": "Latin small letter o with horn and hook above"
      },
      {
        "char": "Ỡ",
        "unicode": "1EE0",
        "fr": "O majuscule corne tilde",
        "en": "Latin capital letter O with horn and tilde"
      },
      {
        "char": "ỡ",
        "unicode": "1EE1",
        "fr": "O minuscule corne tilde",
        "en": "Latin small letter o with horn and tilde"
      },
      {
        "char": "Ợ",
        "unicode": "1EE2",
        "fr": "O majuscule corne point souscrit",
        "en": "Latin capital letter O with horn and dot below"
      },
      {
        "char": "ợ",
        "unicode": "1EE3",
        "fr": "O minuscule corne point souscrit",
        "en": "Latin small letter o with horn and dot below"
      },
      {
        "char": "Ụ",
        "unicode": "1EE4",
        "fr": "U majuscule point souscrit",
        "en": "Latin capital letter U with dot below"
      },
      {
        "char": "ụ",
        "unicode": "1EE5",
        "fr": "U minuscule point souscrit",
        "en": "Latin small letter u with dot below"
      },
      {
        "char": "Ủ",
        "unicode": "1EE6",
        "fr": "U majuscule crochet en chef",
        "en": "Latin capital letter U with hook above"
      },
      {
        "char": "ủ",
        "unicode": "1EE7",
        "fr": "U minuscule crochet en chef",
        "en": "Latin small letter u with hook above"
      },
      {
        "char": "Ứ",
        "unicode": "1EE8",
        "fr": "U majuscule corne accent aigu",
        "en": "Latin capital letter U with horn and acute"
      },
      {
        "char": "ứ",
        "unicode": "1EE9",
        "fr": "U minuscule corne accent aigu",
        "en": "Latin small letter u with horn and acute"
      },
      {
        "char": "Ừ",
        "unicode": "1EEA",
        "fr": "U majuscule corne accent grave",
        "en": "Latin capital letter U with horn and grave"
      },
      {
        "char": "ừ",
        "unicode": "1EEB",
        "fr": "U minuscule corne accent grave",
        "en": "Latin small letter u with horn and grave"
      },
      {
        "char": "Ử",
        "unicode": "1EEC",
        "fr": "U majuscule corne crochet en chef",
        "en": "Latin capital letter U with horn and hook above"
      },
      {
        "char": "ử",
        "unicode": "1EED",
        "fr": "U minuscule corne crochet en chef",
        "en": "Latin small letter u with horn and hook above"
      },
      {
        "char": "Ữ",
        "unicode": "1EEE",
        "fr": "U majuscule corne tilde",
        "en": "Latin capital letter U with horn and tilde"
      },
      {
        "char": "ữ",
        "unicode": "1EEF",
        "fr": "U minuscule corne tilde",
        "en": "Latin small letter u with horn and tilde"
      },
      {
        "char": "Ự",
        "unicode": "1EF0",
        "fr": "U majuscule corne point souscrit",
        "en": "Latin capital letter U with horn and dot below"
      },
      {
        "char": "ự",
        "unicode": "1EF1",
        "fr": "U minuscule corne point souscrit",
        "en": "Latin small letter u with horn and dot below"
      },
      {
        "char": "Ỳ",
        "unicode": "1EF2",
        "fr": "Y majuscule accent grave",
        "en": "Latin capital letter Y with grave"
      },
      {
        "char": "ỳ",
        "unicode": "1EF3",
        "fr": "Y minuscule accent grave",
        "en": "Latin small letter y with grave"
      },
      {
        "char": "Ỵ",
        "unicode": "1EF4",
        "fr": "Y majuscule point souscrit",
        "en": "Latin capital letter Y with dot below"
      },
      {
        "char": "ỵ",
        "unicode": "1EF5",
        "fr": "Y minuscule point souscrit",
        "en": "Latin small letter y with dot below"
      },
      {
        "char": "Ỷ",
        "unicode": "1EF6",
        "fr": "Y majuscule crochet en chef",
        "en": "Latin capital letter Y with hook above"
      },
      {
        "char": "ỷ",
        "unicode": "1EF7",
        "fr": "Y minuscule crochet en chef",
        "en": "Latin small letter y with hook above"
      },
      {
        "char": "Ỹ",
        "unicode": "1EF8",
        "fr": "Y majuscule tilde",
        "en": "Latin capital letter Y with tilde"
      },
      {
        "char": "ỹ",
        "unicode": "1EF9",
        "fr": "Y minuscule tilde",
        "en": "Latin small letter y with tilde"
      },
      {
        "char": "Ỻ",
        "unicode": "1EFA",
        "fr": "Middle-welsh ll majuscule",
        "en": "Latin capital letter middle-welsh ll"
      },
      {
        "char": "ỻ",
        "unicode": "1EFB",
        "fr": "Middle-welsh ll minuscule",
        "en": "Latin small letter middle-welsh ll"
      },
      {
        "char": "Ỽ",
        "unicode": "1EFC",
        "fr": "Middle-welsh v majuscule",
        "en": "Latin capital letter middle-welsh v"
      },
      {
        "char": "ỽ",
        "unicode": "1EFD",
        "fr": "Middle-welsh v minuscule",
        "en": "Latin small letter middle-welsh v"
      },
      {
        "char": "Ỿ",
        "unicode": "1EFE",
        "fr": "Y majuscule crochet",
        "en": "Latin capital letter Y with loop"
      },
      {
        "char": "ỿ",
        "unicode": "1EFF",
        "fr": "Y minuscule crochet",
        "en": "Latin small letter y with loop"
      }
    ]
  },
  {
    "name": "general-punctuation",
    "fr": "Ponctuation générale",
    "en": "General Punctuation",
    "characters": [
      {
        "char": " ",
        "unicode": "2000",
        "fr": "Espace cadratin",
        "en": "En quad"
      },
      {
        "char": " ",
        "unicode": "2001",
        "fr": "Espace double cadratin",
        "en": "Em quad"
      },
      {
        "char": " ",
        "unicode": "2002",
        "fr": "Espace demi-cadratin",
        "en": "En space"
      },
      {
        "char": " ",
        "unicode": "2003",
        "fr": "Espace cadratin",
        "en": "Em space"
      },
      {
        "char": " ",
        "unicode": "2004",
        "fr": "Espace trois-quarts de cadratin",
        "en": "Three-per-em space"
      },
      {
        "char": " ",
        "unicode": "2005",
        "fr": "Espace quart de cadratin",
        "en": "Four-per-em space"
      },
      {
        "char": " ",
        "unicode": "2006",
        "fr": "Espace sixième de cadratin",
        "en": "Six-per-em space"
      },
      {
        "char": " ",
        "unicode": "2007",
        "fr": "Espace tabulaire",
        "en": "Figure space"
      },
      {
        "char": " ",
        "unicode": "2008",
        "fr": "Espace ponctuation",
        "en": "Punctuation space"
      },
      {
        "char": " ",
        "unicode": "2009",
        "fr": "Espace fine",
        "en": "Thin space"
      },
      {
        "char": " ",
        "unicode": "200A",
        "fr": "Espace cheveux",
        "en": "Hair space"
      },
      {
        "char": "​",
        "unicode": "200B",
        "fr": "Espace insécable zéro largeur",
        "en": "Zero width space"
      },
      {
        "char": "‌",
        "unicode": "200C",
        "fr": "Non-jonctionneur",
        "en": "Zero width non-joiner"
      },
      {
        "char": "‍",
        "unicode": "200D",
        "fr": "Jonctionneur",
        "en": "Zero width joiner"
      },
      {
        "char": "‎",
        "unicode": "200E",
        "fr": "Marque gauche à droite",
        "en": "Left-to-right mark"
      },
      {
        "char": "‏",
        "unicode": "200F",
        "fr": "Marque droite à gauche",
        "en": "Right-to-left mark"
      },
      {
        "char": "–",
        "unicode": "2013",
        "fr": "Tiret demi-cadratin",
        "en": "En dash"
      },
      {
        "char": "—",
        "unicode": "2014",
        "fr": "Tiret cadratin",
        "en": "Em dash"
      },
      {
        "char": "―",
        "unicode": "2015",
        "fr": "Tiret horizontal",
        "en": "Horizontal bar"
      },
      {
        "char": "‖",
        "unicode": "2016",
        "fr": "Double barre verticale",
        "en": "Double vertical line"
      },
      {
        "char": "‗",
        "unicode": "2017",
        "fr": "Double soulignement",
        "en": "Double low line"
      },
      {
        "char": "‘",
        "unicode": "2018",
        "fr": "Guillemet-apostrophe gauche",
        "en": "Left single quotation mark"
      },
      {
        "char": "’",
        "unicode": "2019",
        "fr": "Guillemet-apostrophe droit",
        "en": "Right single quotation mark"
      },
      {
        "char": "‚",
        "unicode": "201A",
        "fr": "Guillemet-apostrophe bas",
        "en": "Single low-9 quotation mark"
      },
      {
        "char": "‛",
        "unicode": "201B",
        "fr": "Guillemet-apostrophe haut inversé",
        "en": "Single high-reversed-9 quotation mark"
      },
      {
        "char": "“",
        "unicode": "201C",
        "fr": "Guillemet double gauche",
        "en": "Left double quotation mark"
      },
      {
        "char": "”",
        "unicode": "201D",
        "fr": "Guillemet double droit",
        "en": "Right double quotation mark"
      },
      {
        "char": "„",
        "unicode": "201E",
        "fr": "Guillemet double bas",
        "en": "Double low-9 quotation mark"
      },
      {
        "char": "‟",
        "unicode": "201F",
        "fr": "Guillemet double haut inversé",
        "en": "Double high-reversed-9 quotation mark"
      },
      { "char": "†", "unicode": "2020", "fr": "Dague", "en": "Dagger" },
      {
        "char": "‡",
        "unicode": "2021",
        "fr": "Double dague",
        "en": "Double dagger"
      },
      { "char": "•", "unicode": "2022", "fr": "Puce", "en": "Bullet" },
      {
        "char": "‣",
        "unicode": "2023",
        "fr": "Puce triangulaire",
        "en": "Triangular bullet"
      },
      {
        "char": "․",
        "unicode": "2024",
        "fr": "Point un",
        "en": "One dot leader"
      },
      {
        "char": "‥",
        "unicode": "2025",
        "fr": "Point deux",
        "en": "Two dot leader"
      },
      {
        "char": "…",
        "unicode": "2026",
        "fr": "Points de suspension",
        "en": "Horizontal ellipsis"
      },
      {
        "char": "‧",
        "unicode": "2027",
        "fr": "Point médian",
        "en": "Hyphenation point"
      },
      {
        "char": " ",
        "unicode": "202F",
        "fr": "Espace fine insécable",
        "en": "Narrow no-break space"
      },
      {
        "char": "‰",
        "unicode": "2030",
        "fr": "Pour mille",
        "en": "Per mille sign"
      },
      {
        "char": "‱",
        "unicode": "2031",
        "fr": "Pour dix mille",
        "en": "Per ten thousand sign"
      },
      { "char": "′", "unicode": "2032", "fr": "Prime", "en": "Prime" },
      {
        "char": "″",
        "unicode": "2033",
        "fr": "Double prime",
        "en": "Double prime"
      },
      {
        "char": "‴",
        "unicode": "2034",
        "fr": "Triple prime",
        "en": "Triple prime"
      },
      {
        "char": "‵",
        "unicode": "2035",
        "fr": "Prime inversé",
        "en": "Reversed prime"
      },
      {
        "char": "‶",
        "unicode": "2036",
        "fr": "Double prime inversé",
        "en": "Reversed double prime"
      },
      {
        "char": "‷",
        "unicode": "2037",
        "fr": "Triple prime inversé",
        "en": "Reversed triple prime"
      },
      { "char": "‸", "unicode": "2038", "fr": "Insertion", "en": "Caret" },
      {
        "char": "‹",
        "unicode": "2039",
        "fr": "Guillemet simple gauche",
        "en": "Single left-pointing angle quotation mark"
      },
      {
        "char": "›",
        "unicode": "203A",
        "fr": "Guillemet simple droit",
        "en": "Single right-pointing angle quotation mark"
      },
      {
        "char": "※",
        "unicode": "203B",
        "fr": "Astérisque de référence",
        "en": "Reference mark"
      },
      {
        "char": "‼",
        "unicode": "203C",
        "fr": "Double point d'exclamation",
        "en": "Double exclamation mark"
      },
      {
        "char": "‽",
        "unicode": "203D",
        "fr": "Point d'interrogation-exclamation",
        "en": "Interrobang"
      },
      {
        "char": "‾",
        "unicode": "203E",
        "fr": "Ligne suscrite",
        "en": "Overline"
      },
      {
        "char": "⁁",
        "unicode": "2041",
        "fr": "Caret insertion",
        "en": "Caret insertion point"
      },
      { "char": "⁂", "unicode": "2042", "fr": "Astérisme", "en": "Asterism" },
      {
        "char": "⁃",
        "unicode": "2043",
        "fr": "Tiret bullet",
        "en": "Hyphen bullet"
      },
      {
        "char": "⁇",
        "unicode": "2047",
        "fr": "Double point d'interrogation",
        "en": "Double question mark"
      },
      {
        "char": "⁈",
        "unicode": "2048",
        "fr": "Point d'interrogation-exclamation",
        "en": "Question exclamation mark"
      },
      {
        "char": "⁉",
        "unicode": "2049",
        "fr": "Point d'exclamation-interrogation",
        "en": "Exclamation question mark"
      },
      {
        "char": "⁰",
        "unicode": "2070",
        "fr": "Exposant zéro",
        "en": "Superscript zero"
      },
      {
        "char": "⁊",
        "unicode": "204A",
        "fr": "Signe tironien et",
        "en": "Tironian sign et"
      },
      {
        "char": "⁋",
        "unicode": "204B",
        "fr": "Paragraphe inversé",
        "en": "Reversed pilcrow sign"
      },
      {
        "char": "⁌",
        "unicode": "204C",
        "fr": "Crochet gauche guillemet",
        "en": "Black leftwards bullet"
      },
      {
        "char": "⁍",
        "unicode": "204D",
        "fr": "Crochet droit guillemet",
        "en": "Black rightwards bullet"
      },
      {
        "char": "⁎",
        "unicode": "204E",
        "fr": "Astérisque basse",
        "en": "Low asterisk"
      },
      {
        "char": "⁏",
        "unicode": "204F",
        "fr": "Point de paragraphe",
        "en": "Reversed semicolon"
      },
      {
        "char": "⁐",
        "unicode": "2050",
        "fr": "Quatre points",
        "en": "Close up"
      },
      {
        "char": "⁑",
        "unicode": "2051",
        "fr": "Deux astérisques",
        "en": "Two asterisks aligned vertically"
      },
      {
        "char": "⁒",
        "unicode": "2052",
        "fr": "Pour cent mille",
        "en": "Commercial minus sign"
      },
      {
        "char": "⁓",
        "unicode": "2053",
        "fr": "Tilde vague",
        "en": "Swung dash"
      },
      {
        "char": "⁔",
        "unicode": "2054",
        "fr": "Marque d'insertion",
        "en": "Inverted undertie"
      },
      {
        "char": "⁕",
        "unicode": "2055",
        "fr": "Fleur d'astérisque",
        "en": "Flower punctuation mark"
      },
      {
        "char": "⁖",
        "unicode": "2056",
        "fr": "Trois points verticaux",
        "en": "Three dot punctuation"
      },
      {
        "char": "⁗",
        "unicode": "2057",
        "fr": "Quadruple prime",
        "en": "Quadruple prime"
      },
      {
        "char": "⁘",
        "unicode": "2058",
        "fr": "Quatre points en losange",
        "en": "Four dot punctuation"
      },
      {
        "char": "⁙",
        "unicode": "2059",
        "fr": "Cinq points en croix",
        "en": "Five dot punctuation"
      },
      {
        "char": "⁚",
        "unicode": "205A",
        "fr": "Deux points verticaux",
        "en": "Two dot punctuation"
      },
      {
        "char": "⁛",
        "unicode": "205B",
        "fr": "Quatre points en carré",
        "en": "Four dot mark"
      },
      {
        "char": "⁜",
        "unicode": "205C",
        "fr": "Astérisque tournant",
        "en": "Dotted cross punctuation mark"
      },
      {
        "char": "⁝",
        "unicode": "205D",
        "fr": "Trois points verticaux",
        "en": "Tricolon"
      },
      {
        "char": "⁞",
        "unicode": "205E",
        "fr": "Barre verticale pointillée",
        "en": "Vertical four dots"
      },
      {
        "char": " ",
        "unicode": "205F",
        "fr": "Espace mathématique moyenne",
        "en": "Medium mathematical space"
      },
      {
        "char": "⁠",
        "unicode": "2060",
        "fr": "Saut de mot insécable",
        "en": "Word joiner"
      },
      {
        "char": "⁡",
        "unicode": "2061",
        "fr": "Fonction mathématique invisible",
        "en": "Function application"
      },
      {
        "char": "⁢",
        "unicode": "2062",
        "fr": "Multiplication invisible",
        "en": "Invisible times"
      },
      {
        "char": "⁣",
        "unicode": "2063",
        "fr": "Séparateur invisible",
        "en": "Invisible separator"
      },
      {
        "char": "⁤",
        "unicode": "2064",
        "fr": "Plus invisible",
        "en": "Invisible plus"
      },
      {
        "char": "⁦",
        "unicode": "2066",
        "fr": "Isolat gauche à droite",
        "en": "Left-to-right isolate"
      },
      {
        "char": "⁧",
        "unicode": "2067",
        "fr": "Isolat droite à gauche",
        "en": "Right-to-left isolate"
      },
      {
        "char": "⁨",
        "unicode": "2068",
        "fr": "Isolat droite à gauche pour chiffres",
        "en": "First strong isolate"
      },
      {
        "char": "⁩",
        "unicode": "2069",
        "fr": "Fin d'isolat",
        "en": "Pop directional isolate"
      },
      {
        "char": "⁪",
        "unicode": "206A",
        "fr": "Inhibition de séparation de groupe",
        "en": "Inhibit symmetric swapping"
      },
      {
        "char": "⁫",
        "unicode": "206B",
        "fr": "Activation de séparation de groupe",
        "en": "Activate symmetric swapping"
      },
      {
        "char": "⁬",
        "unicode": "206C",
        "fr": "Inhibition de séparation de chiffres",
        "en": "Inhibit Arabic form shaping"
      },
      {
        "char": "⁭",
        "unicode": "206D",
        "fr": "Activation de séparation de chiffres",
        "en": "Activate Arabic form shaping"
      },
      {
        "char": "⁮",
        "unicode": "206E",
        "fr": "Direction nationale",
        "en": "National digit shapes"
      },
      {
        "char": "⁯",
        "unicode": "206F",
        "fr": "Direction nominale",
        "en": "Nominal digit shapes"
      }
    ]
  },
  {
    "name": "superscripts-and-subscripts",
    "fr": "Exposants et indices",
    "en": "Superscripts and Subscripts",
    "characters": [
      {
        "char": "⁰",
        "unicode": "2070",
        "fr": "Exposant zéro",
        "en": "Superscript zero"
      },
      {
        "char": "ⁱ",
        "unicode": "2071",
        "fr": "Exposant i",
        "en": "Superscript latin small letter i"
      },

      {
        "char": "⁴",
        "unicode": "2074",
        "fr": "Exposant quatre",
        "en": "Superscript four"
      },
      {
        "char": "⁵",
        "unicode": "2075",
        "fr": "Exposant cinq",
        "en": "Superscript five"
      },
      {
        "char": "⁶",
        "unicode": "2076",
        "fr": "Exposant six",
        "en": "Superscript six"
      },
      {
        "char": "⁷",
        "unicode": "2077",
        "fr": "Exposant sept",
        "en": "Superscript seven"
      },
      {
        "char": "⁸",
        "unicode": "2078",
        "fr": "Exposant huit",
        "en": "Superscript eight"
      },
      {
        "char": "⁹",
        "unicode": "2079",
        "fr": "Exposant neuf",
        "en": "Superscript nine"
      },
      {
        "char": "⁺",
        "unicode": "207A",
        "fr": "Exposant plus",
        "en": "Superscript plus sign"
      },
      {
        "char": "⁻",
        "unicode": "207B",
        "fr": "Exposant moins",
        "en": "Superscript minus"
      },
      {
        "char": "⁼",
        "unicode": "207C",
        "fr": "Exposant égal",
        "en": "Superscript equals sign"
      },
      {
        "char": "⁽",
        "unicode": "207D",
        "fr": "Exposant parenthèse gauche",
        "en": "Superscript left parenthesis"
      },
      {
        "char": "⁾",
        "unicode": "207E",
        "fr": "Exposant parenthèse droite",
        "en": "Superscript right parenthesis"
      },
      {
        "char": "ⁿ",
        "unicode": "207F",
        "fr": "Exposant n",
        "en": "Superscript latin small letter n"
      },
      {
        "char": "₀",
        "unicode": "2080",
        "fr": "Indice zéro",
        "en": "Subscript zero"
      },

      {
        "char": "₁",
        "unicode": "2081",
        "fr": "Indice un",
        "en": "Subscript one"
      },
      {
        "char": "₂",
        "unicode": "2082",
        "fr": "Indice deux",
        "en": "Subscript two"
      },
      {
        "char": "₃",
        "unicode": "2083",
        "fr": "Indice trois",
        "en": "Subscript three"
      },
      {
        "char": "₄",
        "unicode": "2084",
        "fr": "Indice quatre",
        "en": "Subscript four"
      },
      {
        "char": "₅",
        "unicode": "2085",
        "fr": "Indice cinq",
        "en": "Subscript five"
      },
      {
        "char": "₆",
        "unicode": "2086",
        "fr": "Indice six",
        "en": "Subscript six"
      },
      {
        "char": "₇",
        "unicode": "2087",
        "fr": "Indice sept",
        "en": "Subscript seven"
      },
      {
        "char": "₈",
        "unicode": "2088",
        "fr": "Indice huit",
        "en": "Subscript eight"
      },
      {
        "char": "₉",
        "unicode": "2089",
        "fr": "Indice neuf",
        "en": "Subscript nine"
      },
      {
        "char": "₊",
        "unicode": "208A",
        "fr": "Indice plus",
        "en": "Subscript plus sign"
      },
      {
        "char": "₋",
        "unicode": "208B",
        "fr": "Indice moins",
        "en": "Subscript minus"
      },
      {
        "char": "₌",
        "unicode": "208C",
        "fr": "Indice égal",
        "en": "Subscript equals sign"
      },
      {
        "char": "₍",
        "unicode": "208D",
        "fr": "Indice parenthèse gauche",
        "en": "Subscript left parenthesis"
      },
      {
        "char": "₎",
        "unicode": "208E",
        "fr": "Indice parenthèse droite",
        "en": "Subscript right parenthesis"
      },
      {
        "char": "ₐ",
        "unicode": "2090",
        "fr": "Indice a",
        "en": "Subscript latin small letter a"
      },
      {
        "char": "ₑ",
        "unicode": "2091",
        "fr": "Indice e",
        "en": "Subscript latin small letter e"
      },
      {
        "char": "ₒ",
        "unicode": "2092",
        "fr": "Indice o",
        "en": "Subscript latin small letter o"
      },
      {
        "char": "ₓ",
        "unicode": "2093",
        "fr": "Indice x",
        "en": "Subscript latin small letter x"
      },
      {
        "char": "ₔ",
        "unicode": "2094",
        "fr": "Indice schwa",
        "en": "Subscript latin small letter schwa"
      },
      {
        "char": "ₕ",
        "unicode": "2095",
        "fr": "Indice h",
        "en": "Subscript latin small letter h"
      },
      {
        "char": "ₖ",
        "unicode": "2096",
        "fr": "Indice k",
        "en": "Subscript latin small letter k"
      },
      {
        "char": "ₗ",
        "unicode": "2097",
        "fr": "Indice l",
        "en": "Subscript latin small letter l"
      },
      {
        "char": "ₘ",
        "unicode": "2098",
        "fr": "Indice m",
        "en": "Subscript latin small letter m"
      },
      {
        "char": "ₙ",
        "unicode": "2099",
        "fr": "Indice n",
        "en": "Subscript latin small letter n"
      },
      {
        "char": "ₚ",
        "unicode": "209A",
        "fr": "Indice p",
        "en": "Subscript latin small letter p"
      },
      {
        "char": "ₛ",
        "unicode": "209B",
        "fr": "Indice s",
        "en": "Subscript latin small letter s"
      },
      {
        "char": "ₜ",
        "unicode": "209C",
        "fr": "Indice t",
        "en": "Subscript latin small letter t"
      }
    ]
  },
  {
    "name": "currency-symbols",
    "fr": "Symboles monétaires",
    "en": "Currency Symbols",
    "characters": [
      {
        "char": "€",
        "unicode": "20AC",
        "fr": "Euro",
        "en": "Euro sign"
      },
      { "char": "$", "unicode": "0024", "fr": "Dollar", "en": "Dollar sign" },
      { "char": "¢", "unicode": "00A2", "fr": "Cent", "en": "Cent sign" },
      { "char": "£", "unicode": "00A3", "fr": "Livre", "en": "Pound sign" },
      {
        "char": "¤",
        "unicode": "00A4",
        "fr": "Symbole monétaire",
        "en": "Currency sign"
      },
      { "char": "¥", "unicode": "00A5", "fr": "Yen", "en": "Yen sign" },
      {
        "char": "₠",
        "unicode": "20A0",
        "fr": "Symbole euro européen",
        "en": "Euro-currency sign"
      },
      { "char": "₡", "unicode": "20A1", "fr": "Colón", "en": "Colon sign" },
      {
        "char": "₢",
        "unicode": "20A2",
        "fr": "Cruzeiro",
        "en": "Cruzeiro sign"
      },
      {
        "char": "₣",
        "unicode": "20A3",
        "fr": "Franc",
        "en": "French franc sign"
      },
      {
        "char": "₤",
        "unicode": "20A4",
        "fr": "Livre sterling",
        "en": "Lira sign"
      },
      { "char": "₥", "unicode": "20A5", "fr": "Mill", "en": "Mill sign" },
      { "char": "₦", "unicode": "20A6", "fr": "Naira", "en": "Naira sign" },
      { "char": "₧", "unicode": "20A7", "fr": "Peseta", "en": "Peseta sign" },
      { "char": "₨", "unicode": "20A8", "fr": "Roupie", "en": "Rupee sign" },
      { "char": "₩", "unicode": "20A9", "fr": "Won", "en": "Won sign" },
      {
        "char": "₪",
        "unicode": "20AA",
        "fr": "Shekel",
        "en": "New sheqel sign"
      },
      { "char": "₫", "unicode": "20AB", "fr": "Dong", "en": "Dong sign" },
      { "char": "₭", "unicode": "20AD", "fr": "Kip", "en": "Kip sign" },
      { "char": "₮", "unicode": "20AE", "fr": "Tugrik", "en": "Tugrik sign" },
      { "char": "₯", "unicode": "20AF", "fr": "Drachme", "en": "Drachma sign" },
      {
        "char": "₰",
        "unicode": "20B0",
        "fr": "Penny",
        "en": "German penny sign"
      },
      {
        "char": "₱",
        "unicode": "20B1",
        "fr": "Peso philippin",
        "en": "Peso sign"
      },
      { "char": "₲", "unicode": "20B2", "fr": "Guarani", "en": "Guarani sign" },
      { "char": "₳", "unicode": "20B3", "fr": "Austral", "en": "Austral sign" },
      { "char": "₴", "unicode": "20B4", "fr": "Hryvnia", "en": "Hryvnia sign" },
      { "char": "₵", "unicode": "20B5", "fr": "Cedi", "en": "Cedi sign" },
      {
        "char": "₶",
        "unicode": "20B6",
        "fr": "Livre tournois",
        "en": "Livre tournois sign"
      },
      {
        "char": "₷",
        "unicode": "20B7",
        "fr": "Spesmilo",
        "en": "Spesmilo sign"
      },
      { "char": "₸", "unicode": "20B8", "fr": "Tenge", "en": "Tenge sign" },
      {
        "char": "₺",
        "unicode": "20BA",
        "fr": "Livre turque",
        "en": "Turkish lira sign"
      },
      {
        "char": "₻",
        "unicode": "20BB",
        "fr": "Mark allemand",
        "en": "Nordic mark sign"
      },
      { "char": "₼", "unicode": "20BC", "fr": "Manat", "en": "Manat sign" },
      { "char": "₽", "unicode": "20BD", "fr": "Rouble", "en": "Ruble sign" },
      { "char": "₾", "unicode": "20BE", "fr": "Lari", "en": "Lari sign" },
      { "char": "₿", "unicode": "20BF", "fr": "Bitcoin", "en": "Bitcoin sign" }
    ]
  },
  {
    "name": "letterlike-symbols",
    "fr": "Symboles de type lettre",
    "en": "Letterlike Symbols",
    "characters": [
      {
        "char": "℀",
        "unicode": "2100",
        "fr": "Symbole a/c",
        "en": "Account of"
      },
      {
        "char": "℁",
        "unicode": "2101",
        "fr": "Symbole a/s",
        "en": "Addressed to"
      },
      {
        "char": "ℂ",
        "unicode": "2102",
        "fr": "C majuscule double barre",
        "en": "Double-struck capital C"
      },
      {
        "char": "℃",
        "unicode": "2103",
        "fr": "Symbole degré Celsius",
        "en": "Degree Celsius"
      },
      {
        "char": "℄",
        "unicode": "2104",
        "fr": "Symbole centre",
        "en": "Centre line symbol"
      },
      {
        "char": "℅",
        "unicode": "2105",
        "fr": "Symbole care of",
        "en": "Care of"
      },
      {
        "char": "℆",
        "unicode": "2106",
        "fr": "Symbole chaque",
        "en": "Cada una"
      },
      {
        "char": "ℇ",
        "unicode": "2107",
        "fr": "Symbole Euler",
        "en": "Euler constant"
      },
      { "char": "℈", "unicode": "2108", "fr": "Symbole dram", "en": "Scruple" },
      {
        "char": "℉",
        "unicode": "2109",
        "fr": "Symbole degré Fahrenheit",
        "en": "Degree Fahrenheit"
      },
      {
        "char": "ℊ",
        "unicode": "210A",
        "fr": "g cursive",
        "en": "Script small g"
      },
      {
        "char": "ℋ",
        "unicode": "210B",
        "fr": "H majuscule cursive",
        "en": "Script capital H"
      },
      {
        "char": "ℌ",
        "unicode": "210C",
        "fr": "H majuscule gothique",
        "en": "Black-letter capital H"
      },
      {
        "char": "ℍ",
        "unicode": "210D",
        "fr": "H majuscule double barre",
        "en": "Double-struck capital H"
      },
      {
        "char": "ℎ",
        "unicode": "210E",
        "fr": "h minuscule planck",
        "en": "Planck constant"
      },
      {
        "char": "ℏ",
        "unicode": "210F",
        "fr": "h barré planck",
        "en": "Planck constant over two pi"
      },
      {
        "char": "ℐ",
        "unicode": "2110",
        "fr": "I majuscule cursive",
        "en": "Script capital I"
      },
      {
        "char": "ℑ",
        "unicode": "2111",
        "fr": "I majuscule gothique",
        "en": "Black-letter capital I"
      },
      {
        "char": "ℒ",
        "unicode": "2112",
        "fr": "L majuscule cursive",
        "en": "Script capital L"
      },
      {
        "char": "ℓ",
        "unicode": "2113",
        "fr": "l minuscule cursive",
        "en": "Script small l"
      },
      {
        "char": "℔",
        "unicode": "2114",
        "fr": "Symbole livre poids",
        "en": "L B bar symbol"
      },
      {
        "char": "ℕ",
        "unicode": "2115",
        "fr": "N majuscule double barre",
        "en": "Double-struck capital N"
      },
      {
        "char": "№",
        "unicode": "2116",
        "fr": "Symbole numéro",
        "en": "Numero sign"
      },
      {
        "char": "℗",
        "unicode": "2117",
        "fr": "Symbole phonogramme",
        "en": "Sound recording copyright"
      },
      {
        "char": "℘",
        "unicode": "2118",
        "fr": "Symbole Weierstrass p",
        "en": "Weierstrass elliptic p"
      },
      {
        "char": "ℙ",
        "unicode": "2119",
        "fr": "P majuscule double barre",
        "en": "Double-struck capital P"
      },
      {
        "char": "ℚ",
        "unicode": "211A",
        "fr": "Q majuscule double barre",
        "en": "Double-struck capital Q"
      },
      {
        "char": "ℛ",
        "unicode": "211B",
        "fr": "R majuscule cursive",
        "en": "Script capital R"
      },
      {
        "char": "ℜ",
        "unicode": "211C",
        "fr": "R majuscule gothique",
        "en": "Black-letter capital R"
      },
      {
        "char": "ℝ",
        "unicode": "211D",
        "fr": "R majuscule double barre",
        "en": "Double-struck capital R"
      },
      {
        "char": "℞",
        "unicode": "211E",
        "fr": "Symbole prescription",
        "en": "Prescription take"
      },
      {
        "char": "℟",
        "unicode": "211F",
        "fr": "Symbole réponse",
        "en": "Response"
      },
      {
        "char": "℠",
        "unicode": "2120",
        "fr": "Symbole marque de service",
        "en": "Service mark"
      },
      {
        "char": "℡",
        "unicode": "2121",
        "fr": "Symbole télécopie",
        "en": "Telephone sign"
      },
      {
        "char": "™",
        "unicode": "2122",
        "fr": "Symbole marque déposée",
        "en": "Trade mark sign"
      },
      {
        "char": "℣",
        "unicode": "2123",
        "fr": "Symbole verset",
        "en": "Versicle"
      },
      {
        "char": "ℤ",
        "unicode": "2124",
        "fr": "Z majuscule double barre",
        "en": "Double-struck capital Z"
      },
      {
        "char": "℥",
        "unicode": "2125",
        "fr": "Symbole once liquide",
        "en": "Ounce sign"
      },
      { "char": "Ω", "unicode": "2126", "fr": "Symbole ohm", "en": "Ohm sign" },
      {
        "char": "℧",
        "unicode": "2127",
        "fr": "Symbole mho",
        "en": "Inverted ohm sign"
      },
      {
        "char": "ℨ",
        "unicode": "2128",
        "fr": "Z majuscule gothique",
        "en": "Black-letter capital Z"
      },
      {
        "char": "℩",
        "unicode": "2129",
        "fr": "Symbole tourné iota",
        "en": "Turned iota"
      },
      {
        "char": "K",
        "unicode": "212A",
        "fr": "K majuscule kelvin",
        "en": "Kelvin sign"
      },
      {
        "char": "Å",
        "unicode": "212B",
        "fr": "A majuscule angström",
        "en": "Angstrom sign"
      },
      {
        "char": "ℬ",
        "unicode": "212C",
        "fr": "B majuscule cursive",
        "en": "Script capital B"
      },
      {
        "char": "ℭ",
        "unicode": "212D",
        "fr": "C majuscule gothique",
        "en": "Black-letter capital C"
      },
      {
        "char": "℮",
        "unicode": "212E",
        "fr": "Symbole estimation",
        "en": "Estimated symbol"
      },
      {
        "char": "ℯ",
        "unicode": "212F",
        "fr": "e minuscule cursive",
        "en": "Script small e"
      },
      {
        "char": "ℰ",
        "unicode": "2130",
        "fr": "E majuscule cursive",
        "en": "Script capital E"
      },
      {
        "char": "ℱ",
        "unicode": "2131",
        "fr": "F majuscule cursive",
        "en": "Script capital F"
      },
      {
        "char": "Ⅎ",
        "unicode": "2132",
        "fr": "F majuscule retourné",
        "en": "Turned capital F"
      },
      {
        "char": "ℳ",
        "unicode": "2133",
        "fr": "M majuscule cursive",
        "en": "Script capital M"
      },
      {
        "char": "ℴ",
        "unicode": "2134",
        "fr": "o minuscule cursive",
        "en": "Script small o"
      },
      { "char": "ℵ", "unicode": "2135", "fr": "Aleph", "en": "Alef symbol" },
      { "char": "ℶ", "unicode": "2136", "fr": "Beth", "en": "Bet symbol" },
      { "char": "ℷ", "unicode": "2137", "fr": "Gimel", "en": "Gimel symbol" },
      { "char": "ℸ", "unicode": "2138", "fr": "Dalet", "en": "Dalet symbol" },
      {
        "char": "ℹ",
        "unicode": "2139",
        "fr": "i minuscule information",
        "en": "Information source"
      },
      {
        "char": "℺",
        "unicode": "213A",
        "fr": "Symbole rotation",
        "en": "Rotated capital Q"
      },
      {
        "char": "℻",
        "unicode": "213B",
        "fr": "Symbole facsimile",
        "en": "Facsimile sign"
      },
      {
        "char": "ℼ",
        "unicode": "213C",
        "fr": "Pi majuscule double barre",
        "en": "Double-struck small pi"
      },
      {
        "char": "ℽ",
        "unicode": "213D",
        "fr": "Gamma majuscule double barre",
        "en": "Double-struck small gamma"
      },
      {
        "char": "ℾ",
        "unicode": "213E",
        "fr": "Pi majuscule double barre",
        "en": "Double-struck capital pi"
      },
      {
        "char": "ℿ",
        "unicode": "213F",
        "fr": "Gamma majuscule double barre",
        "en": "Double-struck capital gamma"
      },
      {
        "char": "⅀",
        "unicode": "2140",
        "fr": "Symbole somme",
        "en": "Double-struck n-ary summation"
      },
      {
        "char": "⅁",
        "unicode": "2141",
        "fr": "G majuscule retourné",
        "en": "Turned sans-serif capital G"
      },
      {
        "char": "⅂",
        "unicode": "2142",
        "fr": "L majuscule retourné",
        "en": "Turned sans-serif capital L"
      },
      {
        "char": "⅃",
        "unicode": "2143",
        "fr": "Y majuscule retourné",
        "en": "Reversed sans-serif capital L"
      },
      {
        "char": "⅄",
        "unicode": "2144",
        "fr": "Y majuscule retourné",
        "en": "Turned sans-serif capital Y"
      },
      {
        "char": "ⅅ",
        "unicode": "2145",
        "fr": "D majuscule double barre",
        "en": "Double-struck italic capital D"
      },
      {
        "char": "ⅆ",
        "unicode": "2146",
        "fr": "d minuscule double barre",
        "en": "Double-struck italic small d"
      },
      {
        "char": "ⅇ",
        "unicode": "2147",
        "fr": "e minuscule double barre",
        "en": "Double-struck italic small e"
      },
      {
        "char": "ⅈ",
        "unicode": "2148",
        "fr": "i minuscule double barre",
        "en": "Double-struck italic small i"
      },
      {
        "char": "ⅉ",
        "unicode": "2149",
        "fr": "j minuscule double barre",
        "en": "Double-struck italic small j"
      },
      {
        "char": "⅊",
        "unicode": "214A",
        "fr": "Symbole propriété",
        "en": "Property line"
      },
      {
        "char": "⅋",
        "unicode": "214B",
        "fr": "Esperluette retournée",
        "en": "Turned ampersand"
      },
      {
        "char": "⅌",
        "unicode": "214C",
        "fr": "Symbole per sign",
        "en": "Per sign"
      },
      {
        "char": "⅍",
        "unicode": "214D",
        "fr": "Symbole acte",
        "en": "Aktieselskab"
      },
      {
        "char": "ⅎ",
        "unicode": "214E",
        "fr": "f minuscule script",
        "en": "Turned small f"
      },
      {
        "char": "⅏",
        "unicode": "214F",
        "fr": "Symbole symbolique",
        "en": "Symbol for Samaritan source"
      }
    ]
  },
  {
    "name": "number-forms",
    "fr": "Feuilles de nombres",
    "en": "Number Forms",
    "characters": [
      {
        "char": "⅐",
        "unicode": "2150",
        "fr": "Un septième",
        "en": "Vulgar fraction one seventh"
      },
      {
        "char": "⅑",
        "unicode": "2151",
        "fr": "Un neuvième",
        "en": "Vulgar fraction one ninth"
      },
      {
        "char": "⅒",
        "unicode": "2152",
        "fr": "Un dixième",
        "en": "Vulgar fraction one tenth"
      },
      {
        "char": "⅓",
        "unicode": "2153",
        "fr": "Un tiers",
        "en": "Vulgar fraction one third"
      },
      {
        "char": "⅔",
        "unicode": "2154",
        "fr": "Deux tiers",
        "en": "Vulgar fraction two thirds"
      },
      {
        "char": "⅕",
        "unicode": "2155",
        "fr": "Un cinquième",
        "en": "Vulgar fraction one fifth"
      },
      {
        "char": "⅖",
        "unicode": "2156",
        "fr": "Deux cinquièmes",
        "en": "Vulgar fraction two fifths"
      },
      {
        "char": "⅗",
        "unicode": "2157",
        "fr": "Trois cinquièmes",
        "en": "Vulgar fraction three fifths"
      },
      {
        "char": "⅘",
        "unicode": "2158",
        "fr": "Quatre cinquièmes",
        "en": "Vulgar fraction four fifths"
      },
      {
        "char": "⅙",
        "unicode": "2159",
        "fr": "Un sixième",
        "en": "Vulgar fraction one sixth"
      },
      {
        "char": "⅚",
        "unicode": "215A",
        "fr": "Cinq sixièmes",
        "en": "Vulgar fraction five sixths"
      },
      {
        "char": "⅛",
        "unicode": "215B",
        "fr": "Un huitième",
        "en": "Vulgar fraction one eighth"
      },
      {
        "char": "⅜",
        "unicode": "215C",
        "fr": "Trois huitièmes",
        "en": "Vulgar fraction three eighths"
      },
      {
        "char": "⅝",
        "unicode": "215D",
        "fr": "Cinq huitièmes",
        "en": "Vulgar fraction five eighths"
      },
      {
        "char": "⅞",
        "unicode": "215E",
        "fr": "Sept huitièmes",
        "en": "Vulgar fraction seven eighths"
      },
      {
        "char": "↉",
        "unicode": "2189",
        "fr": "Zéro tiers",
        "en": "Vulgar fraction zero thirds"
      },
      {
        "char": "Ⅰ",
        "unicode": "2160",
        "fr": "Chiffre romain un majuscule",
        "en": "Roman numeral one"
      },
      {
        "char": "Ⅱ",
        "unicode": "2161",
        "fr": "Chiffre romain deux majuscule",
        "en": "Roman numeral two"
      },
      {
        "char": "Ⅲ",
        "unicode": "2162",
        "fr": "Chiffre romain trois majuscule",
        "en": "Roman numeral three"
      },
      {
        "char": "Ⅳ",
        "unicode": "2163",
        "fr": "Chiffre romain quatre majuscule",
        "en": "Roman numeral four"
      },
      {
        "char": "Ⅴ",
        "unicode": "2164",
        "fr": "Chiffre romain cinq majuscule",
        "en": "Roman numeral five"
      },
      {
        "char": "Ⅵ",
        "unicode": "2165",
        "fr": "Chiffre romain six majuscule",
        "en": "Roman numeral six"
      },
      {
        "char": "Ⅶ",
        "unicode": "2166",
        "fr": "Chiffre romain sept majuscule",
        "en": "Roman numeral seven"
      },
      {
        "char": "Ⅷ",
        "unicode": "2167",
        "fr": "Chiffre romain huit majuscule",
        "en": "Roman numeral eight"
      },
      {
        "char": "Ⅸ",
        "unicode": "2168",
        "fr": "Chiffre romain neuf majuscule",
        "en": "Roman numeral nine"
      },
      {
        "char": "Ⅹ",
        "unicode": "2169",
        "fr": "Chiffre romain dix majuscule",
        "en": "Roman numeral ten"
      },
      {
        "char": "Ⅺ",
        "unicode": "216A",
        "fr": "Chiffre romain onze majuscule",
        "en": "Roman numeral eleven"
      },
      {
        "char": "Ⅻ",
        "unicode": "216B",
        "fr": "Chiffre romain douze majuscule",
        "en": "Roman numeral twelve"
      },
      {
        "char": "Ⅼ",
        "unicode": "216C",
        "fr": "Chiffre romain cinquante majuscule",
        "en": "Roman numeral fifty"
      },
      {
        "char": "Ⅽ",
        "unicode": "216D",
        "fr": "Chiffre romain cent majuscule",
        "en": "Roman numeral one hundred"
      },
      {
        "char": "Ⅾ",
        "unicode": "216E",
        "fr": "Chiffre romain cinq cents majuscule",
        "en": "Roman numeral five hundred"
      },
      {
        "char": "Ⅿ",
        "unicode": "216F",
        "fr": "Chiffre romain mille majuscule",
        "en": "Roman numeral one thousand"
      },
      {
        "char": "ⅰ",
        "unicode": "2170",
        "fr": "Chiffre romain un minuscule",
        "en": "Small roman numeral one"
      },
      {
        "char": "ⅱ",
        "unicode": "2171",
        "fr": "Chiffre romain deux minuscule",
        "en": "Small roman numeral two"
      },
      {
        "char": "ⅲ",
        "unicode": "2172",
        "fr": "Chiffre romain trois minuscule",
        "en": "Small roman numeral three"
      },
      {
        "char": "ⅳ",
        "unicode": "2173",
        "fr": "Chiffre romain quatre minuscule",
        "en": "Small roman numeral four"
      },
      {
        "char": "ⅴ",
        "unicode": "2174",
        "fr": "Chiffre romain cinq minuscule",
        "en": "Small roman numeral five"
      },
      {
        "char": "ⅵ",
        "unicode": "2175",
        "fr": "Chiffre romain six minuscule",
        "en": "Small roman numeral six"
      },
      {
        "char": "ⅶ",
        "unicode": "2176",
        "fr": "Chiffre romain sept minuscule",
        "en": "Small roman numeral seven"
      },
      {
        "char": "ⅷ",
        "unicode": "2177",
        "fr": "Chiffre romain romain minuscule",
        "en": "Small roman numeral eight"
      },
      {
        "char": "ⅸ",
        "unicode": "2178",
        "fr": "Chiffre romain neuf minuscule",
        "en": "Small roman numeral nine"
      },
      {
        "char": "ⅹ",
        "unicode": "2179",
        "fr": "Chiffre romain dix minuscule",
        "en": "Small roman numeral ten"
      },
      {
        "char": "ⅺ",
        "unicode": "217A",
        "fr": "Chiffre romain onze minuscule",
        "en": "Small roman numeral eleven"
      },
      {
        "char": "ⅻ",
        "unicode": "217B",
        "fr": "Chiffre romain douze minuscule",
        "en": "Small roman numeral twelve"
      },
      {
        "char": "ⅼ",
        "unicode": "217C",
        "fr": "Chiffre romain cinquante minuscule",
        "en": "Small roman numeral fifty"
      },
      {
        "char": "ⅽ",
        "unicode": "217D",
        "fr": "Chiffre romain cent minuscule",
        "en": "Small roman numeral one hundred"
      },
      {
        "char": "ⅾ",
        "unicode": "217E",
        "fr": "Chiffre romain cinq cents minuscule",
        "en": "Small roman numeral five hundred"
      },
      {
        "char": "ⅿ",
        "unicode": "217F",
        "fr": "Chiffre romain mille minuscule",
        "en": "Small roman numeral one thousand"
      },
      {
        "char": "ↀ",
        "unicode": "2180",
        "fr": "Chiffre romain dix mille",
        "en": "Roman numeral ten thousand"
      },
      {
        "char": "ↁ",
        "unicode": "2181",
        "fr": "Chiffre romain cinq mille",
        "en": "Roman numeral five thousand"
      },
      {
        "char": "ↂ",
        "unicode": "2182",
        "fr": "Chiffre romain dix mille",
        "en": "Roman numeral ten thousand"
      },
      {
        "char": "Ↄ",
        "unicode": "2183",
        "fr": "Chiffre romain cent archaïque majuscule",
        "en": "Roman numeral reversed one hundred"
      },
      {
        "char": "ↄ",
        "unicode": "2184",
        "fr": "Chiffre romain cent archaïque minuscule",
        "en": "Roman numeral reversed one hundred"
      },
      {
        "char": "ↅ",
        "unicode": "2185",
        "fr": "Chiffre romain six archaïque",
        "en": "Roman numeral six late form"
      },
      {
        "char": "ↆ",
        "unicode": "2186",
        "fr": "Chiffre romain cinquante archaïque",
        "en": "Roman numeral fifty early form"
      },
      {
        "char": "ↇ",
        "unicode": "2187",
        "fr": "Chiffre romain cinq mille archaïque",
        "en": "Roman numeral five thousand"
      },
      {
        "char": "ↈ",
        "unicode": "2188",
        "fr": "Chiffre romain dix mille archaïque",
        "en": "Roman numeral ten thousand"
      }
    ]
  },
  {
    "name": "arrows",
    "fr": "Flèches",
    "en": "Arrows",
    "characters": [
      {
        "char": "←",
        "unicode": "2190",
        "fr": "Flèche gauche",
        "en": "Leftwards arrow"
      },
      {
        "char": "↑",
        "unicode": "2191",
        "fr": "Flèche haut",
        "en": "Upwards arrow"
      },
      {
        "char": "→",
        "unicode": "2192",
        "fr": "Flèche droite",
        "en": "Rightwards arrow"
      },
      {
        "char": "↓",
        "unicode": "2193",
        "fr": "Flèche bas",
        "en": "Downwards arrow"
      },
      {
        "char": "↔",
        "unicode": "2194",
        "fr": "Flèche gauche-droite",
        "en": "Left right arrow"
      },
      {
        "char": "↕",
        "unicode": "2195",
        "fr": "Flèche haut-bas",
        "en": "Up down arrow"
      },
      {
        "char": "↖",
        "unicode": "2196",
        "fr": "Flèche haut-gauche",
        "en": "North west arrow"
      },
      {
        "char": "↗",
        "unicode": "2197",
        "fr": "Flèche haut-droite",
        "en": "North east arrow"
      },
      {
        "char": "↘",
        "unicode": "2198",
        "fr": "Flèche bas-droite",
        "en": "South east arrow"
      },
      {
        "char": "↙",
        "unicode": "2199",
        "fr": "Flèche bas-gauche",
        "en": "South west arrow"
      },
      {
        "char": "↚",
        "unicode": "219A",
        "fr": "Flèche gauche barrée",
        "en": "Leftwards arrow with stroke"
      },
      {
        "char": "↛",
        "unicode": "219B",
        "fr": "Flèche droite barrée",
        "en": "Rightwards arrow with stroke"
      },
      {
        "char": "↜",
        "unicode": "219C",
        "fr": "Flèche ondulée gauche",
        "en": "Leftwards wave arrow"
      },
      {
        "char": "↝",
        "unicode": "219D",
        "fr": "Flèche ondulée droite",
        "en": "Rightwards wave arrow"
      },
      {
        "char": "↞",
        "unicode": "219E",
        "fr": "Flèche double gauche",
        "en": "Leftwards two headed arrow"
      },
      {
        "char": "↟",
        "unicode": "219F",
        "fr": "Flèche double haut",
        "en": "Upwards two headed arrow"
      },
      {
        "char": "↠",
        "unicode": "21A0",
        "fr": "Flèche double droite",
        "en": "Rightwards two headed arrow"
      },
      {
        "char": "↡",
        "unicode": "21A1",
        "fr": "Flèche double bas",
        "en": "Downwards two headed arrow"
      },
      {
        "char": "↢",
        "unicode": "21A2",
        "fr": "Flèche gauche queue",
        "en": "Leftwards arrow with tail"
      },
      {
        "char": "↣",
        "unicode": "21A3",
        "fr": "Flèche droite queue",
        "en": "Rightwards arrow with tail"
      },
      {
        "char": "↤",
        "unicode": "21A4",
        "fr": "Flèche gauche barre",
        "en": "Leftwards arrow from bar"
      },
      {
        "char": "↥",
        "unicode": "21A5",
        "fr": "Flèche haut barre",
        "en": "Upwards arrow from bar"
      },
      {
        "char": "↦",
        "unicode": "21A6",
        "fr": "Flèche droite barre",
        "en": "Rightwards arrow from bar"
      },
      {
        "char": "↧",
        "unicode": "21A7",
        "fr": "Flèche bas barre",
        "en": "Downwards arrow from bar"
      },
      {
        "char": "↩",
        "unicode": "21A9",
        "fr": "Flèche retour gauche",
        "en": "Leftwards arrow with hook"
      },
      {
        "char": "↪",
        "unicode": "21AA",
        "fr": "Flèche retour droite",
        "en": "Rightwards arrow with hook"
      },
      {
        "char": "↫",
        "unicode": "21AB",
        "fr": "Flèche boucle gauche",
        "en": "Leftwards arrow with loop"
      },
      {
        "char": "↬",
        "unicode": "21AC",
        "fr": "Flèche boucle droite",
        "en": "Rightwards arrow with loop"
      },
      {
        "char": "↭",
        "unicode": "21AD",
        "fr": "Flèche ondulée gauche-droite",
        "en": "Left right wave arrow"
      },
      {
        "char": "↯",
        "unicode": "21AF",
        "fr": "Flèche zigzag",
        "en": "Downwards zigzag arrow"
      },
      {
        "char": "↰",
        "unicode": "21B0",
        "fr": "Flèche haut gauche coin",
        "en": "Upwards arrow with tip leftwards"
      },
      {
        "char": "↱",
        "unicode": "21B1",
        "fr": "Flèche haut droite coin",
        "en": "Upwards arrow with tip rightwards"
      },
      {
        "char": "↲",
        "unicode": "21B2",
        "fr": "Flèche bas gauche coin",
        "en": "Downwards arrow with tip leftwards"
      },
      {
        "char": "↳",
        "unicode": "21B3",
        "fr": "Flèche bas droite coin",
        "en": "Downwards arrow with tip rightwards"
      },
      {
        "char": "↴",
        "unicode": "21B4",
        "fr": "Flèche droite bas coin",
        "en": "Rightwards arrow with corner downwards"
      },
      {
        "char": "↵",
        "unicode": "21B5",
        "fr": "Flèche retour chariot",
        "en": "Downwards arrow with corner leftwards"
      },
      {
        "char": "↶",
        "unicode": "21B6",
        "fr": "Flèche rotation gauche",
        "en": "Anticlockwise top semicircle arrow"
      },
      {
        "char": "↷",
        "unicode": "21B7",
        "fr": "Flèche rotation droite",
        "en": "Clockwise top semicircle arrow"
      },
      {
        "char": "↺",
        "unicode": "21BA",
        "fr": "Flèche rotation gauche cercle",
        "en": "Anticlockwise open circle arrow"
      },
      {
        "char": "↻",
        "unicode": "21BB",
        "fr": "Flèche rotation droite cercle",
        "en": "Clockwise open circle arrow"
      },
      {
        "char": "↼",
        "unicode": "21BC",
        "fr": "Flèche gauche ondulée haut",
        "en": "Leftwards harpoon with barb upwards"
      },
      {
        "char": "↽",
        "unicode": "21BD",
        "fr": "Flèche gauche ondulée bas",
        "en": "Leftwards harpoon with barb downwards"
      },
      {
        "char": "↾",
        "unicode": "21BE",
        "fr": "Flèche haut ondulée gauche",
        "en": "Upwards harpoon with barb leftwards"
      },
      {
        "char": "↿",
        "unicode": "21BF",
        "fr": "Flèche haut ondulée droite",
        "en": "Upwards harpoon with barb rightwards"
      },
      {
        "char": "⇀",
        "unicode": "21C0",
        "fr": "Flèche droite ondulée haut",
        "en": "Rightwards harpoon with barb upwards"
      },
      {
        "char": "⇁",
        "unicode": "21C1",
        "fr": "Flèche droite ondulée bas",
        "en": "Rightwards harpoon with barb downwards"
      },
      {
        "char": "⇂",
        "unicode": "21C2",
        "fr": "Flèche bas ondulée gauche",
        "en": "Downwards harpoon with barb leftwards"
      },
      {
        "char": "⇃",
        "unicode": "21C3",
        "fr": "Flèche bas ondulée droite",
        "en": "Downwards harpoon with barb rightwards"
      },
      {
        "char": "⇄",
        "unicode": "21C4",
        "fr": "Flèche droite-gauche double",
        "en": "Rightwards arrow over leftwards arrow"
      },
      {
        "char": "⇅",
        "unicode": "21C5",
        "fr": "Flèche haut-bas double",
        "en": "Upwards arrow leftwards of downwards arrow"
      },
      {
        "char": "⇆",
        "unicode": "21C6",
        "fr": "Flèche gauche-droite double",
        "en": "Leftwards arrow over rightwards arrow"
      },
      {
        "char": "⇇",
        "unicode": "21C7",
        "fr": "Flèche triple gauche",
        "en": "Leftwards paired arrows"
      },
      {
        "char": "⇈",
        "unicode": "21C8",
        "fr": "Flèche triple haut",
        "en": "Upwards paired arrows"
      },
      {
        "char": "⇉",
        "unicode": "21C9",
        "fr": "Flèche triple droite",
        "en": "Rightwards paired arrows"
      },
      {
        "char": "⇊",
        "unicode": "21CA",
        "fr": "Flèche triple bas",
        "en": "Downwards paired arrows"
      },
      {
        "char": "⇋",
        "unicode": "21CB",
        "fr": "Flèche gauche-droite double inversée",
        "en": "Leftwards harpoon over rightwards harpoon"
      },
      {
        "char": "⇌",
        "unicode": "21CC",
        "fr": "Flèche droite-gauche double inversée",
        "en": "Rightwards harpoon over leftwards harpoon"
      },
      {
        "char": "⇍",
        "unicode": "21CD",
        "fr": "Flèche double gauche barrée",
        "en": "Leftwards double arrow with stroke"
      },
      {
        "char": "⇎",
        "unicode": "21CE",
        "fr": "Flèche double gauche-droite barrée",
        "en": "Left right double arrow with stroke"
      },
      {
        "char": "⇏",
        "unicode": "21CF",
        "fr": "Flèche double droite barrée",
        "en": "Rightwards double arrow with stroke"
      },
      {
        "char": "⇐",
        "unicode": "21D0",
        "fr": "Flèche double gauche",
        "en": "Leftwards double arrow"
      },
      {
        "char": "⇑",
        "unicode": "21D1",
        "fr": "Flèche double haut",
        "en": "Upwards double arrow"
      },
      {
        "char": "⇒",
        "unicode": "21D2",
        "fr": "Flèche double droite",
        "en": "Rightwards double arrow"
      },
      {
        "char": "⇓",
        "unicode": "21D3",
        "fr": "Flèche double bas",
        "en": "Downwards double arrow"
      },
      {
        "char": "⇔",
        "unicode": "21D4",
        "fr": "Flèche double gauche-droite",
        "en": "Left right double arrow"
      },
      {
        "char": "⇕",
        "unicode": "21D5",
        "fr": "Flèche double haut-bas",
        "en": "Up down double arrow"
      },
      {
        "char": "⇖",
        "unicode": "21D6",
        "fr": "Flèche double haut-gauche",
        "en": "North west double arrow"
      },
      {
        "char": "⇗",
        "unicode": "21D7",
        "fr": "Flèche double haut-droite",
        "en": "North east double arrow"
      },
      {
        "char": "⇘",
        "unicode": "21D8",
        "fr": "Flèche double bas-droite",
        "en": "South east double arrow"
      },
      {
        "char": "⇙",
        "unicode": "21D9",
        "fr": "Flèche double bas-gauche",
        "en": "South west double arrow"
      },
      {
        "char": "⇚",
        "unicode": "21DA",
        "fr": "Flèche triple double gauche",
        "en": "Leftwards triple arrow"
      },
      {
        "char": "⇛",
        "unicode": "21DB",
        "fr": "Flèche triple double droite",
        "en": "Rightwards triple arrow"
      },
      {
        "char": "⇜",
        "unicode": "21DC",
        "fr": "Flèche ondulée gauche longue",
        "en": "Leftwards squiggle arrow"
      },
      {
        "char": "⇝",
        "unicode": "21DD",
        "fr": "Flèche ondulée droite longue",
        "en": "Rightwards squiggle arrow"
      },
      {
        "char": "⇞",
        "unicode": "21DE",
        "fr": "Flèche haut double",
        "en": "Upwards arrow with double stroke"
      },
      {
        "char": "⇟",
        "unicode": "21DF",
        "fr": "Flèche bas double",
        "en": "Downwards arrow with double stroke"
      },
      {
        "char": "⇠",
        "unicode": "21E0",
        "fr": "Flèche gauche blanche",
        "en": "Leftwards white arrow"
      },
      {
        "char": "⇡",
        "unicode": "21E1",
        "fr": "Flèche haut blanche",
        "en": "Upwards white arrow"
      },
      {
        "char": "⇢",
        "unicode": "21E2",
        "fr": "Flèche droite blanche",
        "en": "Rightwards white arrow"
      },
      {
        "char": "⇣",
        "unicode": "21E3",
        "fr": "Flèche bas blanche",
        "en": "Downwards white arrow"
      },
      {
        "char": "⇤",
        "unicode": "21E4",
        "fr": "Flèche gauche barre blanche",
        "en": "Leftwards arrow to bar"
      },
      {
        "char": "⇥",
        "unicode": "21E5",
        "fr": "Flèche droite barre blanche",
        "en": "Rightwards arrow to bar"
      },
      {
        "char": "⇦",
        "unicode": "21E6",
        "fr": "Flèche gauche noire",
        "en": "Leftwards black arrow"
      },
      {
        "char": "⇧",
        "unicode": "21E7",
        "fr": "Flèche haut noire",
        "en": "Upwards black arrow"
      },
      {
        "char": "⇨",
        "unicode": "21E8",
        "fr": "Flèche droite noire",
        "en": "Rightwards black arrow"
      },
      {
        "char": "⇩",
        "unicode": "21E9",
        "fr": "Flèche bas noire",
        "en": "Downwards black arrow"
      },
      {
        "char": "⇪",
        "unicode": "21EA",
        "fr": "Flèche haut majuscule",
        "en": "Upwards white arrow from bar"
      },
      {
        "char": "⇫",
        "unicode": "21EB",
        "fr": "Flèche haut double barre",
        "en": "Upwards white arrow on pedestal"
      },
      {
        "char": "⇬",
        "unicode": "21EC",
        "fr": "Flèche bas double barre",
        "en": "Upwards white arrow on pedestal with horizontal bar"
      },
      {
        "char": "⇭",
        "unicode": "21ED",
        "fr": "Flèche haut triple barre",
        "en": "Upwards white arrow on pedestal with vertical bar"
      },
      {
        "char": "⇮",
        "unicode": "21EE",
        "fr": "Flèche haut quadruple barre",
        "en": "Upwards white arrow on pedestal with double vertical bar"
      },
      {
        "char": "⇯",
        "unicode": "21EF",
        "fr": "Flèche haut quintuple barre",
        "en": "Upwards white arrow on pedestal with triple vertical bar"
      },
      {
        "char": "⇰",
        "unicode": "21F0",
        "fr": "Flèche droite barre blanche",
        "en": "Rightwards white arrow from wall"
      },
      {
        "char": "⇱",
        "unicode": "21F1",
        "fr": "Flèche haut gauche coin blanc",
        "en": "North west arrow to corner"
      },
      {
        "char": "⇲",
        "unicode": "21F2",
        "fr": "Flèche bas droite coin blanc",
        "en": "South east arrow to corner"
      },
      {
        "char": "⇳",
        "unicode": "21F3",
        "fr": "Flèche haut-bas double blanche",
        "en": "Up down white arrow"
      },
      {
        "char": "⇴",
        "unicode": "21F4",
        "fr": "Flèche droite barre double",
        "en": "Right arrow with small circle"
      },
      {
        "char": "⇵",
        "unicode": "21F5",
        "fr": "Flèche haut-bas barre double",
        "en": "Downwards arrow leftwards of upwards arrow"
      },
      {
        "char": "⇶",
        "unicode": "21F6",
        "fr": "Flèche droite barre double",
        "en": "Three rightwards arrows"
      },
      {
        "char": "⇷",
        "unicode": "21F7",
        "fr": "Flèche gauche barre double",
        "en": "Leftwards arrow with vertical stroke"
      },
      {
        "char": "⇸",
        "unicode": "21F8",
        "fr": "Flèche droite barre double",
        "en": "Rightwards arrow with vertical stroke"
      },
      {
        "char": "⇹",
        "unicode": "21F9",
        "fr": "Flèche gauche-droite barre double",
        "en": "Left right arrow with vertical stroke"
      },
      {
        "char": "⇺",
        "unicode": "21FA",
        "fr": "Flèche gauche barre double",
        "en": "Leftwards arrow with double vertical stroke"
      },
      {
        "char": "⇻",
        "unicode": "21FB",
        "fr": "Flèche droite barre double",
        "en": "Rightwards arrow with double vertical stroke"
      },
      {
        "char": "⇼",
        "unicode": "21FC",
        "fr": "Flèche gauche-droite barre double",
        "en": "Left right arrow with double vertical stroke"
      },
      {
        "char": "⇽",
        "unicode": "21FD",
        "fr": "Flèche gauche boucle",
        "en": "Leftwards open-headed arrow"
      },
      {
        "char": "⇾",
        "unicode": "21FE",
        "fr": "Flèche droite boucle",
        "en": "Rightwards open-headed arrow"
      },
      {
        "char": "⇿",
        "unicode": "21FF",
        "fr": "Flèche gauche-droite boucle",
        "en": "Left right open-headed arrow"
      }
    ]
  },
  {
    "name": "mathematical-operators",
    "fr": "Opérateurs mathématiques",
    "en": "Mathematical Operators",
    "characters": [
      { "char": "∀", "unicode": "2200", "fr": "Pour tout", "en": "For all" },
      {
        "char": "∁",
        "unicode": "2201",
        "fr": "Complément",
        "en": "Complement"
      },
      {
        "char": "∂",
        "unicode": "2202",
        "fr": "Dérivée partielle",
        "en": "Partial differential"
      },
      {
        "char": "∃",
        "unicode": "2203",
        "fr": "Il existe",
        "en": "There exists"
      },
      {
        "char": "∄",
        "unicode": "2204",
        "fr": "Il n'existe pas",
        "en": "There does not exist"
      },
      {
        "char": "∅",
        "unicode": "2205",
        "fr": "Ensemble vide",
        "en": "Empty set"
      },
      { "char": "∇", "unicode": "2207", "fr": "Nabla", "en": "Nabla" },
      {
        "char": "∈",
        "unicode": "2208",
        "fr": "Appartient à",
        "en": "Element of"
      },
      {
        "char": "∉",
        "unicode": "2209",
        "fr": "N'appartient pas à",
        "en": "Not an element of"
      },
      {
        "char": "∊",
        "unicode": "220A",
        "fr": "Petit appartient à",
        "en": "Small element of"
      },
      {
        "char": "∋",
        "unicode": "220B",
        "fr": "Contient comme élément",
        "en": "Contains as member"
      },
      {
        "char": "∌",
        "unicode": "220C",
        "fr": "Ne contient pas comme élément",
        "en": "Does not contain as member"
      },
      {
        "char": "∍",
        "unicode": "220D",
        "fr": "Petit contient comme élément",
        "en": "Small contains as member"
      },
      {
        "char": "∎",
        "unicode": "220E",
        "fr": "Fin de preuve",
        "en": "End of proof"
      },
      {
        "char": "∏",
        "unicode": "220F",
        "fr": "Produit",
        "en": "N-ary product"
      },
      {
        "char": "∐",
        "unicode": "2210",
        "fr": "Coproduct",
        "en": "N-ary coproduct"
      },
      {
        "char": "∑",
        "unicode": "2211",
        "fr": "Somme",
        "en": "N-ary summation"
      },
      {
        "char": "−",
        "unicode": "2212",
        "fr": "Signe moins",
        "en": "Minus sign"
      },
      {
        "char": "∓",
        "unicode": "2213",
        "fr": "Plus ou moins inversé",
        "en": "Minus-or-plus sign"
      },
      { "char": "∔", "unicode": "2214", "fr": "Plus pointé", "en": "Dot plus" },
      {
        "char": "∕",
        "unicode": "2215",
        "fr": "Barre oblique fractionnaire",
        "en": "Division slash"
      },
      {
        "char": "∖",
        "unicode": "2216",
        "fr": "Barre oblique inversée",
        "en": "Set minus"
      },
      {
        "char": "∗",
        "unicode": "2217",
        "fr": "Astérisque opérateur",
        "en": "Asterisk operator"
      },
      {
        "char": "∘",
        "unicode": "2218",
        "fr": "Cercle opérateur",
        "en": "Ring operator"
      },
      {
        "char": "∙",
        "unicode": "2219",
        "fr": "Point opérateur",
        "en": "Bullet operator"
      },
      {
        "char": "√",
        "unicode": "221A",
        "fr": "Racine carrée",
        "en": "Square root"
      },
      {
        "char": "∛",
        "unicode": "221B",
        "fr": "Racine cubique",
        "en": "Cube root"
      },
      {
        "char": "∜",
        "unicode": "221C",
        "fr": "Racine quatrième",
        "en": "Fourth root"
      },
      {
        "char": "∝",
        "unicode": "221D",
        "fr": "Proportionnel à",
        "en": "Proportional to"
      },
      { "char": "∞", "unicode": "221E", "fr": "Infini", "en": "Infinity" },
      {
        "char": "∟",
        "unicode": "221F",
        "fr": "Angle droit",
        "en": "Right angle"
      },
      { "char": "∠", "unicode": "2220", "fr": "Angle", "en": "Angle" },
      {
        "char": "∡",
        "unicode": "2221",
        "fr": "Angle mesuré",
        "en": "Measured angle"
      },
      {
        "char": "∢",
        "unicode": "2222",
        "fr": "Angle sphérique",
        "en": "Spherical angle"
      },
      { "char": "∣", "unicode": "2223", "fr": "Divise", "en": "Divides" },
      {
        "char": "∤",
        "unicode": "2224",
        "fr": "Ne divise pas",
        "en": "Does not divide"
      },
      {
        "char": "∥",
        "unicode": "2225",
        "fr": "Parallèle à",
        "en": "Parallel to"
      },
      {
        "char": "∦",
        "unicode": "2226",
        "fr": "Non parallèle à",
        "en": "Not parallel to"
      },
      {
        "char": "∧",
        "unicode": "2227",
        "fr": "Et logique",
        "en": "Logical and"
      },
      {
        "char": "∨",
        "unicode": "2228",
        "fr": "Ou logique",
        "en": "Logical or"
      },
      {
        "char": "∩",
        "unicode": "2229",
        "fr": "Intersection",
        "en": "Intersection"
      },
      { "char": "∪", "unicode": "222A", "fr": "Union", "en": "Union" },
      { "char": "∫", "unicode": "222B", "fr": "Intégrale", "en": "Integral" },
      {
        "char": "∬",
        "unicode": "222C",
        "fr": "Double intégrale",
        "en": "Double integral"
      },
      {
        "char": "∭",
        "unicode": "222D",
        "fr": "Triple intégrale",
        "en": "Triple integral"
      },
      {
        "char": "∮",
        "unicode": "222E",
        "fr": "Intégrale curviligne",
        "en": "Contour integral"
      },
      {
        "char": "∯",
        "unicode": "222F",
        "fr": "Intégrale de surface",
        "en": "Surface integral"
      },
      {
        "char": "∰",
        "unicode": "2230",
        "fr": "Intégrale de volume",
        "en": "Volume integral"
      },
      {
        "char": "∱",
        "unicode": "2231",
        "fr": "Intégrale de ligne",
        "en": "Clockwise integral"
      },
      {
        "char": "∲",
        "unicode": "2232",
        "fr": "Intégrale de ligne",
        "en": "Clockwise contour integral"
      },
      {
        "char": "∳",
        "unicode": "2233",
        "fr": "Intégrale de ligne",
        "en": "Anticlockwise contour integral"
      },
      { "char": "∴", "unicode": "2234", "fr": "Donc", "en": "Therefore" },
      { "char": "∵", "unicode": "2235", "fr": "Parce que", "en": "Because" },
      { "char": "∶", "unicode": "2236", "fr": "Ratio", "en": "Ratio" },
      {
        "char": "∷",
        "unicode": "2237",
        "fr": "Proportion",
        "en": "Proportion"
      },
      {
        "char": "∸",
        "unicode": "2238",
        "fr": "Moins pointé",
        "en": "Dot minus"
      },
      { "char": "∹", "unicode": "2239", "fr": "Quotient", "en": "Excess" },
      {
        "char": "∺",
        "unicode": "223A",
        "fr": "Géométrique",
        "en": "Geometric proportion"
      },
      {
        "char": "∻",
        "unicode": "223B",
        "fr": "Homothétique",
        "en": "Homothetic"
      },
      { "char": "∼", "unicode": "223C", "fr": "Tilde", "en": "Tilde operator" },
      {
        "char": "∽",
        "unicode": "223D",
        "fr": "Tilde inversé",
        "en": "Reversed tilde"
      },
      {
        "char": "∾",
        "unicode": "223E",
        "fr": "Tilde en chef",
        "en": "Inverted lazy S"
      },
      {
        "char": "∿",
        "unicode": "223F",
        "fr": "S sinusoïdal",
        "en": "Sine wave"
      },
      {
        "char": "≀",
        "unicode": "2240",
        "fr": "Wreath product",
        "en": "Wreath product"
      },
      {
        "char": "≁",
        "unicode": "2241",
        "fr": "Non similaire à",
        "en": "Not tilde"
      },
      {
        "char": "≂",
        "unicode": "2242",
        "fr": "Tilde ou égal à",
        "en": "Minus tilde"
      },
      {
        "char": "≃",
        "unicode": "2243",
        "fr": "Asymptotiquement égal à",
        "en": "Asymptotically equal to"
      },
      {
        "char": "≄",
        "unicode": "2244",
        "fr": "Non asymptotiquement égal à",
        "en": "Not asymptotically equal to"
      },
      {
        "char": "≅",
        "unicode": "2245",
        "fr": "Approximativement égal à",
        "en": "Approximately equal to"
      },
      {
        "char": "≆",
        "unicode": "2246",
        "fr": "Approximativement égal ou non égal à",
        "en": "Approximately but not actually equal to"
      },
      {
        "char": "≇",
        "unicode": "2247",
        "fr": "Non congruent à",
        "en": "Neither approximately nor actually equal to"
      },
      {
        "char": "≈",
        "unicode": "2248",
        "fr": "Presque égal à",
        "en": "Almost equal to"
      },
      {
        "char": "≉",
        "unicode": "2249",
        "fr": "Non presque égal à",
        "en": "Not almost equal to"
      },
      {
        "char": "≊",
        "unicode": "224A",
        "fr": "Presque égal ou égal à",
        "en": "Almost equal or equal to"
      },
      {
        "char": "≋",
        "unicode": "224B",
        "fr": "Triple tilde",
        "en": "Triple tilde"
      },
      {
        "char": "≌",
        "unicode": "224C",
        "fr": "Tous égaux à",
        "en": "All equal to"
      },
      {
        "char": "≍",
        "unicode": "224D",
        "fr": "Égal à par définition",
        "en": "Equivalent to"
      },
      {
        "char": "≎",
        "unicode": "224E",
        "fr": "Géométriquement égal à",
        "en": "Geometrically equivalent to"
      },
      {
        "char": "≏",
        "unicode": "224F",
        "fr": "Différent de",
        "en": "Difference between"
      },
      {
        "char": "≐",
        "unicode": "2250",
        "fr": "Approche la limite",
        "en": "Approaches the limit"
      },
      {
        "char": "≑",
        "unicode": "2251",
        "fr": "Géométriquement égal à",
        "en": "Geometrically equal to"
      },
      {
        "char": "≒",
        "unicode": "2252",
        "fr": "Approximativement égal à",
        "en": "Approximately equal to or the image of"
      },
      {
        "char": "≓",
        "unicode": "2253",
        "fr": "Image de",
        "en": "Image of or approximately equal to"
      },
      {
        "char": "≔",
        "unicode": "2254",
        "fr": "Défini comme",
        "en": "Colon equals"
      },
      {
        "char": "≕",
        "unicode": "2255",
        "fr": "Égal deux-points",
        "en": "Equals colon"
      },
      {
        "char": "≖",
        "unicode": "2256",
        "fr": "Égal à par définition",
        "en": "Ring in equal to"
      },
      {
        "char": "≗",
        "unicode": "2257",
        "fr": "Égal à par définition",
        "en": "Ring equal to"
      },
      {
        "char": "≙",
        "unicode": "2259",
        "fr": "Correspond à",
        "en": "Corresponds to"
      },
      {
        "char": "≚",
        "unicode": "225A",
        "fr": "Étoile égale à",
        "en": "Star equals"
      },
      {
        "char": "≛",
        "unicode": "225B",
        "fr": "Delta égale à",
        "en": "Delta equal to"
      },
      {
        "char": "≜",
        "unicode": "225C",
        "fr": "Défini comme",
        "en": "Equal to by definition"
      },
      {
        "char": "≝",
        "unicode": "225D",
        "fr": "Égal à par définition",
        "en": "Measured by"
      },
      {
        "char": "≞",
        "unicode": "225E",
        "fr": "Égal à par définition",
        "en": "Dotted equal to"
      },
      {
        "char": "≟",
        "unicode": "225F",
        "fr": "Égal à ou non",
        "en": "Questioned equal to"
      },
      {
        "char": "≠",
        "unicode": "2260",
        "fr": "Différent de",
        "en": "Not equal to"
      },
      {
        "char": "≡",
        "unicode": "2261",
        "fr": "Identique à",
        "en": "Identical to"
      },
      {
        "char": "≢",
        "unicode": "2262",
        "fr": "Non identique à",
        "en": "Not identical to"
      },
      {
        "char": "≣",
        "unicode": "2263",
        "fr": "Strictement équivalent à",
        "en": "Strictly equivalent to"
      },
      {
        "char": "≤",
        "unicode": "2264",
        "fr": "Inférieur ou égal à",
        "en": "Less-than or equal to"
      },
      {
        "char": "≥",
        "unicode": "2265",
        "fr": "Supérieur ou égal à",
        "en": "Greater-than or equal to"
      },
      {
        "char": "≦",
        "unicode": "2266",
        "fr": "Inférieur ou égal à",
        "en": "Less-than over equal to"
      },
      {
        "char": "≧",
        "unicode": "2267",
        "fr": "Supérieur ou égal à",
        "en": "Greater-than over equal to"
      },
      {
        "char": "≨",
        "unicode": "2268",
        "fr": "Inférieur ou égal à barré",
        "en": "Less-than but not equal to"
      },
      {
        "char": "≩",
        "unicode": "2269",
        "fr": "Supérieur ou égal à barré",
        "en": "Greater-than but not equal to"
      },
      {
        "char": "≪",
        "unicode": "226A",
        "fr": "Beaucoup plus petit que",
        "en": "Much less-than"
      },
      {
        "char": "≫",
        "unicode": "226B",
        "fr": "Beaucoup plus grand que",
        "en": "Much greater-than"
      },
      { "char": "≬", "unicode": "226C", "fr": "Entre", "en": "Between" },
      {
        "char": "≭",
        "unicode": "226D",
        "fr": "Non équivalent à",
        "en": "Not equivalent to"
      },
      {
        "char": "≮",
        "unicode": "226E",
        "fr": "Non inférieur à",
        "en": "Not less-than"
      },
      {
        "char": "≯",
        "unicode": "226F",
        "fr": "Non supérieur à",
        "en": "Not greater-than"
      },
      {
        "char": "≰",
        "unicode": "2270",
        "fr": "Non inférieur ou égal à",
        "en": "Neither less-than nor equal to"
      },
      {
        "char": "≱",
        "unicode": "2271",
        "fr": "Non supérieur ou égal à",
        "en": "Neither greater-than nor equal to"
      },
      {
        "char": "≲",
        "unicode": "2272",
        "fr": "Inférieur ou égal à approximatif",
        "en": "Less-than or equivalent to"
      },
      {
        "char": "≳",
        "unicode": "2273",
        "fr": "Supérieur ou égal à approximatif",
        "en": "Greater-than or equivalent to"
      },
      {
        "char": "≴",
        "unicode": "2274",
        "fr": "Non inférieur ou égal à approximatif",
        "en": "Neither less-than nor equivalent to"
      },
      {
        "char": "≵",
        "unicode": "2275",
        "fr": "Non supérieur ou égal à approximatif",
        "en": "Neither greater-than nor equivalent to"
      },
      {
        "char": "≶",
        "unicode": "2276",
        "fr": "Inférieur à ou supérieur à",
        "en": "Less-than or greater-than"
      },
      {
        "char": "≷",
        "unicode": "2277",
        "fr": "Supérieur à ou inférieur à",
        "en": "Greater-than or less-than"
      },
      {
        "char": "≸",
        "unicode": "2278",
        "fr": "Non inférieur à ou supérieur à",
        "en": "Neither less-than nor greater-than"
      },
      {
        "char": "≹",
        "unicode": "2279",
        "fr": "Non supérieur à ou inférieur à",
        "en": "Neither greater-than nor less-than"
      },
      {
        "char": "≺",
        "unicode": "227A",
        "fr": "Précède",
        "en": "Precedes"
      },
      {
        "char": "≻",
        "unicode": "227B",
        "fr": "Succède",
        "en": "Succeeds"
      },
      {
        "char": "≼",
        "unicode": "227C",
        "fr": "Précède ou égal à",
        "en": "Precedes or equal to"
      },
      {
        "char": "≽",
        "unicode": "227D",
        "fr": "Succède ou égal à",
        "en": "Succeeds or equal to"
      },
      {
        "char": "≾",
        "unicode": "227E",
        "fr": "Précède ou équivalent à",
        "en": "Precedes or equivalent to"
      },
      {
        "char": "≿",
        "unicode": "227F",
        "fr": "Succède ou équivalent à",
        "en": "Succeeds or equivalent to"
      },
      {
        "char": "⊀",
        "unicode": "2280",
        "fr": "Ne précède pas",
        "en": "Does not precede"
      },
      {
        "char": "⊁",
        "unicode": "2281",
        "fr": "Ne succède pas",
        "en": "Does not succeed"
      },
      {
        "char": "⊂",
        "unicode": "2282",
        "fr": "Inclus dans",
        "en": "Subset of"
      },
      {
        "char": "⊃",
        "unicode": "2283",
        "fr": "Inclut",
        "en": "Superset of"
      },
      {
        "char": "⊄",
        "unicode": "2284",
        "fr": "Non inclus dans",
        "en": "Not a subset of"
      },
      {
        "char": "⊅",
        "unicode": "2285",
        "fr": "N'inclut pas",
        "en": "Not a superset of"
      },
      {
        "char": "⊆",
        "unicode": "2286",
        "fr": "Inclus ou égal à",
        "en": "Subset of or equal to"
      },
      {
        "char": "⊇",
        "unicode": "2287",
        "fr": "Inclut ou égal à",
        "en": "Superset of or equal to"
      },
      {
        "char": "⊈",
        "unicode": "2288",
        "fr": "Non inclus ou égal à",
        "en": "Neither a subset of nor equal to"
      },
      {
        "char": "⊉",
        "unicode": "2289",
        "fr": "N'inclut ni égal à",
        "en": "Neither a superset of nor equal to"
      },
      {
        "char": "⊊",
        "unicode": "228A",
        "fr": "Sous-ensemble propre",
        "en": "Subset of with not equal to"
      },
      {
        "char": "⊋",
        "unicode": "228B",
        "fr": "Sur-ensemble propre",
        "en": "Superset of with not equal to"
      },
      {
        "char": "⊌",
        "unicode": "228C",
        "fr": "Multiset",
        "en": "Multiset"
      },
      {
        "char": "⊍",
        "unicode": "228D",
        "fr": "Multiset union",
        "en": "Multiset multiplication"
      },
      {
        "char": "⊎",
        "unicode": "228E",
        "fr": "Union disjointe",
        "en": "Multiset union"
      },
      {
        "char": "⊏",
        "unicode": "228F",
        "fr": "Sous-ensemble carré",
        "en": "Square subset"
      },
      {
        "char": "⊐",
        "unicode": "2290",
        "fr": "Sur-ensemble carré",
        "en": "Square superset"
      },
      {
        "char": "⊑",
        "unicode": "2291",
        "fr": "Sous-ensemble carré ou égal",
        "en": "Square subset or equal"
      },
      {
        "char": "⊒",
        "unicode": "2292",
        "fr": "Sur-ensemble carré ou égal",
        "en": "Square superset or equal"
      },
      {
        "char": "⊓",
        "unicode": "2293",
        "fr": "Intersection carré",
        "en": "Square intersection"
      },
      {
        "char": "⊔",
        "unicode": "2294",
        "fr": "Union carré",
        "en": "Square union"
      },
      {
        "char": "⊕",
        "unicode": "2295",
        "fr": "Plus cerclé",
        "en": "Circled plus"
      },
      {
        "char": "⊖",
        "unicode": "2296",
        "fr": "Moins cerclé",
        "en": "Circled minus"
      },
      {
        "char": "⊗",
        "unicode": "2297",
        "fr": "Fois cerclé",
        "en": "Circled times"
      },
      {
        "char": "⊘",
        "unicode": "2298",
        "fr": "Divisé cerclé",
        "en": "Circled division slash"
      },
      {
        "char": "⊙",
        "unicode": "2299",
        "fr": "Produit cerclé",
        "en": "Circled dot operator"
      },
      {
        "char": "⊚",
        "unicode": "229A",
        "fr": "Cercle avec point",
        "en": "Circled ring operator"
      },
      {
        "char": "⊛",
        "unicode": "229B",
        "fr": "Cercle étoile",
        "en": "Circled asterisk operator"
      },
      {
        "char": "⊜",
        "unicode": "229C",
        "fr": "Cercle égal",
        "en": "Circled equals"
      },
      {
        "char": "⊝",
        "unicode": "229D",
        "fr": "Cercle tiret",
        "en": "Circled dash"
      },
      {
        "char": "⊞",
        "unicode": "229E",
        "fr": "Carré plus",
        "en": "Squared plus"
      },
      {
        "char": "⊟",
        "unicode": "229F",
        "fr": "Carré moins",
        "en": "Squared minus"
      },
      {
        "char": "⊠",
        "unicode": "22A0",
        "fr": "Carré fois",
        "en": "Squared times"
      },
      {
        "char": "⊡",
        "unicode": "22A1",
        "fr": "Carré point",
        "en": "Squared dot operator"
      },
      {
        "char": "⊢",
        "unicode": "22A2",
        "fr": "Produit logique",
        "en": "Right tack"
      },
      {
        "char": "⊣",
        "unicode": "22A3",
        "fr": "Produit logique inversé",
        "en": "Left tack"
      },
      {
        "char": "⊤",
        "unicode": "22A4",
        "fr": "Vrai logique",
        "en": "Down tack"
      },
      {
        "char": "⊥",
        "unicode": "22A5",
        "fr": "Faux logique",
        "en": "Up tack"
      },
      {
        "char": "⊦",
        "unicode": "22A6",
        "fr": "Assertion",
        "en": "Assertion"
      },
      {
        "char": "⊧",
        "unicode": "22A7",
        "fr": "Modèle",
        "en": "Models"
      },
      {
        "char": "⊨",
        "unicode": "22A8",
        "fr": "Satisfaisable",
        "en": "True"
      },
      {
        "char": "⊩",
        "unicode": "22A9",
        "fr": "Forces",
        "en": "Forces"
      },
      {
        "char": "⊪",
        "unicode": "22AA",
        "fr": "Double assertion",
        "en": "Triple vertical bar right turnstile"
      },
      {
        "char": "⊫",
        "unicode": "22AB",
        "fr": "Double assertion inversée",
        "en": "Double vertical bar double right turnstile"
      },
      {
        "char": "⊬",
        "unicode": "22AC",
        "fr": "Non assertion",
        "en": "Does not prove"
      },
      {
        "char": "⊭",
        "unicode": "22AD",
        "fr": "Non modèle",
        "en": "Not true"
      },
      {
        "char": "⊮",
        "unicode": "22AE",
        "fr": "Non forces",
        "en": "Does not force"
      },
      {
        "char": "⊯",
        "unicode": "22AF",
        "fr": "Non assertion double",
        "en": "Negated double vertical bar double right turnstile"
      },
      {
        "char": "⊰",
        "unicode": "22B0",
        "fr": "Précède courbé",
        "en": "Precedes under relation"
      },
      {
        "char": "⊱",
        "unicode": "22B1",
        "fr": "Succède courbé",
        "en": "Succeeds under relation"
      },
      {
        "char": "⊲",
        "unicode": "22B2",
        "fr": "Triangle gauche inclus",
        "en": "Normal subgroup of"
      },
      {
        "char": "⊳",
        "unicode": "22B3",
        "fr": "Triangle droite inclus",
        "en": "Contains as normal subgroup"
      },
      {
        "char": "⊴",
        "unicode": "22B4",
        "fr": "Triangle gauche inclus ou égal",
        "en": "Normal subgroup of or equal to"
      },
      {
        "char": "⊵",
        "unicode": "22B5",
        "fr": "Triangle droite inclus ou égal",
        "en": "Contains as normal subgroup or equal to"
      },
      {
        "char": "⊶",
        "unicode": "22B6",
        "fr": "Triangle gauche inclus pointé",
        "en": "Original of"
      },
      {
        "char": "⊷",
        "unicode": "22B7",
        "fr": "Triangle droite inclus pointé",
        "en": "Image of"
      },
      {
        "char": "⊸",
        "unicode": "22B8",
        "fr": "Multimap",
        "en": "Multimap"
      },
      {
        "char": "⊹",
        "unicode": "22B9",
        "fr": "Plus pointé",
        "en": "Hermitian conjugate matrix"
      },
      {
        "char": "⊺",
        "unicode": "22BA",
        "fr": "Intercalé",
        "en": "Intercalate"
      },
      {
        "char": "⊻",
        "unicode": "22BB",
        "fr": "Ou exclusif",
        "en": "Xor"
      },
      {
        "char": "⊼",
        "unicode": "22BC",
        "fr": "Non et logique",
        "en": "Nand"
      },
      {
        "char": "⊽",
        "unicode": "22BD",
        "fr": "Non ou logique",
        "en": "Nor"
      },
      {
        "char": "⊾",
        "unicode": "22BE",
        "fr": "Angle droit barré",
        "en": "Right angle with arc"
      },
      {
        "char": "⊿",
        "unicode": "22BF",
        "fr": "Triangle rectangle",
        "en": "Right triangle"
      },
      {
        "char": "⋀",
        "unicode": "22C0",
        "fr": "Et logique n-aire",
        "en": "N-ary logical and"
      },
      {
        "char": "⋁",
        "unicode": "22C1",
        "fr": "Ou logique n-aire",
        "en": "N-ary logical or"
      },
      {
        "char": "⋂",
        "unicode": "22C2",
        "fr": "Intersection n-aire",
        "en": "N-ary intersection"
      },
      {
        "char": "⋃",
        "unicode": "22C3",
        "fr": "Union n-aire",
        "en": "N-ary union"
      },
      {
        "char": "⋄",
        "unicode": "22C4",
        "fr": "Diamant opérateur",
        "en": "Diamond operator"
      },
      {
        "char": "⋅",
        "unicode": "22C5",
        "fr": "Point opérateur",
        "en": "Dot operator"
      },
      {
        "char": "⋆",
        "unicode": "22C6",
        "fr": "Étoile opérateur",
        "en": "Star operator"
      },
      {
        "char": "⋇",
        "unicode": "22C7",
        "fr": "Division opérateur",
        "en": "Division times"
      },
      {
        "char": "⋈",
        "unicode": "22C8",
        "fr": "Jointure",
        "en": "Bowtie"
      },
      {
        "char": "⋉",
        "unicode": "22C9",
        "fr": "Jointure gauche",
        "en": "Left normal factor semidirect product"
      },
      {
        "char": "⋊",
        "unicode": "22CA",
        "fr": "Jointure droite",
        "en": "Right normal factor semidirect product"
      },
      {
        "char": "⋋",
        "unicode": "22CB",
        "fr": "Jointure gauche inversée",
        "en": "Left semidirect product"
      },
      {
        "char": "⋌",
        "unicode": "22CC",
        "fr": "Jointure droite inversée",
        "en": "Right semidirect product"
      },
      {
        "char": "⋍",
        "unicode": "22CD",
        "fr": "Égal à par définition",
        "en": "Reversed tilde equals"
      },
      {
        "char": "⋎",
        "unicode": "22CE",
        "fr": "Ou logique exclusif",
        "en": "Curly logical or"
      },
      {
        "char": "⋏",
        "unicode": "22CF",
        "fr": "Et logique exclusif",
        "en": "Curly logical and"
      },
      {
        "char": "⋐",
        "unicode": "22D0",
        "fr": "Sous-ensemble double",
        "en": "Double subset"
      },
      {
        "char": "⋑",
        "unicode": "22D1",
        "fr": "Sur-ensemble double",
        "en": "Double superset"
      },
      {
        "char": "⋒",
        "unicode": "22D2",
        "fr": "Intersection double",
        "en": "Double intersection"
      },
      {
        "char": "⋓",
        "unicode": "22D3",
        "fr": "Union double",
        "en": "Double union"
      },
      {
        "char": "⋔",
        "unicode": "22D4",
        "fr": "Pitchfork",
        "en": "Pitchfork"
      },
      {
        "char": "⋕",
        "unicode": "22D5",
        "fr": "Égalité avec point",
        "en": "Equal and parallel"
      },
      {
        "char": "⋖",
        "unicode": "22D6",
        "fr": "Inférieur à avec point",
        "en": "Less-than with dot"
      },
      {
        "char": "⋗",
        "unicode": "22D7",
        "fr": "Supérieur à avec point",
        "en": "Greater-than with dot"
      },
      {
        "char": "⋘",
        "unicode": "22D8",
        "fr": "Triple inférieur à",
        "en": "Very much less-than"
      },
      {
        "char": "⋙",
        "unicode": "22D9",
        "fr": "Triple supérieur à",
        "en": "Very much greater-than"
      },
      {
        "char": "⋚",
        "unicode": "22DA",
        "fr": "Inférieur ou égal à double",
        "en": "Less-than equal to or greater-than"
      },
      {
        "char": "⋛",
        "unicode": "22DB",
        "fr": "Supérieur ou égal à double",
        "en": "Greater-than equal to or less-than"
      },
      {
        "char": "⋜",
        "unicode": "22DC",
        "fr": "Inférieur ou égal à courbé",
        "en": "Equal to or less-than"
      },
      {
        "char": "⋝",
        "unicode": "22DD",
        "fr": "Supérieur ou égal à courbé",
        "en": "Equal to or greater-than"
      },
      {
        "char": "⋞",
        "unicode": "22DE",
        "fr": "Égal à ou précède",
        "en": "Equal to or precedes"
      },
      {
        "char": "⋟",
        "unicode": "22DF",
        "fr": "Égal à ou succède",
        "en": "Equal to or succeeds"
      },
      {
        "char": "⋠",
        "unicode": "22E0",
        "fr": "Non précède ou égal à",
        "en": "Does not precede or equal"
      },
      {
        "char": "⋡",
        "unicode": "22E1",
        "fr": "Non succède ou égal à",
        "en": "Does not succeed or equal"
      },
      {
        "char": "⋢",
        "unicode": "22E2",
        "fr": "Non sous-ensemble carré ou égal",
        "en": "Not square subset or equal"
      },
      {
        "char": "⋣",
        "unicode": "22E3",
        "fr": "Non sur-ensemble carré ou égal",
        "en": "Not square superset or equal"
      },
      {
        "char": "⋤",
        "unicode": "22E4",
        "fr": "Sous-ensemble carré barré",
        "en": "Square subset with not equal"
      },
      {
        "char": "⋥",
        "unicode": "22E5",
        "fr": "Sur-ensemble carré barré",
        "en": "Square superset with not equal"
      },
      {
        "char": "⋦",
        "unicode": "22E6",
        "fr": "Sous-ensemble barré",
        "en": "Not equal to or less-than"
      },
      {
        "char": "⋧",
        "unicode": "22E7",
        "fr": "Sur-ensemble barré",
        "en": "Not equal to or greater-than"
      },
      {
        "char": "⋨",
        "unicode": "22E8",
        "fr": "Précède barré",
        "en": "Not precedes"
      },
      {
        "char": "⋩",
        "unicode": "22E9",
        "fr": "Succède barré",
        "en": "Not succeeds"
      },
      {
        "char": "⋪",
        "unicode": "22EA",
        "fr": "Triangle gauche inclus barré",
        "en": "Not normal subgroup of"
      },
      {
        "char": "⋫",
        "unicode": "22EB",
        "fr": "Triangle droite inclus barré",
        "en": "Does not contain as normal subgroup"
      },
      {
        "char": "⋬",
        "unicode": "22EC",
        "fr": "Triangle gauche inclus ou égal barré",
        "en": "Not normal subgroup of or equal"
      },
      {
        "char": "⋭",
        "unicode": "22ED",
        "fr": "Triangle droite inclus ou égal barré",
        "en": "Does not contain as normal subgroup or equal"
      },
      {
        "char": "⋮",
        "unicode": "22EE",
        "fr": "Points verticaux",
        "en": "Vertical ellipsis"
      },
      {
        "char": "⋯",
        "unicode": "22EF",
        "fr": "Points horizontaux",
        "en": "Midline horizontal ellipsis"
      },
      {
        "char": "⋰",
        "unicode": "22F0",
        "fr": "Points diagonaux haut",
        "en": "Up right diagonal ellipsis"
      },
      {
        "char": "⋱",
        "unicode": "22F1",
        "fr": "Points diagonaux bas",
        "en": "Down right diagonal ellipsis"
      },

      {
        "char": "ᵃ",
        "unicode": "1D43",
        "fr": "Lettre script minuscule a",
        "en": "Modifier letter small a"
      },
      {
        "char": "ᵇ",
        "unicode": "1D47",
        "fr": "Lettre script minuscule b",
        "en": "Modifier letter small b"
      },
      {
        "char": "ᵈ",
        "unicode": "1D48",
        "fr": "Lettre script minuscule d",
        "en": "Modifier letter small d"
      },
      {
        "char": "ᵉ",
        "unicode": "1D49",
        "fr": "Lettre script minuscule e",
        "en": "Modifier letter small e"
      },
      {
        "char": "ᵊ",
        "unicode": "1D4A",
        "fr": "Lettre script minuscule schwa",
        "en": "Modifier letter small schwa"
      },
      {
        "char": "ᵋ",
        "unicode": "1D4B",
        "fr": "Lettre script minuscule g",
        "en": "Modifier letter small g"
      },
      {
        "char": "ᵌ",
        "unicode": "1D4C",
        "fr": "Lettre script minuscule h",
        "en": "Modifier letter small h"
      },
      {
        "char": "ᵍ",
        "unicode": "1D4D",
        "fr": "Lettre script minuscule i",
        "en": "Modifier letter small i"
      },
      {
        "char": "ᵎ",
        "unicode": "1D4E",
        "fr": "Lettre script minuscule j",
        "en": "Modifier letter small j"
      },
      {
        "char": "ᵏ",
        "unicode": "1D4F",
        "fr": "Lettre script minuscule k",
        "en": "Modifier letter small k"
      },
      {
        "char": "ᵐ",
        "unicode": "1D50",
        "fr": "lettre script minuscule m",
        "en": "Modifier letter small m"
      },
      {
        "char": "ᵑ",
        "unicode": "1D51",
        "fr": "Lettre script minuscule n",
        "en": "Modifier letter small n"
      },
      {
        "char": "ᵒ",
        "unicode": "1D52",
        "fr": "Lettre script minuscule o",
        "en": "Modifier letter small o"
      },
      {
        "char": "ᵓ",
        "unicode": "1D53",
        "fr": "Lettre script minuscule p",
        "en": "Modifier letter small p"
      },
      {
        "char": "ᵔ",
        "unicode": "1D54",
        "fr": "Lettre script minuscule r",
        "en": "Modifier letter small r"
      },
      {
        "char": "ᵕ",
        "unicode": "1D55",
        "fr": "Lettre script minuscule s",
        "en": "Modifier letter small s"
      },
      {
        "char": "ᵖ",
        "unicode": "1D56",
        "fr": "Lettre script minuscule t",
        "en": "Modifier letter small t"
      },
      {
        "char": "ᵗ",
        "unicode": "1D57",
        "fr": "Lettre script minuscule u",
        "en": "Modifier letter small u"
      },
      {
        "char": "ᵘ",
        "unicode": "1D58",
        "fr": "Lettre script minuscule v",
        "en": "Modifier letter small v"
      }
    ]
  },
  {
    "name": "box-drawing",
    "fr": "Filets",
    "en": "Box Drawing",
    "characters": [
      {
        "char": "─",
        "unicode": "2500",
        "fr": "Filet horizontal fin",
        "en": "Box drawings light horizontal"
      },
      {
        "char": "━",
        "unicode": "2501",
        "fr": "Filet horizontal épais",
        "en": "Box drawings heavy horizontal"
      },
      {
        "char": "│",
        "unicode": "2502",
        "fr": "Filet vertical fin",
        "en": "Box drawings light vertical"
      },
      {
        "char": "┃",
        "unicode": "2503",
        "fr": "Filet vertical épais",
        "en": "Box drawings heavy vertical"
      },
      {
        "char": "┄",
        "unicode": "2504",
        "fr": "Filet horizontal fin pointillé",
        "en": "Box drawings light triple dash horizontal"
      },
      {
        "char": "┅",
        "unicode": "2505",
        "fr": "Filet horizontal épais pointillé",
        "en": "Box drawings heavy triple dash horizontal"
      },
      {
        "char": "┆",
        "unicode": "2506",
        "fr": "Filet vertical fin pointillé",
        "en": "Box drawings light triple dash vertical"
      },
      {
        "char": "┇",
        "unicode": "2507",
        "fr": "Filet vertical épais pointillé",
        "en": "Box drawings heavy triple dash vertical"
      },
      {
        "char": "┈",
        "unicode": "2508",
        "fr": "Filet horizontal fin quadruple",
        "en": "Box drawings light quadruple dash horizontal"
      },
      {
        "char": "┉",
        "unicode": "2509",
        "fr": "Filet horizontal épais quadruple",
        "en": "Box drawings heavy quadruple dash horizontal"
      },
      {
        "char": "┊",
        "unicode": "250A",
        "fr": "Filet vertical fin quadruple",
        "en": "Box drawings light quadruple dash vertical"
      },
      {
        "char": "┋",
        "unicode": "250B",
        "fr": "Filet vertical épais quadruple",
        "en": "Box drawings heavy quadruple dash vertical"
      },
      {
        "char": "┌",
        "unicode": "250C",
        "fr": "Coin haut gauche fin",
        "en": "Box drawings light down and right"
      },
      {
        "char": "┍",
        "unicode": "250D",
        "fr": "Coin haut gauche fin/épais",
        "en": "Box drawings down light and right heavy"
      },
      {
        "char": "┎",
        "unicode": "250E",
        "fr": "Coin haut gauche épais/fin",
        "en": "Box drawings down heavy and right light"
      },
      {
        "char": "┏",
        "unicode": "250F",
        "fr": "Coin haut gauche épais",
        "en": "Box drawings heavy down and right"
      },
      {
        "char": "┐",
        "unicode": "2510",
        "fr": "Coin haut droit fin",
        "en": "Box drawings light down and left"
      },
      {
        "char": "┑",
        "unicode": "2511",
        "fr": "Coin haut droit fin/épais",
        "en": "Box drawings down light and left heavy"
      },
      {
        "char": "┒",
        "unicode": "2512",
        "fr": "Coin haut droit épais/fin",
        "en": "Box drawings down heavy and left light"
      },
      {
        "char": "┓",
        "unicode": "2513",
        "fr": "Coin haut droit épais",
        "en": "Box drawings heavy down and left"
      },
      {
        "char": "└",
        "unicode": "2514",
        "fr": "Coin bas gauche fin",
        "en": "Box drawings light up and right"
      },
      {
        "char": "┕",
        "unicode": "2515",
        "fr": "Coin bas gauche fin/épais",
        "en": "Box drawings up light and right heavy"
      },
      {
        "char": "┖",
        "unicode": "2516",
        "fr": "Coin bas gauche épais/fin",
        "en": "Box drawings up heavy and right light"
      },
      {
        "char": "┗",
        "unicode": "2517",
        "fr": "Coin bas gauche épais",
        "en": "Box drawings heavy up and right"
      },
      {
        "char": "┘",
        "unicode": "2518",
        "fr": "Coin bas droit fin",
        "en": "Box drawings light up and left"
      },
      {
        "char": "┙",
        "unicode": "2519",
        "fr": "Coin bas droit fin/épais",
        "en": "Box drawings up light and left heavy"
      },
      {
        "char": "┚",
        "unicode": "251A",
        "fr": "Coin bas droit épais/fin",
        "en": "Box drawings up heavy and left light"
      },
      {
        "char": "┛",
        "unicode": "251B",
        "fr": "Coin bas droit épais",
        "en": "Box drawings heavy up and left"
      },
      {
        "char": "├",
        "unicode": "251C",
        "fr": "T gauche fin",
        "en": "Box drawings light vertical and right"
      },
      {
        "char": "┝",
        "unicode": "251D",
        "fr": "T gauche fin/épais",
        "en": "Box drawings vertical light and right heavy"
      },
      {
        "char": "┞",
        "unicode": "251E",
        "fr": "T gauche épais/fin",
        "en": "Box drawings vertical heavy and right light"
      },
      {
        "char": "┟",
        "unicode": "251F",
        "fr": "T gauche fin/fin/épais",
        "en": "Box drawings down light and right up heavy"
      },
      {
        "char": "┠",
        "unicode": "2520",
        "fr": "T gauche épais/fin/fin",
        "en": "Box drawings down heavy and right up light"
      },
      {
        "char": "┡",
        "unicode": "2521",
        "fr": "T gauche fin/épais/fin",
        "en": "Box drawings up light and right down heavy"
      },
      {
        "char": "┢",
        "unicode": "2522",
        "fr": "T gauche épais/épais/fin",
        "en": "Box drawings up heavy and right down light"
      },
      {
        "char": "┣",
        "unicode": "2523",
        "fr": "T gauche épais",
        "en": "Box drawings heavy vertical and right"
      },
      {
        "char": "┤",
        "unicode": "2524",
        "fr": "T droit fin",
        "en": "Box drawings light vertical and left"
      },
      {
        "char": "┥",
        "unicode": "2525",
        "fr": "T droit fin/épais",
        "en": "Box drawings vertical light and left heavy"
      },
      {
        "char": "┦",
        "unicode": "2526",
        "fr": "T droit épais/fin",
        "en": "Box drawings vertical heavy and left light"
      },
      {
        "char": "┧",
        "unicode": "2527",
        "fr": "T droit fin/fin/épais",
        "en": "Box drawings down light and left up heavy"
      },
      {
        "char": "┨",
        "unicode": "2528",
        "fr": "T droit épais/fin/fin",
        "en": "Box drawings down heavy and left up light"
      },
      {
        "char": "┩",
        "unicode": "2529",
        "fr": "T droit fin/épais/fin",
        "en": "Box drawings up light and left down heavy"
      },
      {
        "char": "┪",
        "unicode": "252A",
        "fr": "T droit épais/épais/fin",
        "en": "Box drawings up heavy and left down light"
      },
      {
        "char": "┫",
        "unicode": "252B",
        "fr": "T droit épais",
        "en": "Box drawings heavy vertical and left"
      },
      {
        "char": "┬",
        "unicode": "252C",
        "fr": "T haut fin",
        "en": "Box drawings light down and horizontal"
      },
      {
        "char": "┭",
        "unicode": "252D",
        "fr": "T haut fin/épais",
        "en": "Box drawings down light and horizontal heavy"
      },
      {
        "char": "┮",
        "unicode": "252E",
        "fr": "T haut épais/fin",
        "en": "Box drawings down heavy and horizontal light"
      },
      {
        "char": "┯",
        "unicode": "252F",
        "fr": "T haut fin/fin/épais",
        "en": "Box drawings right light and horizontal down heavy"
      },
      {
        "char": "┰",
        "unicode": "2530",
        "fr": "T haut épais/fin/fin",
        "en": "Box drawings right heavy and horizontal down light"
      },
      {
        "char": "┱",
        "unicode": "2531",
        "fr": "T haut fin/épais/fin",
        "en": "Box drawings left light and horizontal down heavy"
      },
      {
        "char": "┲",
        "unicode": "2532",
        "fr": "T haut épais/épais/fin",
        "en": "Box drawings left heavy and horizontal down light"
      },
      {
        "char": "┳",
        "unicode": "2533",
        "fr": "T haut épais",
        "en": "Box drawings heavy down and horizontal"
      },
      {
        "char": "┴",
        "unicode": "2534",
        "fr": "T bas fin",
        "en": "Box drawings light up and horizontal"
      },
      {
        "char": "┵",
        "unicode": "2535",
        "fr": "T bas fin/épais",
        "en": "Box drawings up light and horizontal heavy"
      },
      {
        "char": "┶",
        "unicode": "2536",
        "fr": "T bas épais/fin",
        "en": "Box drawings up heavy and horizontal light"
      },
      {
        "char": "┷",
        "unicode": "2537",
        "fr": "T bas fin/fin/épais",
        "en": "Box drawings right light and horizontal up heavy"
      },
      {
        "char": "┸",
        "unicode": "2538",
        "fr": "T bas épais/fin/fin",
        "en": "Box drawings right heavy and horizontal up light"
      },
      {
        "char": "┹",
        "unicode": "2539",
        "fr": "T bas fin/épais/fin",
        "en": "Box drawings left light and horizontal up heavy"
      },
      {
        "char": "┺",
        "unicode": "253A",
        "fr": "T bas épais/épais/fin",
        "en": "Box drawings left heavy and horizontal up light"
      },
      {
        "char": "┻",
        "unicode": "253B",
        "fr": "T bas épais",
        "en": "Box drawings heavy up and horizontal"
      },
      {
        "char": "┼",
        "unicode": "253C",
        "fr": "Croix fin",
        "en": "Box drawings light vertical and horizontal"
      },
      {
        "char": "┽",
        "unicode": "253D",
        "fr": "Croix fin/épais",
        "en": "Box drawings vertical light and horizontal heavy"
      },
      {
        "char": "┾",
        "unicode": "253E",
        "fr": "Croix épais/fin",
        "en": "Box drawings vertical heavy and horizontal light"
      },
      {
        "char": "┿",
        "unicode": "253F",
        "fr": "Croix fin/fin/épais",
        "en": "Box drawings right light and horizontal vertical heavy"
      },
      {
        "char": "╀",
        "unicode": "2540",
        "fr": "Croix épais/fin/fin",
        "en": "Box drawings right heavy and horizontal vertical light"
      },
      {
        "char": "╁",
        "unicode": "2541",
        "fr": "Croix fin/épais/fin",
        "en": "Box drawings left light and horizontal vertical heavy"
      },
      {
        "char": "╂",
        "unicode": "2542",
        "fr": "Croix épais/épais/fin",
        "en": "Box drawings left heavy and horizontal vertical light"
      },
      {
        "char": "╃",
        "unicode": "2543",
        "fr": "Croix fin/fin/épais/épais",
        "en": "Box drawings up light and horizontal vertical down heavy"
      },
      {
        "char": "╄",
        "unicode": "2544",
        "fr": "Croix épais/fin/fin/épais",
        "en": "Box drawings up heavy and horizontal vertical down light"
      },
      {
        "char": "╅",
        "unicode": "2545",
        "fr": "Croix fin/épais/fin/épais",
        "en": "Box drawings down light and horizontal vertical up heavy"
      },
      {
        "char": "╆",
        "unicode": "2546",
        "fr": "Croix épais/épais/fin/épais",
        "en": "Box drawings down heavy and horizontal vertical up light"
      },
      {
        "char": "╇",
        "unicode": "2547",
        "fr": "Croix quadruple",
        "en": "Box drawings light horizontal and vertical"
      },
      {
        "char": "╈",
        "unicode": "2548",
        "fr": "Croix quadruple épais",
        "en": "Box drawings heavy horizontal and vertical"
      },
      {
        "char": "╉",
        "unicode": "2549",
        "fr": "Croix quadruple mixte",
        "en": "Box drawings light horizontal and heavy vertical"
      },
      {
        "char": "╊",
        "unicode": "254A",
        "fr": "Croix quadruple mixte",
        "en": "Box drawings heavy horizontal and light vertical"
      },
      {
        "char": "╋",
        "unicode": "254B",
        "fr": "Croix épaisse",
        "en": "Box drawings heavy vertical and horizontal"
      },
      {
        "char": "╌",
        "unicode": "254C",
        "fr": "Filet horizontal fin pointillé",
        "en": "Box drawings light left and right"
      },
      {
        "char": "╍",
        "unicode": "254D",
        "fr": "Filet horizontal épais pointillé",
        "en": "Box drawings heavy left and right"
      },
      {
        "char": "╎",
        "unicode": "254E",
        "fr": "Filet vertical fin pointillé",
        "en": "Box drawings light up and down"
      },
      {
        "char": "╏",
        "unicode": "254F",
        "fr": "Filet vertical épais pointillé",
        "en": "Box drawings heavy up and down"
      },
      {
        "char": "═",
        "unicode": "2550",
        "fr": "Filet horizontal double",
        "en": "Box drawings double horizontal"
      },
      {
        "char": "║",
        "unicode": "2551",
        "fr": "Filet vertical double",
        "en": "Box drawings double vertical"
      },
      {
        "char": "╒",
        "unicode": "2552",
        "fr": "Coin haut gauche double/fin",
        "en": "Box drawings down single and right double"
      },
      {
        "char": "╓",
        "unicode": "2553",
        "fr": "Coin haut gauche double/épais",
        "en": "Box drawings down double and right single"
      },
      {
        "char": "╔",
        "unicode": "2554",
        "fr": "Coin haut gauche double",
        "en": "Box drawings double down and right"
      },
      {
        "char": "╕",
        "unicode": "2555",
        "fr": "Coin haut droit double/fin",
        "en": "Box drawings down single and left double"
      },
      {
        "char": "╖",
        "unicode": "2556",
        "fr": "Coin haut droit double/épais",
        "en": "Box drawings down double and left single"
      },
      {
        "char": "╗",
        "unicode": "2557",
        "fr": "Coin haut droit double",
        "en": "Box drawings double down and left"
      },
      {
        "char": "╘",
        "unicode": "2558",
        "fr": "Coin bas gauche double/fin",
        "en": "Box drawings up single and right double"
      },
      {
        "char": "╙",
        "unicode": "2559",
        "fr": "Coin bas gauche double/épais",
        "en": "Box drawings up double and right single"
      },
      {
        "char": "╚",
        "unicode": "255A",
        "fr": "Coin bas gauche double",
        "en": "Box drawings double up and right"
      },
      {
        "char": "╛",
        "unicode": "255B",
        "fr": "Coin bas droit double/fin",
        "en": "Box drawings up single and left double"
      },
      {
        "char": "╜",
        "unicode": "255C",
        "fr": "Coin bas droit double/épais",
        "en": "Box drawings up double and left single"
      },
      {
        "char": "╝",
        "unicode": "255D",
        "fr": "Coin bas droit double",
        "en": "Box drawings double up and left"
      },
      {
        "char": "╞",
        "unicode": "255E",
        "fr": "T gauche double/fin",
        "en": "Box drawings vertical single and right double"
      },
      {
        "char": "╟",
        "unicode": "255F",
        "fr": "T gauche double/épais",
        "en": "Box drawings vertical double and right single"
      },
      {
        "char": "╠",
        "unicode": "2560",
        "fr": "T gauche double",
        "en": "Box drawings double vertical and right"
      },
      {
        "char": "╡",
        "unicode": "2561",
        "fr": "T droit double/fin",
        "en": "Box drawings vertical single and left double"
      },
      {
        "char": "╢",
        "unicode": "2562",
        "fr": "T droit double/épais",
        "en": "Box drawings vertical double and left single"
      },
      {
        "char": "╣",
        "unicode": "2563",
        "fr": "T droit double",
        "en": "Box drawings double vertical and left"
      },
      {
        "char": "╤",
        "unicode": "2564",
        "fr": "T haut double/fin",
        "en": "Box drawings down single and horizontal double"
      },
      {
        "char": "╥",
        "unicode": "2565",
        "fr": "T haut double/épais",
        "en": "Box drawings down double and horizontal single"
      },
      {
        "char": "╦",
        "unicode": "2566",
        "fr": "T haut double",
        "en": "Box drawings double down and horizontal"
      },
      {
        "char": "╧",
        "unicode": "2567",
        "fr": "T bas double/fin",
        "en": "Box drawings up single and horizontal double"
      },
      {
        "char": "╨",
        "unicode": "2568",
        "fr": "T bas double/épais",
        "en": "Box drawings up double and horizontal single"
      },
      {
        "char": "╩",
        "unicode": "2569",
        "fr": "T bas double",
        "en": "Box drawings double up and horizontal"
      },
      {
        "char": "╪",
        "unicode": "256A",
        "fr": "Croix double/fin",
        "en": "Box drawings vertical single and horizontal double"
      },
      {
        "char": "╫",
        "unicode": "256B",
        "fr": "Croix double/épais",
        "en": "Box drawings vertical double and horizontal single"
      },
      {
        "char": "╬",
        "unicode": "256C",
        "fr": "Croix double",
        "en": "Box drawings double vertical and horizontal"
      },
      {
        "char": "╭",
        "unicode": "256D",
        "fr": "Coin haut gauche arrondi",
        "en": "Box drawings light arc down and right"
      },
      {
        "char": "╮",
        "unicode": "256E",
        "fr": "Coin haut droit arrondi",
        "en": "Box drawings light arc down and left"
      },
      {
        "char": "╯",
        "unicode": "256F",
        "fr": "Coin bas droit arrondi",
        "en": "Box drawings light arc up and left"
      },
      {
        "char": "╰",
        "unicode": "2570",
        "fr": "Coin bas gauche arrondi",
        "en": "Box drawings light arc up and right"
      },
      {
        "char": "╱",
        "unicode": "2571",
        "fr": "Filet diagonale gauche",
        "en": "Box drawings light diagonal upper right to lower left"
      },
      {
        "char": "╲",
        "unicode": "2572",
        "fr": "Filet diagonale droite",
        "en": "Box drawings light diagonal upper left to lower right"
      },
      {
        "char": "╳",
        "unicode": "2573",
        "fr": "Croix diagonale",
        "en": "Box drawings light diagonal cross"
      },
      {
        "char": "╴",
        "unicode": "2574",
        "fr": "Filet horizontal fin à droite",
        "en": "Box drawings light left"
      },
      {
        "char": "╵",
        "unicode": "2575",
        "fr": "Filet vertical fin en bas",
        "en": "Box drawings light up"
      },
      {
        "char": "╶",
        "unicode": "2576",
        "fr": "Filet horizontal fin à gauche",
        "en": "Box drawings light right"
      },
      {
        "char": "╷",
        "unicode": "2577",
        "fr": "Filet vertical fin en haut",
        "en": "Box drawings light down"
      },
      {
        "char": "╸",
        "unicode": "2578",
        "fr": "Filet horizontal épais à droite",
        "en": "Box drawings heavy left"
      },
      {
        "char": "╹",
        "unicode": "2579",
        "fr": "Filet vertical épais en bas",
        "en": "Box drawings heavy up"
      },
      {
        "char": "╺",
        "unicode": "257A",
        "fr": "Filet horizontal épais à gauche",
        "en": "Box drawings heavy right"
      },
      {
        "char": "╻",
        "unicode": "257B",
        "fr": "Filet vertical épais en haut",
        "en": "Box drawings heavy down"
      },
      {
        "char": "╼",
        "unicode": "257C",
        "fr": "Filet horizontal fin/épais",
        "en": "Box drawings light left and heavy right"
      },
      {
        "char": "╽",
        "unicode": "257D",
        "fr": "Filet vertical fin/épais",
        "en": "Box drawings light up and heavy down"
      },
      {
        "char": "╾",
        "unicode": "257E",
        "fr": "Filet horizontal épais/fin",
        "en": "Box drawings heavy left and light right"
      },
      {
        "char": "╿",
        "unicode": "257F",
        "fr": "Filet vertical épais/fin",
        "en": "Box drawings heavy up and light down"
      }
    ]
  },
  {
    "name": "block-elements",
    "fr": "Éléments de bloc",
    "en": "Block Elements",
    "characters": [
      {
        "char": "▀",
        "unicode": "2580",
        "fr": "Demi-bloc supérieur",
        "en": "Upper half block"
      },
      {
        "char": "▁",
        "unicode": "2581",
        "fr": "Demi-bloc inférieur 1/8",
        "en": "Lower one eighth block"
      },
      {
        "char": "▂",
        "unicode": "2582",
        "fr": "Demi-bloc inférieur 2/8",
        "en": "Lower one quarter block"
      },
      {
        "char": "▃",
        "unicode": "2583",
        "fr": "Demi-bloc inférieur 3/8",
        "en": "Lower three eighths block"
      },
      {
        "char": "▄",
        "unicode": "2584",
        "fr": "Demi-bloc inférieur",
        "en": "Lower half block"
      },
      {
        "char": "▅",
        "unicode": "2585",
        "fr": "Demi-bloc inférieur 5/8",
        "en": "Lower five eighths block"
      },
      {
        "char": "▆",
        "unicode": "2586",
        "fr": "Demi-bloc inférieur 6/8",
        "en": "Lower three quarters block"
      },
      {
        "char": "▇",
        "unicode": "2587",
        "fr": "Demi-bloc inférieur 7/8",
        "en": "Lower seven eighths block"
      },
      {
        "char": "█",
        "unicode": "2588",
        "fr": "Bloc plein",
        "en": "Full block"
      },
      {
        "char": "▉",
        "unicode": "2589",
        "fr": "Bloc gauche 7/8",
        "en": "Left seven eighths block"
      },
      {
        "char": "▊",
        "unicode": "258A",
        "fr": "Bloc gauche 6/8",
        "en": "Left three quarters block"
      },
      {
        "char": "▋",
        "unicode": "258B",
        "fr": "Bloc gauche 5/8",
        "en": "Left five eighths block"
      },
      {
        "char": "▌",
        "unicode": "258C",
        "fr": "Bloc gauche",
        "en": "Left half block"
      },
      {
        "char": "▍",
        "unicode": "258D",
        "fr": "Bloc gauche 3/8",
        "en": "Left three eighths block"
      },
      {
        "char": "▎",
        "unicode": "258E",
        "fr": "Bloc gauche 2/8",
        "en": "Left one quarter block"
      },
      {
        "char": "▏",
        "unicode": "258F",
        "fr": "Bloc gauche 1/8",
        "en": "Left one eighth block"
      },
      {
        "char": "▐",
        "unicode": "2590",
        "fr": "Bloc droit",
        "en": "Right half block"
      },
      {
        "char": "░",
        "unicode": "2591",
        "fr": "Bloc ombré léger",
        "en": "Light shade"
      },
      {
        "char": "▒",
        "unicode": "2592",
        "fr": "Bloc ombré moyen",
        "en": "Medium shade"
      },
      {
        "char": "▓",
        "unicode": "2593",
        "fr": "Bloc ombré foncé",
        "en": "Dark shade"
      },
      {
        "char": "▔",
        "unicode": "2594",
        "fr": "Ligne supérieure",
        "en": "Upper one eighth block"
      },
      {
        "char": "▕",
        "unicode": "2595",
        "fr": "Ligne droite",
        "en": "Right one eighth block"
      },
      {
        "char": "▖",
        "unicode": "2596",
        "fr": "Quart de bloc bas gauche",
        "en": "Quadrant lower left"
      },
      {
        "char": "▗",
        "unicode": "2597",
        "fr": "Quart de bloc bas droit",
        "en": "Quadrant lower right"
      },
      {
        "char": "▘",
        "unicode": "2598",
        "fr": "Quart de bloc haut gauche",
        "en": "Quadrant upper left"
      },
      {
        "char": "▙",
        "unicode": "2599",
        "fr": "Trois quarts bloc gauche bas",
        "en": "Quadrant upper left and lower left and lower right"
      },
      {
        "char": "▚",
        "unicode": "259A",
        "fr": "Bloc diagonal",
        "en": "Quadrant upper left and lower right"
      },
      {
        "char": "▛",
        "unicode": "259B",
        "fr": "Trois quarts bloc haut gauche",
        "en": "Quadrant upper left and upper right and lower left"
      },
      {
        "char": "▜",
        "unicode": "259C",
        "fr": "Trois quarts bloc haut droit",
        "en": "Quadrant upper right and lower left and lower right"
      },
      {
        "char": "▝",
        "unicode": "259D",
        "fr": "Quart de bloc haut droit",
        "en": "Quadrant upper right"
      },
      {
        "char": "▞",
        "unicode": "259E",
        "fr": "Bloc diagonal inversé",
        "en": "Quadrant upper right and lower left"
      },
      {
        "char": "▟",
        "unicode": "259F",
        "fr": "Trois quarts bloc bas droit",
        "en": "Quadrant upper right and lower right and lower left"
      }
    ]
  },
  {
    "name": "geometric-shapes",
    "fr": "Formes géométriques",
    "en": "Geometric Shapes",
    "characters": [
      {
        "char": "■",
        "unicode": "25A0",
        "fr": "Carré plein",
        "en": "Black square"
      },
      {
        "char": "□",
        "unicode": "25A1",
        "fr": "Carré vide",
        "en": "White square"
      },
      {
        "char": "▢",
        "unicode": "25A2",
        "fr": "Carré vide arrondi",
        "en": "White square with rounded corners"
      },
      {
        "char": "▣",
        "unicode": "25A3",
        "fr": "Carré vide avec carré plein",
        "en": "White square containing black small square"
      },
      {
        "char": "▤",
        "unicode": "25A4",
        "fr": "Carré hachuré horizontal",
        "en": "Square with horizontal fill"
      },
      {
        "char": "▥",
        "unicode": "25A5",
        "fr": "Carré hachuré vertical",
        "en": "Square with vertical fill"
      },
      {
        "char": "▦",
        "unicode": "25A6",
        "fr": "Carré hachuré croisé",
        "en": "Square with orthogonal crosshatch fill"
      },
      {
        "char": "▧",
        "unicode": "25A7",
        "fr": "Carré hachuré diagonale descendante",
        "en": "Square with upper left to lower right fill"
      },
      {
        "char": "▨",
        "unicode": "25A8",
        "fr": "Carré hachuré diagonale montante",
        "en": "Square with upper right to lower left fill"
      },
      {
        "char": "▩",
        "unicode": "25A9",
        "fr": "Carré hachuré croisé diagonal",
        "en": "Square with diagonal crosshatch fill"
      },
      {
        "char": "▪",
        "unicode": "25AA",
        "fr": "Petit carré plein",
        "en": "Black small square"
      },
      {
        "char": "▫",
        "unicode": "25AB",
        "fr": "Petit carré vide",
        "en": "White small square"
      },
      {
        "char": "▬",
        "unicode": "25AC",
        "fr": "Rectangle plein",
        "en": "Black rectangle"
      },
      {
        "char": "▭",
        "unicode": "25AD",
        "fr": "Rectangle vide",
        "en": "White rectangle"
      },
      {
        "char": "▮",
        "unicode": "25AE",
        "fr": "Rectangle vertical plein",
        "en": "Black vertical rectangle"
      },
      {
        "char": "▯",
        "unicode": "25AF",
        "fr": "Rectangle vertical vide",
        "en": "White vertical rectangle"
      },
      {
        "char": "▰",
        "unicode": "25B0",
        "fr": "Grand carré plein",
        "en": "Black parallelogram"
      },
      {
        "char": "▱",
        "unicode": "25B1",
        "fr": "Grand carré vide",
        "en": "White parallelogram"
      },
      {
        "char": "▲",
        "unicode": "25B2",
        "fr": "Triangle haut plein",
        "en": "Black up-pointing triangle"
      },
      {
        "char": "△",
        "unicode": "25B3",
        "fr": "Triangle haut vide",
        "en": "White up-pointing triangle"
      },
      {
        "char": "▴",
        "unicode": "25B4",
        "fr": "Petit triangle haut plein",
        "en": "Black up-pointing small triangle"
      },
      {
        "char": "▵",
        "unicode": "25B5",
        "fr": "Petit triangle haut vide",
        "en": "White up-pointing small triangle"
      },
      {
        "char": "▶",
        "unicode": "25B6",
        "fr": "Triangle droit plein",
        "en": "Black right-pointing triangle"
      },
      {
        "char": "▷",
        "unicode": "25B7",
        "fr": "Triangle droit vide",
        "en": "White right-pointing triangle"
      },
      {
        "char": "▸",
        "unicode": "25B8",
        "fr": "Petit triangle droit plein",
        "en": "Black right-pointing small triangle"
      },
      {
        "char": "▹",
        "unicode": "25B9",
        "fr": "Petit triangle droit vide",
        "en": "White right-pointing small triangle"
      },
      {
        "char": "►",
        "unicode": "25BA",
        "fr": "Triangle droit plein",
        "en": "Black right-pointing pointer"
      },
      {
        "char": "▻",
        "unicode": "25BB",
        "fr": "Triangle droit vide",
        "en": "White right-pointing pointer"
      },
      {
        "char": "▼",
        "unicode": "25BC",
        "fr": "Triangle bas plein",
        "en": "Black down-pointing triangle"
      },
      {
        "char": "▽",
        "unicode": "25BD",
        "fr": "Triangle bas vide",
        "en": "White down-pointing triangle"
      },
      {
        "char": "▾",
        "unicode": "25BE",
        "fr": "Petit triangle bas plein",
        "en": "Black down-pointing small triangle"
      },
      {
        "char": "▿",
        "unicode": "25BF",
        "fr": "Petit triangle bas vide",
        "en": "White down-pointing small triangle"
      },
      {
        "char": "◀",
        "unicode": "25C0",
        "fr": "Triangle gauche plein",
        "en": "Black left-pointing triangle"
      },
      {
        "char": "◁",
        "unicode": "25C1",
        "fr": "Triangle gauche vide",
        "en": "White left-pointing triangle"
      },
      {
        "char": "◂",
        "unicode": "25C2",
        "fr": "Petit triangle gauche plein",
        "en": "Black left-pointing small triangle"
      },
      {
        "char": "◃",
        "unicode": "25C3",
        "fr": "Petit triangle gauche vide",
        "en": "White left-pointing small triangle"
      },
      {
        "char": "◄",
        "unicode": "25C4",
        "fr": "Triangle gauche plein",
        "en": "Black left-pointing pointer"
      },
      {
        "char": "◅",
        "unicode": "25C5",
        "fr": "Triangle gauche vide",
        "en": "White left-pointing pointer"
      },
      {
        "char": "◆",
        "unicode": "25C6",
        "fr": "Losange plein",
        "en": "Black diamond"
      },
      {
        "char": "◇",
        "unicode": "25C7",
        "fr": "Losange vide",
        "en": "White diamond"
      },
      {
        "char": "◈",
        "unicode": "25C8",
        "fr": "Losange vide avec losange plein",
        "en": "White diamond containing black small diamond"
      },
      { "char": "◉", "unicode": "25C9", "fr": "Cercle cible", "en": "Fisheye" },
      {
        "char": "◊",
        "unicode": "25CA",
        "fr": "Losange vertical",
        "en": "Lozenge"
      },
      {
        "char": "○",
        "unicode": "25CB",
        "fr": "Cercle vide",
        "en": "White circle"
      },
      {
        "char": "◌",
        "unicode": "25CC",
        "fr": "Cercle pointillé",
        "en": "Dotted circle"
      },
      {
        "char": "◍",
        "unicode": "25CD",
        "fr": "Cercle cible",
        "en": "Circle with vertical fill"
      },
      {
        "char": "◎",
        "unicode": "25CE",
        "fr": "Cercle double",
        "en": "Bullseye"
      },
      {
        "char": "●",
        "unicode": "25CF",
        "fr": "Cercle plein",
        "en": "Black circle"
      },
      {
        "char": "◐",
        "unicode": "25D0",
        "fr": "Cercle demi-gauche",
        "en": "Circle with left half black"
      },
      {
        "char": "◑",
        "unicode": "25D1",
        "fr": "Cercle demi-droit",
        "en": "Circle with right half black"
      },
      {
        "char": "◒",
        "unicode": "25D2",
        "fr": "Cercle demi-bas",
        "en": "Circle with lower half black"
      },
      {
        "char": "◓",
        "unicode": "25D3",
        "fr": "Cercle demi-haut",
        "en": "Circle with upper half black"
      },
      {
        "char": "◔",
        "unicode": "25D4",
        "fr": "Cercle quart haut gauche",
        "en": "Circle with upper left quadrant black"
      },
      {
        "char": "◕",
        "unicode": "25D5",
        "fr": "Cercle quart bas droit",
        "en": "Circle with all but upper left quadrant black"
      },
      {
        "char": "◖",
        "unicode": "25D6",
        "fr": "Demi-cercle gauche",
        "en": "Left half black circle"
      },
      {
        "char": "◗",
        "unicode": "25D7",
        "fr": "Demi-cercle droit",
        "en": "Right half black circle"
      },
      {
        "char": "◘",
        "unicode": "25D8",
        "fr": "Cercle noir avec point",
        "en": "Inverse bullet"
      },
      {
        "char": "◙",
        "unicode": "25D9",
        "fr": "Cercle noir avec cercle blanc",
        "en": "Inverse white circle"
      },
      {
        "char": "◚",
        "unicode": "25DA",
        "fr": "Cercle demi-haut gauche",
        "en": "Upper half inverse white circle"
      },
      {
        "char": "◛",
        "unicode": "25DB",
        "fr": "Cercle demi-bas gauche",
        "en": "Lower half inverse white circle"
      },
      {
        "char": "◜",
        "unicode": "25DC",
        "fr": "Quart de cercle haut gauche",
        "en": "Upper left quadrant circular arc"
      },
      {
        "char": "◝",
        "unicode": "25DD",
        "fr": "Quart de cercle haut droit",
        "en": "Upper right quadrant circular arc"
      },
      {
        "char": "◞",
        "unicode": "25DE",
        "fr": "Quart de cercle bas droit",
        "en": "Lower right quadrant circular arc"
      },
      {
        "char": "◟",
        "unicode": "25DF",
        "fr": "Quart de cercle bas gauche",
        "en": "Lower left quadrant circular arc"
      },
      {
        "char": "◠",
        "unicode": "25E0",
        "fr": "Arc de cercle haut",
        "en": "Upper half circle"
      },
      {
        "char": "◡",
        "unicode": "25E1",
        "fr": "Arc de cercle bas",
        "en": "Lower half circle"
      },
      {
        "char": "◢",
        "unicode": "25E2",
        "fr": "Triangle bas gauche plein",
        "en": "Black lower right triangle"
      },
      {
        "char": "◣",
        "unicode": "25E3",
        "fr": "Triangle bas droit plein",
        "en": "Black lower left triangle"
      },
      {
        "char": "◤",
        "unicode": "25E4",
        "fr": "Triangle haut gauche plein",
        "en": "Black upper left triangle"
      },
      {
        "char": "◥",
        "unicode": "25E5",
        "fr": "Triangle haut droit plein",
        "en": "Black upper right triangle"
      },
      {
        "char": "◦",
        "unicode": "25E6",
        "fr": "Petit cercle vide",
        "en": "White bullet"
      },
      {
        "char": "◧",
        "unicode": "25E7",
        "fr": "Carré demi-gauche",
        "en": "Square with left half black"
      },
      {
        "char": "◨",
        "unicode": "25E8",
        "fr": "Carré demi-droit",
        "en": "Square with right half black"
      },
      {
        "char": "◩",
        "unicode": "25E9",
        "fr": "Carré demi-haut",
        "en": "Square with upper half black"
      },
      {
        "char": "◪",
        "unicode": "25EA",
        "fr": "Carré demi-bas",
        "en": "Square with lower half black"
      },
      {
        "char": "◫",
        "unicode": "25EB",
        "fr": "Carré vide avec croix",
        "en": "White square with bisected cross"
      },
      {
        "char": "◬",
        "unicode": "25EC",
        "fr": "Triangle haut vide",
        "en": "White up-pointing triangle with dot"
      },
      {
        "char": "◭",
        "unicode": "25ED",
        "fr": "Triangle droit vide",
        "en": "Up-pointing triangle with left half black"
      },
      {
        "char": "◮",
        "unicode": "25EE",
        "fr": "Triangle gauche vide",
        "en": "Up-pointing triangle with right half black"
      },
      {
        "char": "◯",
        "unicode": "25EF",
        "fr": "Grand cercle vide",
        "en": "Large circle"
      }
    ]
  },
  {
    "name": "miscellaneous-symbols",
    "fr": "Symboles divers",
    "en": "Miscellaneous Symbols",
    "characters": [
      {
        "char": "☀",
        "unicode": "2600",
        "fr": "Soleil",
        "en": "Black sun with rays"
      },
      { "char": "☁", "unicode": "2601", "fr": "Nuage", "en": "Cloud" },
      { "char": "☂", "unicode": "2602", "fr": "Parapluie", "en": "Umbrella" },
      {
        "char": "☃",
        "unicode": "2603",
        "fr": "Bonhomme de neige",
        "en": "Snowman"
      },
      { "char": "☄", "unicode": "2604", "fr": "Comète", "en": "Comet" },
      {
        "char": "★",
        "unicode": "2605",
        "fr": "Étoile pleine",
        "en": "Black star"
      },
      {
        "char": "☆",
        "unicode": "2606",
        "fr": "Étoile vide",
        "en": "White star"
      },
      { "char": "☇", "unicode": "2607", "fr": "Éclair", "en": "Lightning" },
      {
        "char": "☈",
        "unicode": "2608",
        "fr": "Tonnerre",
        "en": "Thunderstorm"
      },
      {
        "char": "☉",
        "unicode": "2609",
        "fr": "Soleil (astronomie)",
        "en": "Sun"
      },
      {
        "char": "☊",
        "unicode": "260A",
        "fr": "Noeud ascendant",
        "en": "Ascending node"
      },
      {
        "char": "☋",
        "unicode": "260B",
        "fr": "Noeud descendant",
        "en": "Descending node"
      },
      {
        "char": "☌",
        "unicode": "260C",
        "fr": "Conjonction",
        "en": "Conjunction"
      },
      {
        "char": "☍",
        "unicode": "260D",
        "fr": "Opposition",
        "en": "Opposition"
      },
      {
        "char": "☎",
        "unicode": "260E",
        "fr": "Téléphone",
        "en": "Black telephone"
      },
      {
        "char": "☏",
        "unicode": "260F",
        "fr": "Téléphone blanc",
        "en": "White telephone"
      },
      { "char": "☐", "unicode": "2610", "fr": "Case vide", "en": "Ballot box" },
      {
        "char": "☑",
        "unicode": "2611",
        "fr": "Case cochée",
        "en": "Ballot box with check"
      },
      {
        "char": "☒",
        "unicode": "2612",
        "fr": "Case barrée",
        "en": "Ballot box with X"
      },
      { "char": "☓", "unicode": "2613", "fr": "Croix", "en": "Saltire" },
      {
        "char": "☕",
        "unicode": "2615",
        "fr": "Tasse de café",
        "en": "Hot beverage"
      },
      {
        "char": "☖",
        "unicode": "2616",
        "fr": "Marque noire",
        "en": "White shogi piece"
      },
      {
        "char": "☗",
        "unicode": "2617",
        "fr": "Marque blanche",
        "en": "Black shogi piece"
      },
      { "char": "☘", "unicode": "2618", "fr": "Trèfle", "en": "Shamrock" },
      {
        "char": "☙",
        "unicode": "2619",
        "fr": "Feuille",
        "en": "Reversed rotated floral heart bullet"
      },
      {
        "char": "☚",
        "unicode": "261A",
        "fr": "Main gauche",
        "en": "White left pointing index"
      },
      {
        "char": "☛",
        "unicode": "261B",
        "fr": "Main droite",
        "en": "White right pointing index"
      },
      {
        "char": "☜",
        "unicode": "261C",
        "fr": "Main gauche noire",
        "en": "Black left pointing index"
      },
      {
        "char": "☝",
        "unicode": "261D",
        "fr": "Main haut",
        "en": "White up pointing index"
      },
      {
        "char": "☞",
        "unicode": "261E",
        "fr": "Main droite noire",
        "en": "Black right pointing index"
      },
      {
        "char": "☟",
        "unicode": "261F",
        "fr": "Main bas",
        "en": "White down pointing index"
      },
      {
        "char": "☠",
        "unicode": "2620",
        "fr": "Tête de mort",
        "en": "Skull and crossbones"
      },
      { "char": "☡", "unicode": "2621", "fr": "Danger", "en": "Caution sign" },
      {
        "char": "☢",
        "unicode": "2622",
        "fr": "Radioactivité",
        "en": "Radioactive sign"
      },
      {
        "char": "☣",
        "unicode": "2623",
        "fr": "Biohazard",
        "en": "Biohazard sign"
      },
      { "char": "☤", "unicode": "2624", "fr": "Caducée", "en": "Caduceus" },
      { "char": "☥", "unicode": "2625", "fr": "Croix ansée", "en": "Ankh" },
      {
        "char": "☦",
        "unicode": "2626",
        "fr": "Croix orthodoxe",
        "en": "Orthodox cross"
      },
      { "char": "☧", "unicode": "2627", "fr": "Chrisme", "en": "Chi rho" },
      {
        "char": "☨",
        "unicode": "2628",
        "fr": "Croix de Lorraine",
        "en": "Cross of Lorraine"
      },
      {
        "char": "☩",
        "unicode": "2629",
        "fr": "Croix de Jérusalem",
        "en": "Cross of Jerusalem"
      },
      {
        "char": "☪",
        "unicode": "262A",
        "fr": "Croissant et étoile",
        "en": "Star and crescent"
      },
      {
        "char": "☫",
        "unicode": "262B",
        "fr": "Croix persane",
        "en": "Farsi symbol"
      },
      { "char": "☬", "unicode": "262C", "fr": "Khanda", "en": "Adi shakti" },
      {
        "char": "☭",
        "unicode": "262D",
        "fr": "Faucille et marteau",
        "en": "Hammer and sickle"
      },
      { "char": "☮", "unicode": "262E", "fr": "Paix", "en": "Peace symbol" },
      { "char": "☯", "unicode": "262F", "fr": "Yin yang", "en": "Yin yang" },
      {
        "char": "☸",
        "unicode": "2638",
        "fr": "Roue du Dharma",
        "en": "Wheel of Dharma"
      },
      {
        "char": "☹",
        "unicode": "2639",
        "fr": "Visage triste",
        "en": "White frowning face"
      },
      {
        "char": "☺",
        "unicode": "263A",
        "fr": "Visage souriant",
        "en": "White smiling face"
      },
      {
        "char": "☻",
        "unicode": "263B",
        "fr": "Visage souriant noir",
        "en": "Black smiling face"
      },
      {
        "char": "☼",
        "unicode": "263C",
        "fr": "Soleil blanc",
        "en": "White sun with rays"
      },
      {
        "char": "☽",
        "unicode": "263D",
        "fr": "Lune croissante",
        "en": "First quarter moon"
      },
      {
        "char": "☾",
        "unicode": "263E",
        "fr": "Lune décroissante",
        "en": "Last quarter moon"
      },
      { "char": "☿", "unicode": "263F", "fr": "Mercure", "en": "Mercury" },
      { "char": "♀", "unicode": "2640", "fr": "Femme", "en": "Female sign" },
      { "char": "♂", "unicode": "2642", "fr": "Homme", "en": "Male sign" },
      { "char": "♁", "unicode": "2641", "fr": "Terre", "en": "Earth" },
      { "char": "♃", "unicode": "2643", "fr": "Jupiter", "en": "Jupiter" },
      { "char": "♄", "unicode": "2644", "fr": "Saturne", "en": "Saturn" },
      { "char": "♅", "unicode": "2645", "fr": "Uranus", "en": "Uranus" },
      { "char": "♆", "unicode": "2646", "fr": "Neptune", "en": "Neptune" },
      { "char": "♇", "unicode": "2647", "fr": "Pluton", "en": "Pluto" },
      { "char": "♈", "unicode": "2648", "fr": "Bélier", "en": "Aries" },
      { "char": "♉", "unicode": "2649", "fr": "Taureau", "en": "Taurus" },
      { "char": "♊", "unicode": "264A", "fr": "Gémeaux", "en": "Gemini" },
      { "char": "♋", "unicode": "264B", "fr": "Cancer", "en": "Cancer" },
      { "char": "♌", "unicode": "264C", "fr": "Lion", "en": "Leo" },
      { "char": "♍", "unicode": "264D", "fr": "Vierge", "en": "Virgo" },
      { "char": "♎", "unicode": "264E", "fr": "Balance", "en": "Libra" },
      { "char": "♏", "unicode": "264F", "fr": "Scorpion", "en": "Scorpius" },
      {
        "char": "♐",
        "unicode": "2650",
        "fr": "Sagittaire",
        "en": "Sagittarius"
      },
      {
        "char": "♑",
        "unicode": "2651",
        "fr": "Capricorne",
        "en": "Capricorn"
      },
      { "char": "♒", "unicode": "2652", "fr": "Verseau", "en": "Aquarius" },
      { "char": "♓", "unicode": "2653", "fr": "Poissons", "en": "Pisces" },
      {
        "char": "♔",
        "unicode": "2654",
        "fr": "Roi blanc",
        "en": "White chess king"
      },
      {
        "char": "♕",
        "unicode": "2655",
        "fr": "Reine blanche",
        "en": "White chess queen"
      },
      {
        "char": "♖",
        "unicode": "2656",
        "fr": "Tour blanche",
        "en": "White chess rook"
      },
      {
        "char": "♗",
        "unicode": "2657",
        "fr": "Fou blanc",
        "en": "White chess bishop"
      },
      {
        "char": "♘",
        "unicode": "2658",
        "fr": "Cavalier blanc",
        "en": "White chess knight"
      },
      {
        "char": "♙",
        "unicode": "2659",
        "fr": "Pion blanc",
        "en": "White chess pawn"
      },
      {
        "char": "♚",
        "unicode": "265A",
        "fr": "Roi noir",
        "en": "Black chess king"
      },
      {
        "char": "♛",
        "unicode": "265B",
        "fr": "Reine noire",
        "en": "Black chess queen"
      },
      {
        "char": "♜",
        "unicode": "265C",
        "fr": "Tour noire",
        "en": "Black chess rook"
      },
      {
        "char": "♝",
        "unicode": "265D",
        "fr": "Fou noir",
        "en": "Black chess bishop"
      },
      {
        "char": "♞",
        "unicode": "265E",
        "fr": "Cavalier noir",
        "en": "Black chess knight"
      },
      {
        "char": "♟",
        "unicode": "265F",
        "fr": "Pion noir",
        "en": "Black chess pawn"
      },
      {
        "char": "♠",
        "unicode": "2660",
        "fr": "Pique",
        "en": "Black spade suit"
      },
      {
        "char": "♡",
        "unicode": "2661",
        "fr": "Cœur vide",
        "en": "White heart suit"
      },
      {
        "char": "♢",
        "unicode": "2662",
        "fr": "Carreau vide",
        "en": "White diamond suit"
      },
      {
        "char": "♣",
        "unicode": "2663",
        "fr": "Trèfle",
        "en": "Black club suit"
      },
      {
        "char": "♤",
        "unicode": "2664",
        "fr": "Pique vide",
        "en": "White spade suit"
      },
      {
        "char": "♥",
        "unicode": "2665",
        "fr": "Cœur",
        "en": "Black heart suit"
      },
      {
        "char": "♦",
        "unicode": "2666",
        "fr": "Carreau",
        "en": "Black diamond suit"
      },
      {
        "char": "♧",
        "unicode": "2667",
        "fr": "Trèfle vide",
        "en": "White club suit"
      },
      {
        "char": "♨",
        "unicode": "2668",
        "fr": "Source chaude",
        "en": "Hot springs"
      },
      {
        "char": "♩",
        "unicode": "2669",
        "fr": "Note de musique",
        "en": "Quarter note"
      },
      {
        "char": "♪",
        "unicode": "266A",
        "fr": "Double note",
        "en": "Eighth note"
      },
      {
        "char": "♫",
        "unicode": "266B",
        "fr": "Triple note",
        "en": "Beamed eighth notes"
      },
      {
        "char": "♬",
        "unicode": "266C",
        "fr": "Quadruple note",
        "en": "Beamed sixteenth notes"
      },
      {
        "char": "♭",
        "unicode": "266D",
        "fr": "Bémol",
        "en": "Music flat sign"
      },
      {
        "char": "♮",
        "unicode": "266E",
        "fr": "Bécarre",
        "en": "Music natural sign"
      },
      {
        "char": "♯",
        "unicode": "266F",
        "fr": "Dièse",
        "en": "Music sharp sign"
      }
    ]
  }
]

export function characters_getList() {
  return characterTable;
}